/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/*eslint semi: ["error", "never"], strict: 0*/
	'use strict'; //needed if running in node without transcode
	
	var pluralize = __webpack_require__(20);
	var please = __webpack_require__(19);
	
	var randomInArray = function randomInArray(arr) {
	  return arr[Math.floor(Math.random() * arr.length)];
	};
	var uniq = function uniq(arr) {
	  return arr.filter(function (value, i, self) {
	    return self.indexOf(value) === i;
	  });
	};
	
	var maybe = function maybe(word, weight) {
	  return Math.random() < weight ? word : '';
	};
	
	var upper = function upper(str) {
	  return str[0].toUpperCase() + str.slice(1);
	};
	var upperAll = function upperAll(str) {
	  return str.trim().split(' ').map(upper).join(' ').split('-').map(upper).join('-');
	};
	
	var makeWeightedGetter = function makeWeightedGetter(weights) {
	  var totalWeight = weights.reduce(function (p, c) {
	    return p + c[1];
	  }, 0);
	
	  var lastWeight = 0;
	  for (var i = 0; i < weights.length; i++) {
	    var w = weights[i];
	    w[1] = w[1] / totalWeight + lastWeight;
	    lastWeight = w[1];
	  }
	
	  //Set the final weight to exactly one
	  weights[weights.length - 1][1] = 1;
	
	  return function () {
	    var rr = Math.random();
	    for (var _i = 0; _i < weights.length; _i++) {
	      var _w = weights[_i];
	      if (rr < _w[1]) {
	        return _w[0];
	      }
	    }
	    throw new Error('We goofed!');
	  };
	};
	
	var englishTowns = __webpack_require__(5);
	englishTowns = englishTowns.towns.concat(englishTowns.cities);
	
	var usa = __webpack_require__(8);
	
	var customCorpora = {
	  religionDescriptors: ["Anabaptist", "Anglican", "Baptist", "Calvinist", "Lutheran", "Methodist", "Moravian", "Nonconformist", "Pentecostal", "Presbyterian", "Quaker", "Shaker", "Russian Orthodox", "Jewish"],
	  religionNouns: ["Anabaptist", "Anglican", "Baptist", "Calvinist", "Lutheran", "Methodist", "Moravian", "Nonconformist", "Pentecostal", "Presbyterian", "Quaker", "Shaker", "Jew"]
	};
	
	var corpora = {
	  // adv: require('./corpora/data/words/adverbs').adverbs,
	  adjectives: __webpack_require__(15).adjs,
	  colors: __webpack_require__(3).colors.map(function (c) {
	    return c.color.split(/(?=[A-Z])/).join(' ');
	  }) //transform from CamelCase to spaced
	  .filter(function (c) {
	    return c.split(' ').length < 3;
	  }), //colour names shorter than three words
	  englishTowns: englishTowns,
	  metals: __webpack_require__(10).metals,
	  pastVerbs: __webpack_require__(17).verbs.map(function (v) {
	    return v.past;
	  }),
	  religionDescriptors: customCorpora.religionDescriptors,
	  seas: __webpack_require__(7).seas.map(function (s) {
	    return s.name;
	  }).filter(function (s) {
	    return s.split(' ').length < 3;
	  }),
	  stations: __webpack_require__(6).stations.map(function (s) {
	    return s.name;
	  }),
	  usCities: usa.cities.map(function (c) {
	    return c.city;
	  }),
	  usStates: uniq(usa.cities.map(function (c) {
	    return c.state;
	  })),
	
	  animals: __webpack_require__(1).animals,
	  appliances: __webpack_require__(14).appliances,
	  flowers: __webpack_require__(13).flowers,
	  monsters: __webpack_require__(11).names,
	  nouns: __webpack_require__(16).nouns,
	  objects: __webpack_require__(12).objects.filter(function (o) {
	    return o.split(' ').length < 3;
	  }),
	  occupations: __webpack_require__(9).occupations.filter(function (o) {
	    return o.split(' ').length < 3;
	  }),
	  religionNouns: customCorpora.religionNouns,
	  rooms: __webpack_require__(2).rooms,
	  vegetables: __webpack_require__(4).vegetables
	};
	
	for (var c in corpora) {
	  //eslint-disable-line guard-for-in
	  // console.log(c + ' ' + corpora[c].length)
	  corpora[c] = corpora[c].map(upperAll);
	}
	
	var getArticle = makeWeightedGetter([['The', 1], ['Los', 0.03], ['Les', 0.005]]);
	
	var getDescriptor = makeWeightedGetter([[corpora.adjectives, 1.3], [corpora.colors, 0.8], [corpora.englishTowns, 0.6], [corpora.metals, 0.2], [corpora.pastVerbs, 0.7], [corpora.religionDescriptors, 0.5], [corpora.seas, 0.6], [corpora.stations, 0.7], [corpora.usCities, 0.9], [corpora.usStates, 0.9]]);
	
	var getName = makeWeightedGetter([[corpora.animals, 1], [corpora.appliances, 0.1], [corpora.flowers, 0.2], [corpora.monsters, 1.1], [corpora.nouns, 0.7], [corpora.objects, 0.6], [corpora.occupations, 1.2], [corpora.religionNouns, 0.2], [corpora.rooms, 0.1], [corpora.vegetables, 0.3]]);
	
	var getPlaceType = makeWeightedGetter([['Street', 1.3], ['Lane', 0.7], ['Alley', 1], ['Drive', 0.6], ['City', 0.5]]);
	
	var getGangType = makeWeightedGetter([['Gang', 1.2], ['Club', 0.5], ['Society', 0.7], ['Mafia', 0.3], ['Boys', 1.4], ['Girls', 0.3], ['Lads', 0.5], ['Lords', 0.6], ['Ladies', 0.2], ['Lasses', 0.2], ['Kids', 0.7], ['Tribe', 0.7]]);
	
	var gangName = function gangName() {
	  var descriptor = maybe(randomInArray(getDescriptor()), 0.8);
	
	  var name = maybe(randomInArray(getName()), descriptor.length > 0 ? 0.9 : 1);
	
	  var placeTypeBeforeDescriptor = Math.random() > 0.97;
	  var placeTypeExtraDescriptorChance = 0;
	  if (placeTypeBeforeDescriptor) {
	    placeTypeExtraDescriptorChance = 1;
	  } else if (descriptor.length > 0) {
	    placeTypeExtraDescriptorChance = 0.03;
	  } else {
	    placeTypeExtraDescriptorChance = 0.98;
	  }
	
	  var placeType = maybe(maybe(randomInArray([randomInArray(getDescriptor()), randomInArray(getName())]) + ' ', placeTypeExtraDescriptorChance) + getPlaceType(), descriptor.length > 0 ? 0.18 : 0.64);
	
	  var gangType = maybe(getGangType(), name.length > 0 ? 0.65 : 0.89);
	
	  if (gangType.length === 0 && name.length > 0) {
	    name = pluralize(name);
	  }
	
	  var article = maybe(getArticle(), descriptor.length > 0 && name.length > 0 ? 0.9 : 0.96);
	
	  var finalName = [article, placeTypeBeforeDescriptor ? placeType + ' ' + descriptor : descriptor + ' ' + placeType, name + ' ' + gangType];
	
	  return finalName.map(function (n) {
	    return n.trim();
	  });
	};
	
	if (typeof window === 'undefined') {
	  console.log(gangName().join(' '));
	} else {
	  __webpack_require__(18)(function () {
	    //Create stylesheet for changing colour
	    var s = document.createElement("style");
	    document.head.appendChild(s);
	    var gradientStyles = s.sheet;
	    gradientStyles.insertRule('dummy { }', 0);
	
	    //Undo history
	    var history = [];
	
	    //Elements for text replacement
	    var xs = document.querySelector('.victory .xs');
	    var sm = document.querySelector('.victory .sm');
	    var lg = document.querySelector('.victory .lg');
	
	    var name = [];
	    var col = '';
	
	    function newName() {
	      history.push({ name: name, col: col });
	
	      name = gangName();
	
	      //Use the bigger font size if words are missing
	      if (name[2].length === 0) {
	        name[2] = name[1];
	        name[1] = name[0];
	        name[0] = '';
	      }
	      if (name[1].length === 0) {
	        name[1] = name[0];
	        name[0] = '';
	      }
	
	      //If the descriptor is long, make sure it wraps
	      sm.style.whiteSpace = name[1].split(' ').length > 2 && name[1].length > 14 || name[1].length > 24 ? 'normal' : 'nowrap';
	
	      //Set text
	      xs.innerHTML = name[0];
	      sm.innerHTML = name[1];
	      lg.innerHTML = name[2];
	
	      //Set new colour
	      col = please.make_color({ saturation: 1 });
	      setColor(col);
	    }
	
	    function undo() {
	      if (history.length <= 1) {
	        return;
	      }
	
	      var h = history.pop();
	      name = h.name;
	
	      sm.style.whiteSpace = name[1].split(' ').length > 2 && name[1].length > 14 || name[1].length > 24 ? 'normal' : 'nowrap';
	
	      xs.innerHTML = name[0];
	      sm.innerHTML = name[1];
	      lg.innerHTML = name[2];
	
	      col = h.col;
	      setColor(col);
	    }
	
	    function setColor(color) {
	      gradientStyles.deleteRule(0);
	      gradientStyles.insertRule('.fancy.cssgradients.backgroundblendmode .victory::before { background: linear-gradient(' + color + ' 40%,  #F9F9F7 80%); }', 0);
	    }
	
	    var b = document.querySelector('#another');
	    b.onclick = function (e) {
	      e.preventDefault();newName();
	    };
	
	    var u = document.querySelector('#undo');
	    u.onclick = function (e) {
	      e.preventDefault();undo();
	    };
	
	    var p = document.querySelector('#plain');
	    var htmlEl = document.querySelector('html').classList;
	    p.onclick = function (e) {
	      e.preventDefault();htmlEl.toggle('fancy');
	    };
	
	    newName();
	  });
	}

/***/ },
/* 1 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
		"animals": ["aardvark", "alligator", "alpaca", "antelope", "ape", "armadillo", "baboon", "badger", "bat", "bear", "beaver", "bison", "boar", "buffalo", "bull", "camel", "canary", "capybara", "cat", "chameleon", "cheetah", "chimpanzee", "chinchilla", "chipmunk", "cougar", "cow", "coyote", "crocodile", "crow", "deer", "dingo", "dog", "donkey", "dromedary", "elephant", "elk", "ewe", "ferret", "finch", "fish", "fox", "frog", "gazelle", "gila monster", "giraffe", "gnu", "goat", "gopher", "gorilla", "grizzly bear", "ground hog", "guinea pig", "hamster", "hedgehog", "hippopotamus", "hog", "horse", "hyena", "ibex", "iguana", "impala", "jackal", "jaguar", "kangaroo", "koala", "lamb", "lemur", "leopard", "lion", "lizard", "llama", "lynx", "mandrill", "marmoset", "mink", "mole", "mongoose", "monkey", "moose", "mountain goat", "mouse", "mule", "muskrat", "mustang", "mynah bird", "newt", "ocelot", "opossum", "orangutan", "oryx", "otter", "ox", "panda", "panther", "parakeet", "parrot", "pig", "platypus", "polar bear", "porcupine", "porpoise", "prairie dog", "puma", "rabbit", "raccoon", "ram", "rat", "reindeer", "reptile", "rhinoceros", "salamander", "seal", "sheep", "shrew", "silver fox", "skunk", "sloth", "snake", "squirrel", "tapir", "tiger", "toad", "turtle", "walrus", "warthog", "weasel", "whale", "wildcat", "wolf", "wolverine", "wombat", "woodchuck", "yak", "zebra"]
	};

/***/ },
/* 2 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
		"description": "Different kinds of rooms",
		"rooms": ["aerary", "aircraft cabin", "airport lounge", "alcove", "anatomical theatre", "anechoic chamber", "antechamber", "anteroom", "armory", "assembly room", "atelier", "attic", "auditorium", "backroom", "ballroom", "basement", "bathroom", "bedroom", "billiard room", "boardroom", "boiler room", "boudoir", "breakfast nook", "breezeway", "cabin", "cafeteria", "caldarium", "cellar", "changing room", "chapel", "classroom", "clean room", "cloakroom", "closet", "cold room", "common room", "computer lab", "conference room", "conservatory", "control room", "conversation pit", "corner office", "courtroom", "cry room", "darkroom", "den", "dining room", "dormitory", "drawing room", "dressing room", "electrical room", "emergency room", "engine room", "equipment room", "fallout shelter", "family room", "fitting room", "foyer", "game room", "garage", "guest room", "gym", "hotel room", "kitchen", "laundry room", "library", "living room", "lobby", "locker room", "loft", "lounge", "mailroom", "map room", "motel room", "mud room", "newsroom", "nursery", "office", "panic room", "pantry", "parlor", "playroom", "pool room", "print room", "rec room", "salon", "sauna", "schoolroom", "showroom", "sitting room", "staff room", "stockroom", "storm cellar", "studio", "study", "sunroom", "tearoom", "throne room", "transmission control room", "tv room", "utility room", "waiting room", "washroom", "water closet", "weight room", "wine cellar", "wiring closet", "workshop"]
	};

/***/ },
/* 3 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
		"description": "List of named HTML colors",
		"colors": [{
			"color": "AliceBlue",
			"hex": "#F0F8FF"
		}, {
			"color": "AntiqueWhite",
			"hex": "#FAEBD7"
		}, {
			"color": "Aqua",
			"hex": "#00FFFF"
		}, {
			"color": "Aquamarine",
			"hex": "#7FFFD4"
		}, {
			"color": "Azure",
			"hex": "#F0FFFF"
		}, {
			"color": "Beige",
			"hex": "#F5F5DC"
		}, {
			"color": "Bisque",
			"hex": "#FFE4C4"
		}, {
			"color": "Black",
			"hex": "#000000"
		}, {
			"color": "BlanchedAlmond",
			"hex": "#FFEBCD"
		}, {
			"color": "Blue",
			"hex": "#0000FF"
		}, {
			"color": "BlueViolet",
			"hex": "#8A2BE2"
		}, {
			"color": "Brown",
			"hex": "#A52A2A"
		}, {
			"color": "BurlyWood",
			"hex": "#DEB887"
		}, {
			"color": "CadetBlue",
			"hex": "#5F9EA0"
		}, {
			"color": "Chartreuse",
			"hex": "#7FFF00"
		}, {
			"color": "Chocolate",
			"hex": "#D2691E"
		}, {
			"color": "Coral",
			"hex": "#FF7F50"
		}, {
			"color": "CornflowerBlue",
			"hex": "#6495ED"
		}, {
			"color": "Cornsilk",
			"hex": "#FFF8DC"
		}, {
			"color": "Crimson",
			"hex": "#DC143C"
		}, {
			"color": "Cyan",
			"hex": "#00FFFF"
		}, {
			"color": "DarkBlue",
			"hex": "#00008B"
		}, {
			"color": "DarkCyan",
			"hex": "#008B8B"
		}, {
			"color": "DarkGoldenRod",
			"hex": "#B8860B"
		}, {
			"color": "DarkGray",
			"hex": "#A9A9A9"
		}, {
			"color": "DarkGreen",
			"hex": "#006400"
		}, {
			"color": "DarkKhaki",
			"hex": "#BDB76B"
		}, {
			"color": "DarkMagenta",
			"hex": "#8B008B"
		}, {
			"color": "DarkOliveGreen",
			"hex": "#556B2F"
		}, {
			"color": "DarkOrange",
			"hex": "#FF8C00"
		}, {
			"color": "DarkOrchid",
			"hex": "#9932CC"
		}, {
			"color": "DarkRed",
			"hex": "#8B0000"
		}, {
			"color": "DarkSalmon",
			"hex": "#E9967A"
		}, {
			"color": "DarkSeaGreen",
			"hex": "#8FBC8F"
		}, {
			"color": "DarkSlateBlue",
			"hex": "#483D8B"
		}, {
			"color": "DarkSlateGray",
			"hex": "#2F4F4F"
		}, {
			"color": "DarkTurquoise",
			"hex": "#00CED1"
		}, {
			"color": "DarkViolet",
			"hex": "#9400D3"
		}, {
			"color": "DeepPink",
			"hex": "#FF1493"
		}, {
			"color": "DeepSkyBlue",
			"hex": "#00BFFF"
		}, {
			"color": "DimGray",
			"hex": "#696969"
		}, {
			"color": "DodgerBlue",
			"hex": "#1E90FF"
		}, {
			"color": "FireBrick",
			"hex": "#B22222"
		}, {
			"color": "FloralWhite",
			"hex": "#FFFAF0"
		}, {
			"color": "ForestGreen",
			"hex": "#228B22"
		}, {
			"color": "Fuchsia",
			"hex": "#FF00FF"
		}, {
			"color": "Gainsboro",
			"hex": "#DCDCDC"
		}, {
			"color": "GhostWhite",
			"hex": "#F8F8FF"
		}, {
			"color": "Gold",
			"hex": "#FFD700"
		}, {
			"color": "GoldenRod",
			"hex": "#DAA520"
		}, {
			"color": "Gray",
			"hex": "#808080"
		}, {
			"color": "Green",
			"hex": "#008000"
		}, {
			"color": "GreenYellow",
			"hex": "#ADFF2F"
		}, {
			"color": "HoneyDew",
			"hex": "#F0FFF0"
		}, {
			"color": "HotPink",
			"hex": "#FF69B4"
		}, {
			"color": "IndianRed ",
			"hex": "#CD5C5C"
		}, {
			"color": "Indigo ",
			"hex": "#4B0082"
		}, {
			"color": "Ivory",
			"hex": "#FFFFF0"
		}, {
			"color": "Khaki",
			"hex": "#F0E68C"
		}, {
			"color": "Lavender",
			"hex": "#E6E6FA"
		}, {
			"color": "LavenderBlush",
			"hex": "#FFF0F5"
		}, {
			"color": "LawnGreen",
			"hex": "#7CFC00"
		}, {
			"color": "LemonChiffon",
			"hex": "#FFFACD"
		}, {
			"color": "LightBlue",
			"hex": "#ADD8E6"
		}, {
			"color": "LightCoral",
			"hex": "#F08080"
		}, {
			"color": "LightCyan",
			"hex": "#E0FFFF"
		}, {
			"color": "LightGoldenRodYellow",
			"hex": "#FAFAD2"
		}, {
			"color": "LightGray",
			"hex": "#D3D3D3"
		}, {
			"color": "LightGreen",
			"hex": "#90EE90"
		}, {
			"color": "LightPink",
			"hex": "#FFB6C1"
		}, {
			"color": "LightSalmon",
			"hex": "#FFA07A"
		}, {
			"color": "LightSeaGreen",
			"hex": "#20B2AA"
		}, {
			"color": "LightSkyBlue",
			"hex": "#87CEFA"
		}, {
			"color": "LightSlateGray",
			"hex": "#778899"
		}, {
			"color": "LightSteelBlue",
			"hex": "#B0C4DE"
		}, {
			"color": "LightYellow",
			"hex": "#FFFFE0"
		}, {
			"color": "Lime",
			"hex": "#00FF00"
		}, {
			"color": "LimeGreen",
			"hex": "#32CD32"
		}, {
			"color": "Linen",
			"hex": "#FAF0E6"
		}, {
			"color": "Magenta",
			"hex": "#FF00FF"
		}, {
			"color": "Maroon",
			"hex": "#800000"
		}, {
			"color": "MediumAquaMarine",
			"hex": "#66CDAA"
		}, {
			"color": "MediumBlue",
			"hex": "#0000CD"
		}, {
			"color": "MediumOrchid",
			"hex": "#BA55D3"
		}, {
			"color": "MediumPurple",
			"hex": "#9370DB"
		}, {
			"color": "MediumSeaGreen",
			"hex": "#3CB371"
		}, {
			"color": "MediumSlateBlue",
			"hex": "#7B68EE"
		}, {
			"color": "MediumSpringGreen",
			"hex": "#00FA9A"
		}, {
			"color": "MediumTurquoise",
			"hex": "#48D1CC"
		}, {
			"color": "MediumVioletRed",
			"hex": "#C71585"
		}, {
			"color": "MidnightBlue",
			"hex": "#191970"
		}, {
			"color": "MintCream",
			"hex": "#F5FFFA"
		}, {
			"color": "MistyRose",
			"hex": "#FFE4E1"
		}, {
			"color": "Moccasin",
			"hex": "#FFE4B5"
		}, {
			"color": "NavajoWhite",
			"hex": "#FFDEAD"
		}, {
			"color": "Navy",
			"hex": "#000080"
		}, {
			"color": "OldLace",
			"hex": "#FDF5E6"
		}, {
			"color": "Olive",
			"hex": "#808000"
		}, {
			"color": "OliveDrab",
			"hex": "#6B8E23"
		}, {
			"color": "Orange",
			"hex": "#FFA500"
		}, {
			"color": "OrangeRed",
			"hex": "#FF4500"
		}, {
			"color": "Orchid",
			"hex": "#DA70D6"
		}, {
			"color": "PaleGoldenRod",
			"hex": "#EEE8AA"
		}, {
			"color": "PaleGreen",
			"hex": "#98FB98"
		}, {
			"color": "PaleTurquoise",
			"hex": "#AFEEEE"
		}, {
			"color": "PaleVioletRed",
			"hex": "#DB7093"
		}, {
			"color": "PapayaWhip",
			"hex": "#FFEFD5"
		}, {
			"color": "PeachPuff",
			"hex": "#FFDAB9"
		}, {
			"color": "Peru",
			"hex": "#CD853F"
		}, {
			"color": "Pink",
			"hex": "#FFC0CB"
		}, {
			"color": "Plum",
			"hex": "#DDA0DD"
		}, {
			"color": "PowderBlue",
			"hex": "#B0E0E6"
		}, {
			"color": "Purple",
			"hex": "#800080"
		}, {
			"color": "Red",
			"hex": "#FF0000"
		}, {
			"color": "RosyBrown",
			"hex": "#BC8F8F"
		}, {
			"color": "RoyalBlue",
			"hex": "#4169E1"
		}, {
			"color": "SaddleBrown",
			"hex": "#8B4513"
		}, {
			"color": "Salmon",
			"hex": "#FA8072"
		}, {
			"color": "SandyBrown",
			"hex": "#F4A460"
		}, {
			"color": "SeaGreen",
			"hex": "#2E8B57"
		}, {
			"color": "SeaShell",
			"hex": "#FFF5EE"
		}, {
			"color": "Sienna",
			"hex": "#A0522D"
		}, {
			"color": "Silver",
			"hex": "#C0C0C0"
		}, {
			"color": "SkyBlue",
			"hex": "#87CEEB"
		}, {
			"color": "SlateBlue",
			"hex": "#6A5ACD"
		}, {
			"color": "SlateGray",
			"hex": "#708090"
		}, {
			"color": "Snow",
			"hex": "#FFFAFA"
		}, {
			"color": "SpringGreen",
			"hex": "#00FF7F"
		}, {
			"color": "SteelBlue",
			"hex": "#4682B4"
		}, {
			"color": "Tan",
			"hex": "#D2B48C"
		}, {
			"color": "Teal",
			"hex": "#008080"
		}, {
			"color": "Thistle",
			"hex": "#D8BFD8"
		}, {
			"color": "Tomato",
			"hex": "#FF6347"
		}, {
			"color": "Turquoise",
			"hex": "#40E0D0"
		}, {
			"color": "Violet",
			"hex": "#EE82EE"
		}, {
			"color": "Wheat",
			"hex": "#F5DEB3"
		}, {
			"color": "White",
			"hex": "#FFFFFF"
		}, {
			"color": "WhiteSmoke",
			"hex": "#F5F5F5"
		}, {
			"color": "Yellow",
			"hex": "#FFFF00"
		}, {
			"color": "YellowGreen",
			"hex": "#9ACD32"
		}]
	};

/***/ },
/* 4 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
		"description": "A list of vegetables.",
		"vegetables": ["acorn squash", "alfalfa sprout", "amaranth", "anise", "artichoke", "arugula", "asparagus", "aubergine", "azuki bean", "banana squash", "basil", "bean sprout", "beet", "black bean", "black-eyed pea", "bok choy", "borlotti bean", "broad beans", "broccoflower", "broccoli", "brussels sprout", "butternut squash", "cabbage", "calabrese", "caraway", "carrot", "cauliflower", "cayenne pepper", "celeriac", "celery", "chamomile", "chard", "chayote", "chickpea", "chives", "cilantro", "collard green", "corn", "corn salad", "courgette", "cucumber", "daikon", "delicata", "dill", "eggplant", "endive", "fennel", "fiddlehead", "frisee", "garlic", "gem squash", "ginger", "green bean", "green pepper", "habanero", "herbs and spice", "horseradish", "hubbard squash", "jalapeno", "jerusalem artichoke", "jicama", "kale", "kidney bean", "kohlrabi", "lavender", "leek ", "legume", "lemon grass", "lentils", "lettuce", "lima bean", "mamey", "mangetout", "marjoram", "mung bean", "mushrooms", "mustard green", "navy bean", "nettles", "new zealand spinach", "nopale", "okra", "onion", "oregano", "paprika", "parsley", "parsnip", "patty pan", "peas", "pinto bean", "potato", "pumpkin", "radicchio", "radish", "rhubarb", "rosemary", "runner bean", "rutabaga", "sage", "scallion", "shallot", "skirret", "snap pea", "soy bean", "spaghetti squash", "spinach", "squash ", "sweet potato", "tabasco pepper", "taro", "tat soi", "thyme", "tomato", "topinambur", "tubers", "turnip", "wasabi", "water chestnut", "watercress", "white radish", "yam", "zucchini"]
	};

/***/ },
/* 5 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
		"description": "Two lists: one for English towns, one for English cities.",
		"sources": {
			"towns": "https://en.wikipedia.org/wiki/List_of_towns_in_England",
			"cities": "https://en.wikipedia.org/wiki/List_of_cities_in_the_United_Kingdom"
		},
		"towns": ["Abingdon", "Accrington", "Acle", "Acton", "Adlington", "Alcester", "Aldeburgh", "Aldershot", "Alford", "Alfreton", "Alnwick", "Alsager", "Alston", "Alton", "Altrincham", "Amble", "Ambleside", "Amersham", "Amesbury", "Ampthill", "Andover", "Appleby-in-Westmorland", "Arlesey", "Arundel", "Ashbourne", "Ashburton", "Ashby Woulds", "Ashby-de-la-Zouch", "Ashford", "Ashington", "Ashton-under-Lyne", "Askern", "Aspatria", "Atherstone", "Attleborough", "Axbridge", "Axminster", "Aylesbury", "Aylsham", "Bacup", "Bakewell", "Banbury", "Barking", "Barnard Castle", "Barnes", "Barnet", "Barnoldswick", "Barnsley", "Barnstaple", "Barrow-in-Furness", "Barton-upon-Humber", "Basildon", "Basingstoke", "Batley", "Battle", "Bawtry", "Beaconsfield", "Beaminster", "Bebington", "Beccles", "Beckenham", "Bedale", "Bedford", "Bedworth", "Belper", "Bentham", "Berkeley", "Berkhamsted", "Berwick-upon-Tweed", "Beverley", "Bewdley", "Bexhill-on-Sea", "Bexley", "Bicester", "Biddulph", "Bideford", "Biggleswade", "Billericay", "Billingham", "Bilston", "Bingham", "Bingley", "Birchwood", "Birkenhead", "Bishop Auckland", "Bishop's Castle", "Bishop's Stortford", "Bishop's Waltham", "Blackburn", "Blackpool", "Blackrod", "Blackwater and Hawley", "Blandford Forum", "Bletchley and Fenny Stratford", "Blyth", "Bodmin", "Bognor Regis", "Bollington", "Bolsover", "Bolton", "Bootle", "Boroughbridge", "Boston", "Bottesford", "Bourne", "Bournemouth", "Bovey Tracey", "Brackley", "Bracknell", "Bradford-on-Avon", "Brading", "Bradley Stoke", "Bradninch", "Braintree", "Brampton", "Brandon", "Braunstone Town", "Brentford", "Brentwood", "Bridgnorth", "Bridgwater", "Bridlington", "Bridport", "Brierfield", "Brierley", "Brigg", "Brighouse", "Brightlingsea", "Brixham", "Broadstairs and St Peter's", "Bromborough", "Bromley", "Bromsgrove", "Bromyard and Winslow", "Broseley", "Broughton-in-Furness", "Broughton", "Bruton", "Buckfastleigh", "Buckingham", "Bude-Stratton", "Budleigh Salterton", "Bulwell", "Bungay", "Buntingford", "Burford", "Burgess Hill", "Burgh-le-Marsh", "Burnham-on-Crouch", "Burnham-on-Sea and Highbridge", "Burnley", "Burntwood", "Burslem", "Burton Latimer", "Burton upon Trent", "Bury St Edmunds", "Bury", "Bushey", "Buxton", "Caistor", "Callington", "Calne", "Camborne", "Camelford", "Cannock", "Canvey Island", "Carlton Colville", "Carnforth", "Carshalton", "Carterton", "Castle Cary", "Castleford", "Chagford", "Chapel-en-le-Frith", "Chard", "Charlbury", "Chatham", "Chatteris", "Cheadle", "Cheltenham", "Chertsey", "Chesham", "Cheshunt", "Chester-le-Street", "Chesterfield", "Chickerell", "Chingford", "Chippenham", "Chipping Campden", "Chipping Norton", "Chipping Sodbury", "Chorley", "Chorleywood", "Christchurch", "Chudleigh", "Chulmleigh", "Church Stretton", "Cinderford", "Cirencester", "Clare", "Clay Cross", "Cleator Moor", "Cleethorpes", "Cleobury Mortimer", "Clevedon", "Clitheroe", "Clun", "Cockermouth", "Coggeshall", "Colburn", "Colchester", "Coleford", "Coleshill", "Colne", "Colyton", "Congleton", "Conisbrough", "Corbridge", "Corby", "Corringham", "Corsham", "Cotgrave", "Coulsdon", "Cowes", "Cramlington", "Cranbrook", "Craven Arms", "Crawley", "Crediton", "Crewe", "Crewkerne", "Cricklade", "Cromer", "Crosby", "Crowborough", "Crowland", "Crowle", "Croydon", "Cullompton", "Dagenham", "Dalton Town with Newton", "Darley Dale", "Darlington", "Dartford", "Dartmouth", "Darwen", "Daventry", "Dawley", "Dawlish", "Deal", "Dereham", "Desborough", "Devizes", "Dewsbury", "Didcot", "Dinnington St John's", "Diss", "Doncaster", "Dorchester", "Dorking", "Dover", "Dovercourt", "Downham Market", "Driffield", "Droitwich Spa", "Dronfield", "Dudley", "Dukinfield", "Dulverton", "Dunstable", "Dunwich", "Dursley", "Ealing", "Earl Shilton", "Earley", "Easingwold", "East Cowes", "East Grinstead", "East Ham", "East Retford", "Eastbourne", "Eastleigh", "Eastwood", "Eccles", "Eccleshall", "Edenbridge", "Edgware", "Edmonton", "Egremont", "Elland", "Ellesmere Port", "Ellesmere", "Elstree and Borehamwood", "Emsworth", "Enfield", "Epping", "Epworth", "Erith", "Eton", "Evesham", "Exmouth", "Eye", "Fairford", "Fakenham", "Falmouth", "Fareham", "Faringdon", "Farnham", "Faversham", "Fazeley", "Featherstone", "Felixstowe", "Ferndown", "Ferryhill", "Filey", "Filton", "Finchley", "Fleet", "Fleetwood", "Flitwick", "Folkestone", "Fordbridge", "Fordingbridge", "Fordwich", "Fowey", "Framlingham", "Frinton and Walton", "Frodsham", "Frome", "Gainsborough", "Garstang", "Gateshead", "Gillingham", "Glastonbury", "Glossop", "Godalming", "Godmanchester", "Goole", "Gorleston", "Gosport", "Grange-over-Sands", "Grantham", "Gravesend", "Grays", "Great Dunmow", "Great Torrington", "Great Yarmouth", "Greater Willington", "Grimsby", "Guildford", "Guisborough", "Hadleigh", "Hailsham", "Halesowen", "Halesworth", "Halifax", "Halstead", "Haltwhistle", "Harlow", "Harpenden", "Harrogate", "Harrow", "Hartland", "Hartlepool", "Harwich", "Harworth and Bircotes", "Haslemere", "Haslingden", "Hastings", "Hatfield", "Hatherleigh", "Havant", "Haverhill", "Haxby", "Hayle", "Haywards Heath", "Heanor and Loscoe", "Heathfield", "Hebden Royd", "Hedge End", "Hednesford", "Hedon", "Helmsley", "Helston", "Hemel Hempstead", "Hemsworth", "Hendon", "Henley-in-Arden", "Henley-on-Thames", "Hertford", "Hessle", "Hetton", "Hexham", "Heywood", "High Wycombe", "Higham Ferrers", "Highworth", "Hinckley", "Hingham", "Hitchin", "Hoddesdon", "Holbeach", "Holsworthy", "Holt", "Honiton", "Horley", "Horncastle", "Hornsea", "Hornsey", "Horsforth", "Horsham", "Horwich", "Houghton Regis", "Howden", "Huddersfield", "Hungerford", "Hunstanton", "Huntingdon", "Hyde", "Hythe", "Ilford", "Ilfracombe", "Ilkeston", "Ilkley", "Ilminster", "Immingham", "Ingleby Barwick", "Ipswich", "Irthlingborough", "Ivybridge", "Jarrow", "Keighley", "Kempston", "Kendal", "Kenilworth", "Kesgrave", "Keswick", "Kettering", "Keynsham", "Kidderminster", "Kidsgrove", "Kimberley", "King's Lynn", "Kingsbridge", "Kingston-upon-Thames", "Kington", "Kirkby Lonsdale", "Kirkby Stephen", "Kirkby-in-Ashfield", "Kirkbymoorside", "Kirkham", "Kirton-in-Lindsey", "Knaresborough", "Knutsford", "Langport", "Launceston", "Leatherhead", "Lechlade", "Ledbury", "Leek", "Leigh-on-Sea", "Leigh", "Leighton-Linslade", "Leiston", "Leominster", "Letchworth Garden City", "Lewes", "Leyburn", "Leyton", "Liskeard", "Littlehampton", "Loddon", "Loftus", "Long Sutton", "Longridge", "Longtown", "Looe", "Lostwithiel", "Loughborough", "Loughton", "Louth", "Lowestoft", "Ludgershall", "Ludlow", "Luton", "Lutterworth", "Lydd", "Lydney", "Lyme Regis", "Lynton and Lynmouth", "Lytham St Annes", "Mablethorpe and Sutton", "Macclesfield", "Madeley", "Maghull", "Maidenhead", "Maidstone", "Maldon", "Malmesbury", "Maltby", "Malton", "Malvern", "Manningtree", "Mansfield", "Marazion", "March", "Margate", "Market Bosworth", "Market Deeping", "Market Drayton", "Market Harborough", "Market Rasen", "Market Weighton", "Marlborough", "Marlow", "Maryport", "Masham", "Matlock", "Medlar with Wesham", "Melksham", "Meltham", "Melton Mowbray", "Mere", "Mexborough", "Middleham", "Middlesbrough", "Middleton", "Middlewich", "Midhurst", "Midsomer Norton", "Mildenhall", "Millom", "Milton Keynes", "Minchinhampton", "Minehead", "Minster", "Mirfield", "Mitcham", "Mitcheldean", "Morecambe", "Moreton-in-Marsh", "Moretonhampstead", "Morley", "Morpeth", "Mossley", "Much Wenlock", "Nailsea", "Nailsworth", "Nantwich", "Needham Market", "Nelson", "Neston", "New Alresford", "New Mills", "New Milton", "New Romney", "Newark-on-Trent", "Newbiggin-by-the-Sea", "Newbury", "Newcastle-under-Lyme", "Newent", "Newhaven", "Newlyn", "Newmarket", "Newport Pagnell", "Newport", "Newquay", "Newton Abbot", "Newton-le-Willows", "Normanton", "North Hykeham", "North Petherton", "North Tawton", "North Walsham", "Northallerton", "Northam", "Northampton", "Northfleet", "Northleach with Eastington", "Northwich", "Norton-on-Derwent", "Nuneaton", "Oakengates", "Oakham", "Okehampton", "Oldbury", "Oldham", "Ollerton and Boughton", "Olney", "Ongar", "Orford", "Ormskirk", "Ossett", "Oswestry", "Otley", "Ottery St Mary", "Oundle", "Paddock Wood", "Padiham", "Padstow", "Paignton", "Painswick", "Partington", "Patchway", "Pateley Bridge", "Peacehaven", "Penistone", "Penkridge", "Penrith", "Penryn", "Penwortham", "Penzance", "Pershore", "Peterlee", "Petersfield", "Petworth", "Pickering", "Pocklington", "Polegate", "Pontefract", "Ponteland", "Poole", "Porthleven", "Portishead and North Weston", "Portland", "Potton", "Poynton-with-Worth", "Preesall", "Prescot", "Princes Risborough", "Prudhoe", "Pudsey", "Queenborough-in-Sheppey", "Radstock", "Ramsey", "Ramsgate", "Raunds", "Rawtenstall", "Rayleigh", "Reading", "Redcar", "Redditch", "Redenhall with Harleston", "Redruth", "Reepham", "Reigate", "Richmond", "Ringwood", "Ripley", "Ripon", "Rochdale", "Rochester", "Rochford", "Romford", "Romsey", "Ross-on-Wye", "Rothbury", "Rotherham", "Rothwell", "Rowley Regis", "Royal Leamington Spa", "Royal Tunbridge Wells", "Royal Wootton Bassett", "Royston", "Rugby", "Rugeley", "Rushden", "Ryde", "Rye", "Saffron Walden", "Salcombe", "Sale", "Saltash", "Sandbach", "Sandhurst", "Sandiacre", "Sandown", "Sandwich", "Sandy", "Sawbridgeworth", "Saxmundham", "Scarborough", "Scunthorpe", "Seaford", "Seaham", "Seaton", "Sedbergh", "Selby", "Selsey", "Settle", "Sevenoaks", "Shaftesbury", "Shanklin", "Shefford", "Shepshed", "Shepton Mallet", "Sherborne", "Sheringham", "Shifnal", "Shildon", "Shipston-on-Stour", "Shirebrook", "Shoreham-by-Sea", "Shrewsbury", "Sidmouth", "Silloth", "Silsden", "Sittingbourne", "Skegness", "Skelmersdale", "Skelton-in-Cleveland", "Skipton", "Sleaford", "Slough", "Smethwick", "Snaith and Cowick", "Snodland", "Soham", "Solihull", "Somerton", "South Cave", "South Elmsall", "South Kirkby and Moorthorpe", "South Molton", "South Petherton", "South Shields", "South Woodham Ferrers", "Southall", "Southam", "Southborough", "Southend-on-Sea", "Southgate", "Southminster", "Southport", "Southsea", "Southwell", "Southwick", "Southwold", "Spalding", "Spennymoor", "Spilsby", "St Austell", "St Blaise", "St Columb Major", "St Helens", "St Ives", "St Just-in-Penwith", "St Mary Cray", "St Mawes", "St Neots", "Stafford", "Staines-upon-Thames", "Stainforth", "Stalbridge", "Stalham", "Stalybridge", "Stamford", "Stanhope", "Stanley", "Stapleford", "Staveley", "Stevenage", "Steyning", "Stockport", "Stocksbridge", "Stockton-on-Tees", "Stone", "Stonehouse", "Stony Stratford", "Stotfold", "Stourbridge", "Stourport-on-Severn", "Stow-on-the-Wold", "Stowmarket", "Stratford-upon-Avon", "Stretford", "Strood", "Stroud", "Sturminster Newton", "Sudbury", "Surbiton", "Sutton Coldfield", "Sutton", "Swaffham", "Swanage", "Swanley", "Swanscombe and Greenhithe", "Swindon", "Syston", "Tadcaster", "Tadley", "Tamworth", "Taunton", "Tavistock", "Teignmouth", "Telford", "Telscombe", "Tenbury Wells", "Tenterden", "Tetbury", "Tewkesbury", "Thame", "Thatcham", "Thaxted", "Thetford", "Thirsk", "Thornaby-on-Tees", "Thornbury", "Thorne", "Thorpe St Andrew", "Thrapston", "Tickhill", "Tidworth", "Tipton", "Tisbury", "Tiverton", "Todmorden", "Tonbridge", "Topsham", "Torpoint", "Torquay", "Totnes", "Tottenham", "Totton and Eling", "Tow Law", "Towcester", "Tring", "Trowbridge", "Twickenham", "Tynemouth", "Uckfield", "Ulverston", "Uppingham", "Upton-upon-Severn", "Uttoxeter", "Uxbridge", "Ventnor", "Verwood", "Wadebridge", "Wadhurst", "Wainfleet All Saints", "Wallasey", "Wallingford", "Wallsend", "Walsall", "Waltham Abbey", "Waltham Cross", "Walthamstow", "Walton-on-Thames", "Wantage", "Ware", "Wareham", "Warminster", "Warrington", "Warwick", "Washington", "Watchet", "Watford", "Wath-upon-Dearne", "Watlington", "Watton", "Wellingborough", "Wellington", "Wells-next-the-Sea", "Welwyn Garden City", "Wem", "Wembley", "Wendover", "West Bedlington", "West Bromwich", "West Ham", "West Malling", "West Mersea", "West Tilbury", "Westbury", "Westerham", "Westhoughton", "Weston-super-Mare", "Wetherby", "Weybridge", "Weymouth", "Whaley Bridge", "Whitby", "Whitchurch", "Whitehaven", "Whitehill", "Whitnash", "Whittlesey", "Whitworth", "Wickham", "Wickwar", "Widnes", "Wigan", "Wigton", "Willenhall", "Willesden", "Wilton", "Wimbledon", "Wimborne Minster", "Wincanton", "Winchcombe", "Winchelsea", "Windermere", "Windsor", "Winsford", "Winslow", "Winterton", "Wirksworth", "Wisbech", "Witham", "Withernsea", "Witney", "Wiveliscombe", "Wivenhoe", "Woburn Sands", "Woburn", "Woking", "Wokingham", "Wolsingham", "Wolverton and Greenleys", "Wood Green", "Woodbridge", "Woodley", "Woodstock", "Wooler", "Workington", "Worksop", "Worthing", "Wotton-under-Edge", "Wragby", "Wymondham", "Yarm", "Yarmouth", "Yate", "Yateley", "Yeovil"],
		"cities": ["Bath", "Birmingham", "Bradford", "Brighton & Hove", "Bristol", "Cambridge", "Cantebury", "Carlisle", "Chelmsford", "Chester", "Chichester", "City of London", "City of Westminster", "Coventry", "Derby", "Durham", "Ely", "Exeter", "Gloucester", "Hereford", "Kingston upon Hull", "Lancaster", "Leeds", "Leicester", "Lichfield", "Lincoln", "Liverpool", "Manchester", "Newcastle upon Tyne", "Norwich", "Nottingham", "Oxford", "Peterborough", "Plymouth", "Portsmouth", "Preston", "Ripon", "Salford", "Salisbury", "Sheffield", "Southampton", "St Albans", "Stoke-on-Trent", "Sunderland", "Truro", "Wakefield", "Wells", "Winchester", "Worcester", "York"]
	};

/***/ },
/* 6 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
		"description": "London Underground stations, with their lines and Travelcard zones",
		"source": "https://en.wikipedia.org/wiki/List_of_London_Underground_stations",
		"stations": [{
			"name": "Acton Town",
			"lines": ["District", "Piccadilly"],
			"zones": [3]
		}, {
			"name": "Aldgate",
			"lines": ["Metropolitan", "Circle"],
			"zones": [1]
		}, {
			"name": "Aldgate East",
			"lines": ["Hammersmith & City", "District"],
			"zones": [1]
		}, {
			"name": "Alperton",
			"lines": ["Piccadilly"],
			"zones": [4]
		}, {
			"name": "Amersham",
			"lines": ["Metropolitan"],
			"zones": [9]
		}, {
			"name": "Angel",
			"lines": ["Northern"],
			"zones": [1]
		}, {
			"name": "Archway",
			"lines": ["Northern"],
			"zones": [2, 3]
		}, {
			"name": "Arnos Grove",
			"lines": ["Piccadilly"],
			"zones": [4]
		}, {
			"name": "Arsenal",
			"lines": ["Piccadilly"],
			"zones": [2]
		}, {
			"name": "Baker Street",
			"lines": ["Metropolitan", "Bakerloo", "Circle", "Jubilee", "Hammersmith & City"],
			"zones": [1]
		}, {
			"name": "Balham",
			"lines": ["Northern"],
			"zones": [3]
		}, {
			"name": "Bank",
			"lines": ["Waterloo & City", "Northern", "Central"],
			"zones": [1]
		}, {
			"name": "Barbican",
			"lines": ["Metropolitan", "Circle", "Hammersmith & City"],
			"zones": [1]
		}, {
			"name": "Barking",
			"lines": ["District", "Hammersmith & City"],
			"zones": [4]
		}, {
			"name": "Barkingside",
			"lines": ["Central"],
			"zones": [4]
		}, {
			"name": "Barons Court",
			"lines": ["District", "Piccadilly"],
			"zones": [2]
		}, {
			"name": "Bayswater",
			"lines": ["District", "Circle"],
			"zones": [1]
		}, {
			"name": "Becontree",
			"lines": ["District"],
			"zones": [5]
		}, {
			"name": "Belsize Park",
			"lines": ["Northern"],
			"zones": [2]
		}, {
			"name": "Bermondsey",
			"lines": ["Jubilee"],
			"zones": [2]
		}, {
			"name": "Bethnal Green",
			"lines": ["Central"],
			"zones": [2]
		}, {
			"name": "Blackfriars",
			"lines": ["District", "Circle"],
			"zones": [1]
		}, {
			"name": "Blackhorse Road",
			"lines": ["Victoria"],
			"zones": [3]
		}, {
			"name": "Bond Street",
			"lines": ["Central", "Jubilee"],
			"zones": [1]
		}, {
			"name": "Borough",
			"lines": ["Northern"],
			"zones": [1]
		}, {
			"name": "Boston Manor",
			"lines": ["Piccadilly"],
			"zones": [4]
		}, {
			"name": "Bounds Green",
			"lines": ["Piccadilly"],
			"zones": [3, 4]
		}, {
			"name": "Bow Road",
			"lines": ["District", "Hammersmith & City"],
			"zones": [2]
		}, {
			"name": "Brent Cross",
			"lines": ["Northern"],
			"zones": [3]
		}, {
			"name": "Brixton",
			"lines": ["Victoria"],
			"zones": [2]
		}, {
			"name": "Bromley-by-Bow",
			"lines": ["District", "Hammersmith & City"],
			"zones": [2, 3]
		}, {
			"name": "Buckhurst Hill",
			"lines": ["Central"],
			"zones": [5]
		}, {
			"name": "Burnt Oak",
			"lines": ["Northern"],
			"zones": [4]
		}, {
			"name": "Caledonian Road",
			"lines": ["Piccadilly"],
			"zones": [2]
		}, {
			"name": "Camden Town",
			"lines": ["Northern"],
			"zones": [2]
		}, {
			"name": "Canada Water",
			"lines": ["Jubilee"],
			"zones": [2]
		}, {
			"name": "Canary Wharf",
			"lines": ["Jubilee"],
			"zones": [2]
		}, {
			"name": "Canning Town",
			"lines": ["Jubilee"],
			"zones": [3]
		}, {
			"name": "Cannon Street",
			"lines": ["District", "Circle"],
			"zones": [1]
		}, {
			"name": "Canons Park",
			"lines": ["Jubilee"],
			"zones": [5]
		}, {
			"name": "Chalfont & Latimer",
			"lines": ["Metropolitan"],
			"zones": [8]
		}, {
			"name": "Chalk Farm",
			"lines": ["Northern"],
			"zones": [2]
		}, {
			"name": "Chancery Lane",
			"lines": ["Central"],
			"zones": [1]
		}, {
			"name": "Charing Cross",
			"lines": ["Bakerloo", "Northern"],
			"zones": [1]
		}, {
			"name": "Chesham",
			"lines": ["Metropolitan"],
			"zones": [9]
		}, {
			"name": "Chigwell",
			"lines": ["Central"],
			"zones": [4]
		}, {
			"name": "Chiswick Park",
			"lines": ["District"],
			"zones": [3]
		}, {
			"name": "Chorleywood",
			"lines": ["Metropolitan"],
			"zones": [7]
		}, {
			"name": "Clapham Common",
			"lines": ["Northern"],
			"zones": [2]
		}, {
			"name": "Clapham North",
			"lines": ["Northern"],
			"zones": [2]
		}, {
			"name": "Clapham South",
			"lines": ["Northern"],
			"zones": [2, 3]
		}, {
			"name": "Cockfosters",
			"lines": ["Piccadilly"],
			"zones": [5]
		}, {
			"name": "Colindale",
			"lines": ["Northern"],
			"zones": [4]
		}, {
			"name": "Colliers Wood",
			"lines": ["Northern"],
			"zones": [3]
		}, {
			"name": "Covent Garden",
			"lines": ["Piccadilly"],
			"zones": [1]
		}, {
			"name": "Croxley",
			"lines": ["Metropolitan"],
			"zones": [7]
		}, {
			"name": "Dagenham East",
			"lines": ["District"],
			"zones": [5]
		}, {
			"name": "Dagenham Heathway",
			"lines": ["District"],
			"zones": [5]
		}, {
			"name": "Debden",
			"lines": ["Central"],
			"zones": [6]
		}, {
			"name": "Dollis Hill",
			"lines": ["Jubilee"],
			"zones": [3]
		}, {
			"name": "Ealing Broadway",
			"lines": ["District", "Central"],
			"zones": [3]
		}, {
			"name": "Ealing Common",
			"lines": ["District", "Piccadilly"],
			"zones": [3]
		}, {
			"name": "Earl's Court",
			"lines": ["District", "Piccadilly"],
			"zones": [1, 2]
		}, {
			"name": "East Acton",
			"lines": ["Central"],
			"zones": [2]
		}, {
			"name": "East Finchley",
			"lines": ["Northern"],
			"zones": [3]
		}, {
			"name": "East Ham",
			"lines": ["District", "Hammersmith & City"],
			"zones": [3, 4]
		}, {
			"name": "East Putney",
			"lines": ["District"],
			"zones": [2, 3]
		}, {
			"name": "Eastcote",
			"lines": ["Metropolitan", "Piccadilly"],
			"zones": [5]
		}, {
			"name": "Edgware",
			"lines": ["Northern"],
			"zones": [5]
		}, {
			"name": "Edgware Road",
			"lines": ["Bakerloo"],
			"zones": [1]
		}, {
			"name": "Edgware Road",
			"lines": ["Hammersmith & City", "District", "Circle"],
			"zones": [1]
		}, {
			"name": "Elephant & Castle",
			"lines": ["Northern", "Bakerloo"],
			"zones": [1, 2]
		}, {
			"name": "Elm Park",
			"lines": ["District"],
			"zones": [6]
		}, {
			"name": "Embankment",
			"lines": ["District", "Bakerloo", "Northern", "Circle"],
			"zones": [1]
		}, {
			"name": "Epping",
			"lines": ["Central"],
			"zones": [6]
		}, {
			"name": "Euston",
			"lines": ["Northern", "Victoria"],
			"zones": [1]
		}, {
			"name": "Euston Square",
			"lines": ["Metropolitan", "Circle", "Hammersmith & City"],
			"zones": [1]
		}, {
			"name": "Fairlop",
			"lines": ["Central"],
			"zones": [4]
		}, {
			"name": "Farringdon",
			"lines": ["Metropolitan", "Circle", "Hammersmith & City"],
			"zones": [1]
		}, {
			"name": "Finchley Central",
			"lines": ["Northern"],
			"zones": [4]
		}, {
			"name": "Finchley Road",
			"lines": ["Metropolitan", "Jubilee"],
			"zones": [2]
		}, {
			"name": "Finsbury Park",
			"lines": ["Piccadilly", "Victoria"],
			"zones": [2]
		}, {
			"name": "Fulham Broadway",
			"lines": ["District"],
			"zones": [2]
		}, {
			"name": "Gants Hill",
			"lines": ["Central"],
			"zones": [4]
		}, {
			"name": "Gloucester Road",
			"lines": ["District", "Piccadilly", "Circle"],
			"zones": [1]
		}, {
			"name": "Golders Green",
			"lines": ["Northern"],
			"zones": [3]
		}, {
			"name": "Goldhawk Road",
			"lines": ["Hammersmith & City", "Circle"],
			"zones": [2]
		}, {
			"name": "Goodge Street",
			"lines": ["Northern"],
			"zones": [1]
		}, {
			"name": "Grange Hill",
			"lines": ["Central"],
			"zones": [4]
		}, {
			"name": "Great Portland Street",
			"lines": ["Metropolitan", "Circle", "Hammersmith & City"],
			"zones": [1]
		}, {
			"name": "Greenford",
			"lines": ["Central"],
			"zones": [4]
		}, {
			"name": "Green Park",
			"lines": ["Piccadilly", "Victoria", "Jubilee"],
			"zones": [1]
		}, {
			"name": "Gunnersbury",
			"lines": ["District"],
			"zones": [3]
		}, {
			"name": "Hainault",
			"lines": ["Central"],
			"zones": [4]
		}, {
			"name": "Hammersmith",
			"lines": ["District", "Piccadilly"],
			"zones": [2]
		}, {
			"name": "Hammersmith",
			"lines": ["Hammersmith & City", "Circle"],
			"zones": [2]
		}, {
			"name": "Hampstead",
			"lines": ["Northern"],
			"zones": [2, 3]
		}, {
			"name": "Hanger Lane",
			"lines": ["Central"],
			"zones": [3]
		}, {
			"name": "Harlesden",
			"lines": ["Bakerloo"],
			"zones": [3]
		}, {
			"name": "Harrow & Wealdstone",
			"lines": ["Bakerloo"],
			"zones": [5]
		}, {
			"name": "Harrow-on-the-Hill",
			"lines": ["Metropolitan"],
			"zones": [5]
		}, {
			"name": "Hatton Cross",
			"lines": ["Piccadilly"],
			"zones": [5, 6]
		}, {
			"name": "Heathrow Terminals 1, 2, 3",
			"lines": ["Piccadilly"],
			"zones": [6]
		}, {
			"name": "Heathrow Terminal 4",
			"lines": ["Piccadilly"],
			"zones": [6]
		}, {
			"name": "Heathrow Terminal 5",
			"lines": ["Piccadilly"],
			"zones": [6]
		}, {
			"name": "Hendon Central",
			"lines": ["Northern"],
			"zones": [3, 4]
		}, {
			"name": "High Barnet",
			"lines": ["Northern"],
			"zones": [5]
		}, {
			"name": "Highbury & Islington",
			"lines": ["Victoria"],
			"zones": [2]
		}, {
			"name": "Highgate",
			"lines": ["Northern"],
			"zones": [3]
		}, {
			"name": "High Street Kensington",
			"lines": ["District", "Circle"],
			"zones": [1]
		}, {
			"name": "Hillingdon",
			"lines": ["Metropolitan", "Piccadilly"],
			"zones": [6]
		}, {
			"name": "Holborn",
			"lines": ["Central", "Piccadilly"],
			"zones": [1]
		}, {
			"name": "Holland Park",
			"lines": ["Central"],
			"zones": [2]
		}, {
			"name": "Holloway Road",
			"lines": ["Piccadilly"],
			"zones": [2]
		}, {
			"name": "Hornchurch",
			"lines": ["District"],
			"zones": [6]
		}, {
			"name": "Hounslow Central",
			"lines": ["Piccadilly"],
			"zones": [4]
		}, {
			"name": "Hounslow East",
			"lines": ["Piccadilly"],
			"zones": [4]
		}, {
			"name": "Hounslow West",
			"lines": ["Piccadilly"],
			"zones": [5]
		}, {
			"name": "Hyde Park Corner",
			"lines": ["Piccadilly"],
			"zones": [1]
		}, {
			"name": "Ickenham",
			"lines": ["Metropolitan", "Piccadilly"],
			"zones": [6]
		}, {
			"name": "Kennington",
			"lines": ["Northern"],
			"zones": [2]
		}, {
			"name": "Kensal Green",
			"lines": ["Bakerloo"],
			"zones": [2]
		}, {
			"name": "Kensington (Olympia)",
			"lines": ["District"],
			"zones": [2]
		}, {
			"name": "Kentish Town",
			"lines": ["Northern"],
			"zones": [2]
		}, {
			"name": "Kenton",
			"lines": ["Bakerloo"],
			"zones": [4]
		}, {
			"name": "Kew Gardens",
			"lines": ["District"],
			"zones": [3, 4]
		}, {
			"name": "Kilburn",
			"lines": ["Jubilee"],
			"zones": [2]
		}, {
			"name": "Kilburn Park",
			"lines": ["Bakerloo"],
			"zones": [2]
		}, {
			"name": "Kingsbury",
			"lines": ["Jubilee"],
			"zones": [4]
		}, {
			"name": "King's Cross St. Pancras",
			"lines": ["Metropolitan", "Northern", "Piccadilly", "Circle", "Victoria", "Hammersmith & City"],
			"zones": [1]
		}, {
			"name": "Knightsbridge",
			"lines": ["Piccadilly"],
			"zones": [1]
		}, {
			"name": "Ladbroke Grove",
			"lines": ["Hammersmith & City", "Circle"],
			"zones": [2]
		}, {
			"name": "Lambeth North",
			"lines": ["Bakerloo"],
			"zones": [1]
		}, {
			"name": "Lancaster Gate",
			"lines": ["Central"],
			"zones": [1]
		}, {
			"name": "Latimer Road",
			"lines": ["Hammersmith & City", "Circle"],
			"zones": [2]
		}, {
			"name": "Leicester Square",
			"lines": ["Piccadilly", "Northern"],
			"zones": [1]
		}, {
			"name": "Leyton",
			"lines": ["Central"],
			"zones": [3]
		}, {
			"name": "Leytonstone",
			"lines": ["Central"],
			"zones": [3, 4]
		}, {
			"name": "Liverpool Street",
			"lines": ["Metropolitan", "Central", "Circle", "Hammersmith & City"],
			"zones": [1]
		}, {
			"name": "London Bridge",
			"lines": ["Northern", "Jubilee"],
			"zones": [1]
		}, {
			"name": "Loughton",
			"lines": ["Central"],
			"zones": [6]
		}, {
			"name": " Maida Vale",
			"lines": ["Bakerloo"],
			"zones": [2]
		}, {
			"name": "Manor House",
			"lines": ["Piccadilly"],
			"zones": [2, 3]
		}, {
			"name": "Mansion House",
			"lines": ["District", "Circle"],
			"zones": [1]
		}, {
			"name": "Marble Arch",
			"lines": ["Central"],
			"zones": [1]
		}, {
			"name": "Marylebone",
			"lines": ["Bakerloo"],
			"zones": [1]
		}, {
			"name": "Mile End",
			"lines": ["District", "Hammersmith & City", "Central"],
			"zones": [2]
		}, {
			"name": "Mill Hill East",
			"lines": ["Northern"],
			"zones": [4]
		}, {
			"name": "Monument",
			"lines": ["District", "Circle"],
			"zones": [1]
		}, {
			"name": "Moorgate",
			"lines": ["Metropolitan", "Northern", "Circle", "Hammersmith & City"],
			"zones": [1]
		}, {
			"name": "Moor Park",
			"lines": ["Metropolitan"],
			"zones": [6, 7]
		}, {
			"name": "Morden",
			"lines": ["Northern"],
			"zones": [4]
		}, {
			"name": "Mornington Crescent",
			"lines": ["Northern"],
			"zones": [2]
		}, {
			"name": "Neasden",
			"lines": ["Jubilee"],
			"zones": [3]
		}, {
			"name": "Newbury Park",
			"lines": ["Central"],
			"zones": [4]
		}, {
			"name": "North Acton",
			"lines": ["Central"],
			"zones": [2, 3]
		}, {
			"name": "North Ealing",
			"lines": ["Piccadilly"],
			"zones": [3]
		}, {
			"name": "North Greenwich",
			"lines": ["Jubilee"],
			"zones": [2, 3]
		}, {
			"name": "North Harrow",
			"lines": ["Metropolitan"],
			"zones": [5]
		}, {
			"name": "North Wembley",
			"lines": ["Bakerloo"],
			"zones": [4]
		}, {
			"name": "Northfields",
			"lines": ["Piccadilly"],
			"zones": [3]
		}, {
			"name": "Northolt",
			"lines": ["Central"],
			"zones": [5]
		}, {
			"name": "Northwick Park",
			"lines": ["Metropolitan"],
			"zones": [4]
		}, {
			"name": "Northwood",
			"lines": ["Metropolitan"],
			"zones": [6]
		}, {
			"name": "Northwood Hills",
			"lines": ["Metropolitan"],
			"zones": [6]
		}, {
			"name": "Notting Hill Gate",
			"lines": ["District", "Central", "Circle"],
			"zones": [1, 2]
		}, {
			"name": "Oakwood",
			"lines": ["Piccadilly"],
			"zones": [5]
		}, {
			"name": "Old Street",
			"lines": ["Northern"],
			"zones": [1]
		}, {
			"name": "Osterley",
			"lines": ["Piccadilly"],
			"zones": [4]
		}, {
			"name": "Oval",
			"lines": ["Northern"],
			"zones": [2]
		}, {
			"name": "Oxford Circus",
			"lines": ["Central", "Bakerloo", "Victoria"],
			"zones": [1]
		}, {
			"name": "Paddington",
			"lines": ["Hammersmith & City", "District", "Circle", "Bakerloo"],
			"zones": [1]
		}, {
			"name": "Park Royal",
			"lines": ["Piccadilly"],
			"zones": [3]
		}, {
			"name": "Parsons Green",
			"lines": ["District"],
			"zones": [2]
		}, {
			"name": "Perivale",
			"lines": ["Central"],
			"zones": [4]
		}, {
			"name": "Piccadilly Circus",
			"lines": ["Bakerloo", "Piccadilly"],
			"zones": [1]
		}, {
			"name": "Pimlico",
			"lines": ["Victoria"],
			"zones": [1]
		}, {
			"name": "Pinner",
			"lines": ["Metropolitan"],
			"zones": [5]
		}, {
			"name": "Plaistow",
			"lines": ["District", "Hammersmith & City"],
			"zones": [3]
		}, {
			"name": "Preston Road",
			"lines": ["Metropolitan"],
			"zones": [4]
		}, {
			"name": "Putney Bridge",
			"lines": ["District"],
			"zones": [2]
		}, {
			"name": "Queen's Park",
			"lines": ["Bakerloo"],
			"zones": [2]
		}, {
			"name": "Queensbury",
			"lines": ["Jubilee"],
			"zones": [4]
		}, {
			"name": "Queensway",
			"lines": ["Central"],
			"zones": [1]
		}, {
			"name": "Ravenscourt Park",
			"lines": ["District"],
			"zones": [2]
		}, {
			"name": "Rayners Lane",
			"lines": ["Metropolitan", "Piccadilly"],
			"zones": [5]
		}, {
			"name": "Redbridge",
			"lines": ["Central"],
			"zones": [4]
		}, {
			"name": "Regent's Park",
			"lines": ["Bakerloo"],
			"zones": [1]
		}, {
			"name": "Richmond",
			"lines": ["District"],
			"zones": [4]
		}, {
			"name": "Rickmansworth",
			"lines": ["Metropolitan"],
			"zones": [7]
		}, {
			"name": "Roding Valley",
			"lines": ["Central"],
			"zones": [4]
		}, {
			"name": "Royal Oak",
			"lines": ["Hammersmith & City", "Circle"],
			"zones": [2]
		}, {
			"name": "Ruislip",
			"lines": ["Metropolitan", "Piccadilly"],
			"zones": [6]
		}, {
			"name": "Ruislip Gardens",
			"lines": ["Central"],
			"zones": [5]
		}, {
			"name": "Ruislip Manor",
			"lines": ["Metropolitan", "Piccadilly"],
			"zones": [6]
		}, {
			"name": "Russell Square",
			"lines": ["Piccadilly"],
			"zones": [1]
		}, {
			"name": "St. James's Park",
			"lines": ["District", "Circle"],
			"zones": [1]
		}, {
			"name": "St. John's Wood",
			"lines": ["Jubilee"],
			"zones": [2]
		}, {
			"name": "St. Paul's",
			"lines": ["Central"],
			"zones": [1]
		}, {
			"name": "Seven Sisters",
			"lines": ["Victoria"],
			"zones": [3]
		}, {
			"name": "Shepherd's Bush",
			"lines": ["Central"],
			"zones": [2]
		}, {
			"name": "Shepherd's Bush Market",
			"lines": ["Hammersmith & City", "Circle"],
			"zones": [2]
		}, {
			"name": "Sloane Square",
			"lines": ["District", "Circle"],
			"zones": [1]
		}, {
			"name": "Snaresbrook",
			"lines": ["Central"],
			"zones": [4]
		}, {
			"name": "South Ealing",
			"lines": ["Piccadilly"],
			"zones": [3]
		}, {
			"name": "South Harrow",
			"lines": ["Piccadilly"],
			"zones": [5]
		}, {
			"name": "South Kensington",
			"lines": ["District", "Piccadilly", "Circle"],
			"zones": [1]
		}, {
			"name": "South Kenton",
			"lines": ["Bakerloo"],
			"zones": [4]
		}, {
			"name": "South Ruislip",
			"lines": ["Central"],
			"zones": [5]
		}, {
			"name": "South Wimbledon",
			"lines": ["Northern"],
			"zones": [3, 4]
		}, {
			"name": "South Woodford",
			"lines": ["Central"],
			"zones": [4]
		}, {
			"name": "Southfields",
			"lines": ["District"],
			"zones": [3]
		}, {
			"name": "Southgate",
			"lines": ["Piccadilly"],
			"zones": [4]
		}, {
			"name": "Southwark",
			"lines": ["Jubilee"],
			"zones": [1]
		}, {
			"name": "Stamford Brook",
			"lines": ["District"],
			"zones": [2]
		}, {
			"name": "Stanmore",
			"lines": ["Jubilee"],
			"zones": [5]
		}, {
			"name": "Stepney Green",
			"lines": ["District", "Hammersmith & City"],
			"zones": [2]
		}, {
			"name": "Stockwell",
			"lines": ["Northern", "Victoria"],
			"zones": [2]
		}, {
			"name": "Stonebridge Park",
			"lines": ["Bakerloo"],
			"zones": [3]
		}, {
			"name": "Stratford",
			"lines": ["Central", "Jubilee"],
			"zones": [3]
		}, {
			"name": "Sudbury Hill",
			"lines": ["Piccadilly"],
			"zones": [4]
		}, {
			"name": "Sudbury Town",
			"lines": ["Piccadilly"],
			"zones": [4]
		}, {
			"name": "Swiss Cottage",
			"lines": ["Jubilee"],
			"zones": [2]
		}, {
			"name": "Temple",
			"lines": ["District", "Circle"],
			"zones": [1]
		}, {
			"name": "Theydon Bois",
			"lines": ["Central"],
			"zones": [6]
		}, {
			"name": "Tooting Bec",
			"lines": ["Northern"],
			"zones": [3]
		}, {
			"name": "Tooting Broadway",
			"lines": ["Northern"],
			"zones": [3]
		}, {
			"name": "Tottenham Court Road",
			"lines": ["Central", "Northern"],
			"zones": [1]
		}, {
			"name": "Tottenham Hale",
			"lines": ["Victoria"],
			"zones": [3]
		}, {
			"name": "Totteridge & Whetstone",
			"lines": ["Northern"],
			"zones": [4]
		}, {
			"name": "Tower Hill",
			"lines": ["District", "Circle"],
			"zones": [1]
		}, {
			"name": "Tufnell Park",
			"lines": ["Northern"],
			"zones": [2]
		}, {
			"name": "Turnham Green",
			"lines": ["District", "Piccadilly"],
			"zones": [2, 3]
		}, {
			"name": "Turnpike Lane",
			"lines": ["Piccadilly"],
			"zones": [3]
		}, {
			"name": "Upminster",
			"lines": ["District"],
			"zones": [6]
		}, {
			"name": "Upminster Bridge",
			"lines": ["District"],
			"zones": [6]
		}, {
			"name": "Upney",
			"lines": ["District"],
			"zones": [4]
		}, {
			"name": "Upton Park",
			"lines": ["District", "Hammersmith & City"],
			"zones": [3]
		}, {
			"name": "Uxbridge",
			"lines": ["Metropolitan", "Piccadilly"],
			"zones": [6]
		}, {
			"name": "Vauxhall",
			"lines": ["Victoria"],
			"zones": [1, 2]
		}, {
			"name": "Victoria",
			"lines": ["District", "Circle", "Victoria"],
			"zones": [1]
		}, {
			"name": "Walthamstow Central",
			"lines": ["Victoria"],
			"zones": [3]
		}, {
			"name": "Wanstead",
			"lines": ["Central"],
			"zones": [4]
		}, {
			"name": "Warren Street",
			"lines": ["Northern", "Victoria"],
			"zones": [1]
		}, {
			"name": "Warwick Avenue",
			"lines": ["Bakerloo"],
			"zones": [2]
		}, {
			"name": "Waterloo",
			"lines": ["Waterloo & City", "Bakerloo", "Northern", "Jubilee"],
			"zones": [1]
		}, {
			"name": "Watford",
			"lines": ["Metropolitan"],
			"zones": [7]
		}, {
			"name": "Wembley Central",
			"lines": ["Bakerloo"],
			"zones": [4]
		}, {
			"name": "Wembley Park",
			"lines": ["Metropolitan", "Jubilee"],
			"zones": [4]
		}, {
			"name": "West Acton",
			"lines": ["Central"],
			"zones": [3]
		}, {
			"name": "West Brompton",
			"lines": ["District"],
			"zones": [2]
		}, {
			"name": "West Finchley",
			"lines": ["Northern"],
			"zones": [4]
		}, {
			"name": "West Ham",
			"lines": ["District", "Hammersmith & City", "Jubilee"],
			"zones": [3]
		}, {
			"name": "West Hampstead",
			"lines": ["Jubilee"],
			"zones": [2]
		}, {
			"name": "West Harrow",
			"lines": ["Metropolitan"],
			"zones": [5]
		}, {
			"name": "West Kensington",
			"lines": ["District"],
			"zones": [2]
		}, {
			"name": "West Ruislip",
			"lines": ["Central"],
			"zones": [6]
		}, {
			"name": "Westbourne Park",
			"lines": ["Hammersmith & City", "Circle"],
			"zones": [2]
		}, {
			"name": "Westminster",
			"lines": ["District", "Circle", "Jubilee"],
			"zones": [1]
		}, {
			"name": "White City",
			"lines": ["Central"],
			"zones": [2]
		}, {
			"name": "Whitechapel",
			"lines": ["District", "Hammersmith & City"],
			"zones": [2]
		}, {
			"name": "Willesden Green",
			"lines": ["Jubilee"],
			"zones": [2, 3]
		}, {
			"name": "Willesden Junction",
			"lines": ["Bakerloo"],
			"zones": [2, 3]
		}, {
			"name": "Wimbledon",
			"lines": ["District"],
			"zones": [3]
		}, {
			"name": "Wimbledon Park",
			"lines": ["District"],
			"zones": [3]
		}, {
			"name": "Wood Green",
			"lines": ["Piccadilly"],
			"zones": [3]
		}, {
			"name": "Wood Lane",
			"lines": ["Hammersmith & City", "Circle"],
			"zones": [2]
		}, {
			"name": "Woodford",
			"lines": ["Central"],
			"zones": [4]
		}, {
			"name": "Woodside Park",
			"lines": "Northern",
			"zones": [4]
		}]
	};

/***/ },
/* 7 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
		"description": "A list of oceans and seas.",
		"source": "http://en.wikipedia.org/wiki/List_of_seas",
		"oceans": [{
			"name": "Pacific"
		}, {
			"name": "Atlantic"
		}, {
			"name": "Indian"
		}, {
			"name": "Southern"
		}, {
			"name": "Arctic"
		}],
		"seas": [{
			"name": "Amundsen Gulf"
		}, {
			"name": "Baffin Bay"
		}, {
			"name": "Barents Sea"
		}, {
			"name": "Beaufort Sea"
		}, {
			"name": "Chukchi Sea"
		}, {
			"name": "East Siberian Sea"
		}, {
			"name": "Greenland Sea"
		}, {
			"name": "Hudson Bay"
		}, {
			"name": "James Bay"
		}, {
			"name": "Kara Sea"
		}, {
			"name": "Kara Strait"
		}, {
			"name": "Laptev Sea"
		}, {
			"name": "Lincoln Sea"
		}, {
			"name": "Prince Gustav Adolf Sea"
		}, {
			"name": "Pechora Sea"
		}, {
			"name": "Wandel Sea"
		}, {
			"name": "White Sea"
		}, {
			"name": "Amundsen Sea"
		}, {
			"name": "Bass Strait"
		}, {
			"name": "Bellingshausen Sea"
		}, {
			"name": "Cooperation Sea"
		}, {
			"name": "Cosmonauts Sea"
		}, {
			"name": "Davis Sea"
		}, {
			"name": "D'Urville Sea"
		}, {
			"name": "Drake Passage"
		}, {
			"name": "Great Australian Bight"
		}, {
			"name": "Gulf St Vincent"
		}, {
			"name": "King Haakon VII Sea"
		}, {
			"name": "Lazarev Sea"
		}, {
			"name": "Mawson Sea"
		}, {
			"name": "Riiser-Larsen Sea"
		}, {
			"name": "Ross Sea"
		}, {
			"name": "Scotia Sea"
		}, {
			"name": "Somov Sea"
		}, {
			"name": "Spencer Gulf"
		}, {
			"name": "Weddell Sea"
		}, {
			"name": "Andaman Sea"
		}, {
			"name": "Arabian Sea"
		}, {
			"name": "Bay of Bengal"
		}, {
			"name": "Gulf of Aden"
		}, {
			"name": "Gulf of Oman"
		}, {
			"name": "Laccadive Sea"
		}, {
			"name": "Mozambique Channel"
		}, {
			"name": "Persian Gulf"
		}, {
			"name": "Red Sea"
		}, {
			"name": "Timor Sea"
		}, {
			"name": "Arafura Sea"
		}, {
			"name": "Bali Sea"
		}, {
			"name": "Banda Sea"
		}, {
			"name": "Bering Sea"
		}, {
			"name": "Bismarck Sea"
		}, {
			"name": "Bohai Sea"
		}, {
			"name": "Bohol Sea"
		}, {
			"name": "Mindanao Sea"
		}, {
			"name": "Camotes Sea"
		}, {
			"name": "Celebes Sea"
		}, {
			"name": "Ceram Sea"
		}, {
			"name": "Chilean Sea"
		}, {
			"name": "Sea of Chiloé"
		}, {
			"name": "Coral Sea"
		}, {
			"name": "East China Sea"
		}, {
			"name": "Flores Sea"
		}, {
			"name": "Gulf of Alaska"
		}, {
			"name": "Gulf of California"
		}, {
			"name": "Sea of Cortés"
		}, {
			"name": "Gulf of Carpentaria"
		}, {
			"name": "Gulf of Thailand"
		}, {
			"name": "Halmahera Sea"
		}, {
			"name": "Java Sea"
		}, {
			"name": "Koro Sea"
		}, {
			"name": "Mar de Grau"
		}, {
			"name": "Molucca Sea"
		}, {
			"name": "Philippine Sea"
		}, {
			"name": "Salish Sea"
		}, {
			"name": "Savu Sea"
		}, {
			"name": "Sea of Japan"
		}, {
			"name": "Sea of Okhotsk"
		}, {
			"name": "Seto Inland Sea"
		}, {
			"name": "Sibuyan Sea"
		}, {
			"name": "Solomon Sea"
		}, {
			"name": "South China Sea"
		}, {
			"name": "Sulu Sea"
		}, {
			"name": "Tasman Sea"
		}, {
			"name": "Visayan Sea"
		}, {
			"name": "Yellow Sea"
		}, {
			"name": "Aral Sea"
		}, {
			"name": "Caspian Sea"
		}, {
			"name": "Dead Sea"
		}, {
			"name": "Salton Sea"
		}, {
			"name": "Baltic Sea"
		}, {
			"name": "Archipelago Sea"
		}, {
			"name": "Bothnian Sea"
		}, {
			"name": "Central Baltic Sea"
		}, {
			"name": "Gulf of Bothnia"
		}, {
			"name": "Gulf of Finland"
		}, {
			"name": "Gulf of Riga"
		}, {
			"name": "Oresund Strait"
		}, {
			"name": "Sea of Ĺland"
		}, {
			"name": "Mediterranean Sea"
		}, {
			"name": "Aegean Sea"
		}, {
			"name": "Mirtoon Sea"
		}, {
			"name": "Sea of Crete"
		}, {
			"name": "Thracian Sea"
		}, {
			"name": "Adriatic Sea"
		}, {
			"name": "Alboran Sea"
		}, {
			"name": "Balearic Sea"
		}, {
			"name": "Catalan Sea"
		}, {
			"name": "Cilician Sea"
		}, {
			"name": "Gulf of Sidra"
		}, {
			"name": "Ionian Sea"
		}, {
			"name": "Levantine Sea"
		}, {
			"name": "Libyan Sea"
		}, {
			"name": "Ligurian Sea"
		}, {
			"name": "Sea of Sardinia"
		}, {
			"name": "Sea of Sicily"
		}, {
			"name": "Tyrrhenian Sea"
		}, {
			"name": "Argentine Sea"
		}, {
			"name": "Bay of Biscay"
		}, {
			"name": "Bay of Campeche"
		}, {
			"name": "Bay of Fundy"
		}, {
			"name": "Black Sea"
		}, {
			"name": "Caribbean Sea"
		}, {
			"name": "Celtic Sea"
		}, {
			"name": "Chesapeake Bay"
		}, {
			"name": "Davis Strait"
		}, {
			"name": "Denmark Strait"
		}, {
			"name": "English Channel"
		}, {
			"name": "Gulf of Guinea"
		}, {
			"name": "Gulf of Maine"
		}, {
			"name": "Gulf of Mexico"
		}, {
			"name": "Gulf of St. Lawrence"
		}, {
			"name": "Gulf of Venezuela"
		}, {
			"name": "Irish Sea"
		}, {
			"name": "Labrador Sea"
		}, {
			"name": "Marmara Sea"
		}, {
			"name": "North Sea"
		}, {
			"name": "Norwegian Sea"
		}, {
			"name": "Sargasso Sea"
		}, {
			"name": "Sea of Azov"
		}, {
			"name": "Sea of the Hebrides"
		}, {
			"name": "Wadden Sea"
		}]
	};

/***/ },
/* 8 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
		"description": "Top 1000 U.S. cities by 2013 population",
		"cities": [{
			"city": "New York",
			"state": "New York",
			"population": "8,405,837"
		}, {
			"city": "Los Angeles",
			"state": "California",
			"population": "3,884,307"
		}, {
			"city": "Chicago",
			"state": "Illinois",
			"population": "2,718,782"
		}, {
			"city": "Houston",
			"state": "Texas",
			"population": "2,195,914"
		}, {
			"city": "Philadelphia",
			"state": "Pennsylvania",
			"population": "1,553,165"
		}, {
			"city": "Phoenix",
			"state": "Arizona",
			"population": "1,513,367"
		}, {
			"city": "San Antonio",
			"state": "Texas",
			"population": "1,409,019"
		}, {
			"city": "San Diego",
			"state": "California",
			"population": "1,355,896"
		}, {
			"city": "Dallas",
			"state": "Texas",
			"population": "1,257,676"
		}, {
			"city": "San Jose",
			"state": "California",
			"population": "998,537"
		}, {
			"city": "Austin",
			"state": "Texas",
			"population": "885,400"
		}, {
			"city": "Indianapolis",
			"state": "Indiana",
			"population": "843,393"
		}, {
			"city": "Jacksonville",
			"state": "Florida",
			"population": "842,583"
		}, {
			"city": "San Francisco",
			"state": "California",
			"population": "837,442"
		}, {
			"city": "Columbus",
			"state": "Ohio",
			"population": "822,553"
		}, {
			"city": "Charlotte",
			"state": "North Carolina",
			"population": "792,862"
		}, {
			"city": "Fort Worth",
			"state": "Texas",
			"population": "792,727"
		}, {
			"city": "Detroit",
			"state": "Michigan",
			"population": "688,701"
		}, {
			"city": "El Paso",
			"state": "Texas",
			"population": "674,433"
		}, {
			"city": "Memphis",
			"state": "Tennessee",
			"population": "653,450"
		}, {
			"city": "Seattle",
			"state": "Washington",
			"population": "652,405"
		}, {
			"city": "Denver",
			"state": "Colorado",
			"population": "649,495"
		}, {
			"city": "Washington",
			"state": "District of Columbia",
			"population": "646,449"
		}, {
			"city": "Boston",
			"state": "Massachusetts",
			"population": "645,966"
		}, {
			"city": "Nashville-Davidson",
			"state": "Tennessee",
			"population": "634,464"
		}, {
			"city": "Baltimore",
			"state": "Maryland",
			"population": "622,104"
		}, {
			"city": "Oklahoma City",
			"state": "Oklahoma",
			"population": "610,613"
		}, {
			"city": "Louisville/Jefferson County",
			"state": "Kentucky",
			"population": "609,893"
		}, {
			"city": "Portland",
			"state": "Oregon",
			"population": "609,456"
		}, {
			"city": "Las Vegas",
			"state": "Nevada",
			"population": "603,488"
		}, {
			"city": "Milwaukee",
			"state": "Wisconsin",
			"population": "599,164"
		}, {
			"city": "Albuquerque",
			"state": "New Mexico",
			"population": "556,495"
		}, {
			"city": "Tucson",
			"state": "Arizona",
			"population": "526,116"
		}, {
			"city": "Fresno",
			"state": "California",
			"population": "509,924"
		}, {
			"city": "Sacramento",
			"state": "California",
			"population": "479,686"
		}, {
			"city": "Long Beach",
			"state": "California",
			"population": "469,428"
		}, {
			"city": "Kansas City",
			"state": "Missouri",
			"population": "467,007"
		}, {
			"city": "Mesa",
			"state": "Arizona",
			"population": "457,587"
		}, {
			"city": "Virginia Beach",
			"state": "Virginia",
			"population": "448,479"
		}, {
			"city": "Atlanta",
			"state": "Georgia",
			"population": "447,841"
		}, {
			"city": "Colorado Springs",
			"state": "Colorado",
			"population": "439,886"
		}, {
			"city": "Omaha",
			"state": "Nebraska",
			"population": "434,353"
		}, {
			"city": "Raleigh",
			"state": "North Carolina",
			"population": "431,746"
		}, {
			"city": "Miami",
			"state": "Florida",
			"population": "417,650"
		}, {
			"city": "Oakland",
			"state": "California",
			"population": "406,253"
		}, {
			"city": "Minneapolis",
			"state": "Minnesota",
			"population": "400,070"
		}, {
			"city": "Tulsa",
			"state": "Oklahoma",
			"population": "398,121"
		}, {
			"city": "Cleveland",
			"state": "Ohio",
			"population": "390,113"
		}, {
			"city": "Wichita",
			"state": "Kansas",
			"population": "386,552"
		}, {
			"city": "Arlington",
			"state": "Texas",
			"population": "379,577"
		}, {
			"city": "New Orleans",
			"state": "Louisiana",
			"population": "378,715"
		}, {
			"city": "Bakersfield",
			"state": "California",
			"population": "363,630"
		}, {
			"city": "Tampa",
			"state": "Florida",
			"population": "352,957"
		}, {
			"city": "Honolulu",
			"state": "Hawaii",
			"population": "347,884"
		}, {
			"city": "Aurora",
			"state": "Colorado",
			"population": "345,803"
		}, {
			"city": "Anaheim",
			"state": "California",
			"population": "345,012"
		}, {
			"city": "Santa Ana",
			"state": "California",
			"population": "334,227"
		}, {
			"city": "St. Louis",
			"state": "Missouri",
			"population": "318,416"
		}, {
			"city": "Riverside",
			"state": "California",
			"population": "316,619"
		}, {
			"city": "Corpus Christi",
			"state": "Texas",
			"population": "316,381"
		}, {
			"city": "Lexington-Fayette",
			"state": "Kentucky",
			"population": "308,428"
		}, {
			"city": "Pittsburgh",
			"state": "Pennsylvania",
			"population": "305,841"
		}, {
			"city": "Anchorage",
			"state": "Alaska",
			"population": "300,950"
		}, {
			"city": "Stockton",
			"state": "California",
			"population": "298,118"
		}, {
			"city": "Cincinnati",
			"state": "Ohio",
			"population": "297,517"
		}, {
			"city": "St. Paul",
			"state": "Minnesota",
			"population": "294,873"
		}, {
			"city": "Toledo",
			"state": "Ohio",
			"population": "282,313"
		}, {
			"city": "Greensboro",
			"state": "North Carolina",
			"population": "279,639"
		}, {
			"city": "Newark",
			"state": "New Jersey",
			"population": "278,427"
		}, {
			"city": "Plano",
			"state": "Texas",
			"population": "274,409"
		}, {
			"city": "Henderson",
			"state": "Nevada",
			"population": "270,811"
		}, {
			"city": "Lincoln",
			"state": "Nebraska",
			"population": "268,738"
		}, {
			"city": "Buffalo",
			"state": "New York",
			"population": "258,959"
		}, {
			"city": "Jersey City",
			"state": "New Jersey",
			"population": "257,342"
		}, {
			"city": "Chula Vista",
			"state": "California",
			"population": "256,780"
		}, {
			"city": "Fort Wayne",
			"state": "Indiana",
			"population": "256,496"
		}, {
			"city": "Orlando",
			"state": "Florida",
			"population": "255,483"
		}, {
			"city": "St. Petersburg",
			"state": "Florida",
			"population": "249,688"
		}, {
			"city": "Chandler",
			"state": "Arizona",
			"population": "249,146"
		}, {
			"city": "Laredo",
			"state": "Texas",
			"population": "248,142"
		}, {
			"city": "Norfolk",
			"state": "Virginia",
			"population": "246,139"
		}, {
			"city": "Durham",
			"state": "North Carolina",
			"population": "245,475"
		}, {
			"city": "Madison",
			"state": "Wisconsin",
			"population": "243,344"
		}, {
			"city": "Lubbock",
			"state": "Texas",
			"population": "239,538"
		}, {
			"city": "Irvine",
			"state": "California",
			"population": "236,716"
		}, {
			"city": "Winston-Salem",
			"state": "North Carolina",
			"population": "236,441"
		}, {
			"city": "Glendale",
			"state": "Arizona",
			"population": "234,632"
		}, {
			"city": "Garland",
			"state": "Texas",
			"population": "234,566"
		}, {
			"city": "Hialeah",
			"state": "Florida",
			"population": "233,394"
		}, {
			"city": "Reno",
			"state": "Nevada",
			"population": "233,294"
		}, {
			"city": "Chesapeake",
			"state": "Virginia",
			"population": "230,571"
		}, {
			"city": "Gilbert",
			"state": "Arizona",
			"population": "229,972"
		}, {
			"city": "Baton Rouge",
			"state": "Louisiana",
			"population": "229,426"
		}, {
			"city": "Irving",
			"state": "Texas",
			"population": "228,653"
		}, {
			"city": "Scottsdale",
			"state": "Arizona",
			"population": "226,918"
		}, {
			"city": "North Las Vegas",
			"state": "Nevada",
			"population": "226,877"
		}, {
			"city": "Fremont",
			"state": "California",
			"population": "224,922"
		}, {
			"city": "Boise City",
			"state": "Idaho",
			"population": "214,236"
		}, {
			"city": "Richmond",
			"state": "Virginia",
			"population": "214,114"
		}, {
			"city": "San Bernardino",
			"state": "California",
			"population": "213,708"
		}, {
			"city": "Birmingham",
			"state": "Alabama",
			"population": "212,113"
		}, {
			"city": "Spokane",
			"state": "Washington",
			"population": "210,721"
		}, {
			"city": "Rochester",
			"state": "New York",
			"population": "210,358"
		}, {
			"city": "Des Moines",
			"state": "Iowa",
			"population": "207,510"
		}, {
			"city": "Modesto",
			"state": "California",
			"population": "204,933"
		}, {
			"city": "Fayetteville",
			"state": "North Carolina",
			"population": "204,408"
		}, {
			"city": "Tacoma",
			"state": "Washington",
			"population": "203,446"
		}, {
			"city": "Oxnard",
			"state": "California",
			"population": "203,007"
		}, {
			"city": "Fontana",
			"state": "California",
			"population": "203,003"
		}, {
			"city": "Columbus",
			"state": "Georgia",
			"population": "202,824"
		}, {
			"city": "Montgomery",
			"state": "Alabama",
			"population": "201,332"
		}, {
			"city": "Moreno Valley",
			"state": "California",
			"population": "201,175"
		}, {
			"city": "Shreveport",
			"state": "Louisiana",
			"population": "200,327"
		}, {
			"city": "Aurora",
			"state": "Illinois",
			"population": "199,963"
		}, {
			"city": "Yonkers",
			"state": "New York",
			"population": "199,766"
		}, {
			"city": "Akron",
			"state": "Ohio",
			"population": "198,100"
		}, {
			"city": "Huntington Beach",
			"state": "California",
			"population": "197,575"
		}, {
			"city": "Little Rock",
			"state": "Arkansas",
			"population": "197,357"
		}, {
			"city": "Augusta-Richmond County",
			"state": "Georgia",
			"population": "197,350"
		}, {
			"city": "Amarillo",
			"state": "Texas",
			"population": "196,429"
		}, {
			"city": "Glendale",
			"state": "California",
			"population": "196,021"
		}, {
			"city": "Mobile",
			"state": "Alabama",
			"population": "194,899"
		}, {
			"city": "Grand Rapids",
			"state": "Michigan",
			"population": "192,294"
		}, {
			"city": "Salt Lake City",
			"state": "Utah",
			"population": "191,180"
		}, {
			"city": "Tallahassee",
			"state": "Florida",
			"population": "186,411"
		}, {
			"city": "Huntsville",
			"state": "Alabama",
			"population": "186,254"
		}, {
			"city": "Grand Prairie",
			"state": "Texas",
			"population": "183,372"
		}, {
			"city": "Knoxville",
			"state": "Tennessee",
			"population": "183,270"
		}, {
			"city": "Worcester",
			"state": "Massachusetts",
			"population": "182,544"
		}, {
			"city": "Newport News",
			"state": "Virginia",
			"population": "182,020"
		}, {
			"city": "Brownsville",
			"state": "Texas",
			"population": "181,860"
		}, {
			"city": "Overland Park",
			"state": "Kansas",
			"population": "181,260"
		}, {
			"city": "Santa Clarita",
			"state": "California",
			"population": "179,590"
		}, {
			"city": "Providence",
			"state": "Rhode Island",
			"population": "177,990"
		}, {
			"city": "Garden Grove",
			"state": "California",
			"population": "175,140"
		}, {
			"city": "Chattanooga",
			"state": "Tennessee",
			"population": "173,360"
		}, {
			"city": "Oceanside",
			"state": "California",
			"population": "172,790"
		}, {
			"city": "Jackson",
			"state": "Mississippi",
			"population": "172,638"
		}, {
			"city": "Fort Lauderdale",
			"state": "Florida",
			"population": "172,380"
		}, {
			"city": "Santa Rosa",
			"state": "California",
			"population": "171,990"
		}, {
			"city": "Rancho Cucamonga",
			"state": "California",
			"population": "171,380"
		}, {
			"city": "Port St. Lucie",
			"state": "Florida",
			"population": "171,010"
		}, {
			"city": "Tempe",
			"state": "Arizona",
			"population": "168,220"
		}, {
			"city": "Ontario",
			"state": "California",
			"population": "167,500"
		}, {
			"city": "Vancouver",
			"state": "Washington",
			"population": "167,400"
		}, {
			"city": "Cape Coral",
			"state": "Florida",
			"population": "165,830"
		}, {
			"city": "Sioux Falls",
			"state": "South Dakota",
			"population": "164,670"
		}, {
			"city": "Springfield",
			"state": "Missouri",
			"population": "164,120"
		}, {
			"city": "Peoria",
			"state": "Arizona",
			"population": "162,590"
		}, {
			"city": "Pembroke Pines",
			"state": "Florida",
			"population": "162,320"
		}, {
			"city": "Elk Grove",
			"state": "California",
			"population": "161,000"
		}, {
			"city": "Salem",
			"state": "Oregon",
			"population": "160,610"
		}, {
			"city": "Lancaster",
			"state": "California",
			"population": "159,520"
		}, {
			"city": "Corona",
			"state": "California",
			"population": "159,500"
		}, {
			"city": "Eugene",
			"state": "Oregon",
			"population": "159,190"
		}, {
			"city": "Palmdale",
			"state": "California",
			"population": "157,160"
		}, {
			"city": "Salinas",
			"state": "California",
			"population": "155,660"
		}, {
			"city": "Springfield",
			"state": "Massachusetts",
			"population": "153,700"
		}, {
			"city": "Pasadena",
			"state": "Texas",
			"population": "152,730"
		}, {
			"city": "Fort Collins",
			"state": "Colorado",
			"population": "152,060"
		}, {
			"city": "Hayward",
			"state": "California",
			"population": "151,570"
		}, {
			"city": "Pomona",
			"state": "California",
			"population": "151,340"
		}, {
			"city": "Cary",
			"state": "North Carolina",
			"population": "151,080"
		}, {
			"city": "Rockford",
			"state": "Illinois",
			"population": "150,251"
		}, {
			"city": "Alexandria",
			"state": "Virginia",
			"population": "148,890"
		}, {
			"city": "Escondido",
			"state": "California",
			"population": "148,730"
		}, {
			"city": "McKinney",
			"state": "Texas",
			"population": "148,550"
		}, {
			"city": "Kansas City",
			"state": "Kansas",
			"population": "148,480"
		}, {
			"city": "Joliet",
			"state": "Illinois",
			"population": "147,800"
		}, {
			"city": "Sunnyvale",
			"state": "California",
			"population": "147,550"
		}, {
			"city": "Torrance",
			"state": "California",
			"population": "147,470"
		}, {
			"city": "Bridgeport",
			"state": "Connecticut",
			"population": "147,210"
		}, {
			"city": "Lakewood",
			"state": "Colorado",
			"population": "147,210"
		}, {
			"city": "Hollywood",
			"state": "Florida",
			"population": "146,520"
		}, {
			"city": "Paterson",
			"state": "New Jersey",
			"population": "145,948"
		}, {
			"city": "Naperville",
			"state": "Illinois",
			"population": "144,860"
		}, {
			"city": "Syracuse",
			"state": "New York",
			"population": "144,669"
		}, {
			"city": "Mesquite",
			"state": "Texas",
			"population": "143,480"
		}, {
			"city": "Dayton",
			"state": "Ohio",
			"population": "143,355"
		}, {
			"city": "Savannah",
			"state": "Georgia",
			"population": "142,770"
		}, {
			"city": "Clarksville",
			"state": "Tennessee",
			"population": "142,350"
		}, {
			"city": "Orange",
			"state": "California",
			"population": "139,960"
		}, {
			"city": "Pasadena",
			"state": "California",
			"population": "139,730"
		}, {
			"city": "Fullerton",
			"state": "California",
			"population": "138,980"
		}, {
			"city": "Killeen",
			"state": "Texas",
			"population": "137,140"
		}, {
			"city": "Frisco",
			"state": "Texas",
			"population": "136,790"
		}, {
			"city": "Hampton",
			"state": "Virginia",
			"population": "136,699"
		}, {
			"city": "McAllen",
			"state": "Texas",
			"population": "136,630"
		}, {
			"city": "Warren",
			"state": "Michigan",
			"population": "134,873"
		}, {
			"city": "Bellevue",
			"state": "Washington",
			"population": "133,990"
		}, {
			"city": "West Valley City",
			"state": "Utah",
			"population": "133,570"
		}, {
			"city": "Columbia",
			"state": "South Carolina",
			"population": "133,350"
		}, {
			"city": "Olathe",
			"state": "Kansas",
			"population": "131,880"
		}, {
			"city": "Sterling Heights",
			"state": "Michigan",
			"population": "131,220"
		}, {
			"city": "New Haven",
			"state": "Connecticut",
			"population": "130,660"
		}, {
			"city": "Miramar",
			"state": "Florida",
			"population": "130,280"
		}, {
			"city": "Waco",
			"state": "Texas",
			"population": "129,030"
		}, {
			"city": "Thousand Oaks",
			"state": "California",
			"population": "128,730"
		}, {
			"city": "Cedar Rapids",
			"state": "Iowa",
			"population": "128,420"
		}, {
			"city": "Charleston",
			"state": "South Carolina",
			"population": "127,990"
		}, {
			"city": "Visalia",
			"state": "California",
			"population": "127,760"
		}, {
			"city": "Topeka",
			"state": "Kansas",
			"population": "127,670"
		}, {
			"city": "Elizabeth",
			"state": "New Jersey",
			"population": "127,550"
		}, {
			"city": "Gainesville",
			"state": "Florida",
			"population": "127,480"
		}, {
			"city": "Thornton",
			"state": "Colorado",
			"population": "127,350"
		}, {
			"city": "Roseville",
			"state": "California",
			"population": "127,030"
		}, {
			"city": "Carrollton",
			"state": "Texas",
			"population": "126,700"
		}, {
			"city": "Coral Springs",
			"state": "Florida",
			"population": "126,600"
		}, {
			"city": "Stamford",
			"state": "Connecticut",
			"population": "126,450"
		}, {
			"city": "Simi Valley",
			"state": "California",
			"population": "126,180"
		}, {
			"city": "Concord",
			"state": "California",
			"population": "125,880"
		}, {
			"city": "Hartford",
			"state": "Connecticut",
			"population": "125,010"
		}, {
			"city": "Kent",
			"state": "Washington",
			"population": "124,430"
		}, {
			"city": "Lafayette",
			"state": "Louisiana",
			"population": "124,270"
		}, {
			"city": "Midland",
			"state": "Texas",
			"population": "123,930"
		}, {
			"city": "Surprise",
			"state": "Arizona",
			"population": "123,540"
		}, {
			"city": "Denton",
			"state": "Texas",
			"population": "123,090"
		}, {
			"city": "Victorville",
			"state": "California",
			"population": "121,090"
		}, {
			"city": "Evansville",
			"state": "Indiana",
			"population": "120,310"
		}, {
			"city": "Santa Clara",
			"state": "California",
			"population": "120,240"
		}, {
			"city": "Abilene",
			"state": "Texas",
			"population": "120,090"
		}, {
			"city": "Athens-Clarke County",
			"state": "Georgia",
			"population": "119,980"
		}, {
			"city": "Vallejo",
			"state": "California",
			"population": "118,830"
		}, {
			"city": "Allentown",
			"state": "Pennsylvania",
			"population": "118,570"
		}, {
			"city": "Norman",
			"state": "Oklahoma",
			"population": "118,190"
		}, {
			"city": "Beaumont",
			"state": "Texas",
			"population": "117,790"
		}, {
			"city": "Independence",
			"state": "Missouri",
			"population": "117,240"
		}, {
			"city": "Murfreesboro",
			"state": "Tennessee",
			"population": "117,040"
		}, {
			"city": "Ann Arbor",
			"state": "Michigan",
			"population": "117,020"
		}, {
			"city": "Springfield",
			"state": "Illinois",
			"population": "117,000"
		}, {
			"city": "Berkeley",
			"state": "California",
			"population": "116,760"
		}, {
			"city": "Peoria",
			"state": "Illinois",
			"population": "116,510"
		}, {
			"city": "Provo",
			"state": "Utah",
			"population": "116,280"
		}, {
			"city": "El Monte",
			"state": "California",
			"population": "115,708"
		}, {
			"city": "Columbia",
			"state": "Missouri",
			"population": "115,270"
		}, {
			"city": "Lansing",
			"state": "Michigan",
			"population": "113,972"
		}, {
			"city": "Fargo",
			"state": "North Dakota",
			"population": "113,650"
		}, {
			"city": "Downey",
			"state": "California",
			"population": "113,240"
		}, {
			"city": "Costa Mesa",
			"state": "California",
			"population": "112,170"
		}, {
			"city": "Wilmington",
			"state": "North Carolina",
			"population": "112,060"
		}, {
			"city": "Arvada",
			"state": "Colorado",
			"population": "111,700"
		}, {
			"city": "Inglewood",
			"state": "California",
			"population": "111,542"
		}, {
			"city": "Miami Gardens",
			"state": "Florida",
			"population": "111,370"
		}, {
			"city": "Carlsbad",
			"state": "California",
			"population": "110,970"
		}, {
			"city": "Westminster",
			"state": "Colorado",
			"population": "110,940"
		}, {
			"city": "Rochester",
			"state": "Minnesota",
			"population": "110,740"
		}, {
			"city": "Odessa",
			"state": "Texas",
			"population": "110,720"
		}, {
			"city": "Manchester",
			"state": "New Hampshire",
			"population": "110,370"
		}, {
			"city": "Elgin",
			"state": "Illinois",
			"population": "110,140"
		}, {
			"city": "West Jordan",
			"state": "Utah",
			"population": "110,070"
		}, {
			"city": "Round Rock",
			"state": "Texas",
			"population": "109,820"
		}, {
			"city": "Clearwater",
			"state": "Florida",
			"population": "109,700"
		}, {
			"city": "Waterbury",
			"state": "Connecticut",
			"population": "109,670"
		}, {
			"city": "Gresham",
			"state": "Oregon",
			"population": "109,390"
		}, {
			"city": "Fairfield",
			"state": "California",
			"population": "109,320"
		}, {
			"city": "Billings",
			"state": "Montana",
			"population": "109,050"
		}, {
			"city": "Lowell",
			"state": "Massachusetts",
			"population": "108,860"
		}, {
			"city": "San Buenaventura (Ventura)",
			"state": "California",
			"population": "108,810"
		}, {
			"city": "Pueblo",
			"state": "Colorado",
			"population": "108,240"
		}, {
			"city": "High Point",
			"state": "North Carolina",
			"population": "107,740"
		}, {
			"city": "West Covina",
			"state": "California",
			"population": "107,740"
		}, {
			"city": "Richmond",
			"state": "California",
			"population": "107,570"
		}, {
			"city": "Murrieta",
			"state": "California",
			"population": "107,470"
		}, {
			"city": "Cambridge",
			"state": "Massachusetts",
			"population": "107,280"
		}, {
			"city": "Antioch",
			"state": "California",
			"population": "107,100"
		}, {
			"city": "Temecula",
			"state": "California",
			"population": "106,780"
		}, {
			"city": "Norwalk",
			"state": "California",
			"population": "106,580"
		}, {
			"city": "Centennial",
			"state": "Colorado",
			"population": "106,110"
		}, {
			"city": "Everett",
			"state": "Washington",
			"population": "105,370"
		}, {
			"city": "Palm Bay",
			"state": "Florida",
			"population": "104,890"
		}, {
			"city": "Wichita Falls",
			"state": "Texas",
			"population": "104,890"
		}, {
			"city": "Green Bay",
			"state": "Wisconsin",
			"population": "104,770"
		}, {
			"city": "Daly City",
			"state": "California",
			"population": "104,730"
		}, {
			"city": "Burbank",
			"state": "California",
			"population": "104,700"
		}, {
			"city": "Richardson",
			"state": "Texas",
			"population": "104,470"
		}, {
			"city": "Pompano Beach",
			"state": "Florida",
			"population": "104,410"
		}, {
			"city": "North Charleston",
			"state": "South Carolina",
			"population": "104,050"
		}, {
			"city": "Broken Arrow",
			"state": "Oklahoma",
			"population": "103,500"
		}, {
			"city": "Boulder",
			"state": "Colorado",
			"population": "103,160"
		}, {
			"city": "West Palm Beach",
			"state": "Florida",
			"population": "102,430"
		}, {
			"city": "Santa Maria",
			"state": "California",
			"population": "102,210"
		}, {
			"city": "El Cajon",
			"state": "California",
			"population": "102,210"
		}, {
			"city": "Davenport",
			"state": "Iowa",
			"population": "102,150"
		}, {
			"city": "Rialto",
			"state": "California",
			"population": "101,910"
		}, {
			"city": "Las Cruces",
			"state": "New Mexico",
			"population": "101,320"
		}, {
			"city": "San Mateo",
			"state": "California",
			"population": "101,120"
		}, {
			"city": "Lewisville",
			"state": "Texas",
			"population": "101,070"
		}, {
			"city": "South Bend",
			"state": "Indiana",
			"population": "100,886"
		}, {
			"city": "Lakeland",
			"state": "Florida",
			"population": "100,710"
		}, {
			"city": "Erie",
			"state": "Pennsylvania",
			"population": "100,671"
		}, {
			"city": "Tyler",
			"state": "Texas",
			"population": "100,220"
		}, {
			"city": "Pearland",
			"state": "Texas",
			"population": "100,060"
		}, {
			"city": "College Station",
			"state": "Texas",
			"population": "100,050"
		}, {
			"city": "Kenosha",
			"state": "Wisconsin",
			"population": "99,8890"
		}, {
			"city": "Sandy Springs",
			"state": "Georgia",
			"population": "99,7700"
		}, {
			"city": "Clovis",
			"state": "California",
			"population": "99,769"
		}, {
			"city": "Flint",
			"state": "Michigan",
			"population": "99,763"
		}, {
			"city": "Roanoke",
			"state": "Virginia",
			"population": "98,465"
		}, {
			"city": "Albany",
			"state": "New York",
			"population": "98,424"
		}, {
			"city": "Jurupa Valley",
			"state": "California",
			"population": "98,030"
		}, {
			"city": "Compton",
			"state": "California",
			"population": "97,877"
		}, {
			"city": "San Angelo",
			"state": "Texas",
			"population": "97,492"
		}, {
			"city": "Hillsboro",
			"state": "Oregon",
			"population": "97,368"
		}, {
			"city": "Lawton",
			"state": "Oklahoma",
			"population": "97,151"
		}, {
			"city": "Renton",
			"state": "Washington",
			"population": "97,003"
		}, {
			"city": "Vista",
			"state": "California",
			"population": "96,929"
		}, {
			"city": "Davie",
			"state": "Florida",
			"population": "96,830"
		}, {
			"city": "Greeley",
			"state": "Colorado",
			"population": "96,539"
		}, {
			"city": "Mission Viejo",
			"state": "California",
			"population": "96,346"
		}, {
			"city": "Portsmouth",
			"state": "Virginia",
			"population": "96,205"
		}, {
			"city": "Dearborn",
			"state": "Michigan",
			"population": "95,884"
		}, {
			"city": "South Gate",
			"state": "California",
			"population": "95,677"
		}, {
			"city": "Tuscaloosa",
			"state": "Alabama",
			"population": "95,334"
		}, {
			"city": "Livonia",
			"state": "Michigan",
			"population": "95,208"
		}, {
			"city": "New Bedford",
			"state": "Massachusetts",
			"population": "95,078"
		}, {
			"city": "Vacaville",
			"state": "California",
			"population": "94,275"
		}, {
			"city": "Brockton",
			"state": "Massachusetts",
			"population": "94,089"
		}, {
			"city": "Roswell",
			"state": "Georgia",
			"population": "94,034"
		}, {
			"city": "Beaverton",
			"state": "Oregon",
			"population": "93,542"
		}, {
			"city": "Quincy",
			"state": "Massachusetts",
			"population": "93,494"
		}, {
			"city": "Sparks",
			"state": "Nevada",
			"population": "93,282"
		}, {
			"city": "Yakima",
			"state": "Washington",
			"population": "93,257"
		}, {
			"city": "Lee's Summit",
			"state": "Missouri",
			"population": "93,184"
		}, {
			"city": "Federal Way",
			"state": "Washington",
			"population": "92,734"
		}, {
			"city": "Carson",
			"state": "California",
			"population": "92,599"
		}, {
			"city": "Santa Monica",
			"state": "California",
			"population": "92,472"
		}, {
			"city": "Hesperia",
			"state": "California",
			"population": "92,147"
		}, {
			"city": "Allen",
			"state": "Texas",
			"population": "92,020"
		}, {
			"city": "Rio Rancho",
			"state": "New Mexico",
			"population": "91,956"
		}, {
			"city": "Yuma",
			"state": "Arizona",
			"population": "91,923"
		}, {
			"city": "Westminster",
			"state": "California",
			"population": "91,739"
		}, {
			"city": "Orem",
			"state": "Utah",
			"population": "91,648"
		}, {
			"city": "Lynn",
			"state": "Massachusetts",
			"population": "91,589"
		}, {
			"city": "Redding",
			"state": "California",
			"population": "91,119"
		}, {
			"city": "Spokane Valley",
			"state": "Washington",
			"population": "91,113"
		}, {
			"city": "Miami Beach",
			"state": "Florida",
			"population": "91,026"
		}, {
			"city": "League City",
			"state": "Texas",
			"population": "90,983"
		}, {
			"city": "Lawrence",
			"state": "Kansas",
			"population": "90,811"
		}, {
			"city": "Santa Barbara",
			"state": "California",
			"population": "90,412"
		}, {
			"city": "Plantation",
			"state": "Florida",
			"population": "90,268"
		}, {
			"city": "Sandy",
			"state": "Utah",
			"population": "90,231"
		}, {
			"city": "Sunrise",
			"state": "Florida",
			"population": "90,116"
		}, {
			"city": "Macon",
			"state": "Georgia",
			"population": "89,981"
		}, {
			"city": "Longmont",
			"state": "Colorado",
			"population": "89,919"
		}, {
			"city": "Boca Raton",
			"state": "Florida",
			"population": "89,407"
		}, {
			"city": "San Marcos",
			"state": "California",
			"population": "89,387"
		}, {
			"city": "Greenville",
			"state": "North Carolina",
			"population": "89,130"
		}, {
			"city": "Waukegan",
			"state": "Illinois",
			"population": "88,826"
		}, {
			"city": "Fall River",
			"state": "Massachusetts",
			"population": "88,697"
		}, {
			"city": "Chico",
			"state": "California",
			"population": "88,077"
		}, {
			"city": "Newton",
			"state": "Massachusetts",
			"population": "87,971"
		}, {
			"city": "San Leandro",
			"state": "California",
			"population": "87,965"
		}, {
			"city": "Reading",
			"state": "Pennsylvania",
			"population": "87,893"
		}, {
			"city": "Norwalk",
			"state": "Connecticut",
			"population": "87,776"
		}, {
			"city": "Fort Smith",
			"state": "Arkansas",
			"population": "87,650"
		}, {
			"city": "Newport Beach",
			"state": "California",
			"population": "87,273"
		}, {
			"city": "Asheville",
			"state": "North Carolina",
			"population": "87,236"
		}, {
			"city": "Nashua",
			"state": "New Hampshire",
			"population": "87,137"
		}, {
			"city": "Edmond",
			"state": "Oklahoma",
			"population": "87,004"
		}, {
			"city": "Whittier",
			"state": "California",
			"population": "86,635"
		}, {
			"city": "Nampa",
			"state": "Idaho",
			"population": "86,518"
		}, {
			"city": "Bloomington",
			"state": "Minnesota",
			"population": "86,319"
		}, {
			"city": "Deltona",
			"state": "Florida",
			"population": "86,290"
		}, {
			"city": "Hawthorne",
			"state": "California",
			"population": "86,199"
		}, {
			"city": "Duluth",
			"state": "Minnesota",
			"population": "86,128"
		}, {
			"city": "Carmel",
			"state": "Indiana",
			"population": "85,927"
		}, {
			"city": "Suffolk",
			"state": "Virginia",
			"population": "85,728"
		}, {
			"city": "Clifton",
			"state": "New Jersey",
			"population": "85,390"
		}, {
			"city": "Citrus Heights",
			"state": "California",
			"population": "85,285"
		}, {
			"city": "Livermore",
			"state": "California",
			"population": "85,156"
		}, {
			"city": "Tracy",
			"state": "California",
			"population": "84,691"
		}, {
			"city": "Alhambra",
			"state": "California",
			"population": "84,577"
		}, {
			"city": "Kirkland",
			"state": "Washington",
			"population": "84,430"
		}, {
			"city": "Trenton",
			"state": "New Jersey",
			"population": "84,349"
		}, {
			"city": "Ogden",
			"state": "Utah",
			"population": "84,249"
		}, {
			"city": "Hoover",
			"state": "Alabama",
			"population": "84,126"
		}, {
			"city": "Cicero",
			"state": "Illinois",
			"population": "84,103"
		}, {
			"city": "Fishers",
			"state": "Indiana",
			"population": "83,891"
		}, {
			"city": "Sugar Land",
			"state": "Texas",
			"population": "83,860"
		}, {
			"city": "Danbury",
			"state": "Connecticut",
			"population": "83,684"
		}, {
			"city": "Meridian",
			"state": "Idaho",
			"population": "83,596"
		}, {
			"city": "Indio",
			"state": "California",
			"population": "83,539"
		}, {
			"city": "Concord",
			"state": "North Carolina",
			"population": "83,506"
		}, {
			"city": "Menifee",
			"state": "California",
			"population": "83,447"
		}, {
			"city": "Champaign",
			"state": "Illinois",
			"population": "83,424"
		}, {
			"city": "Buena Park",
			"state": "California",
			"population": "82,882"
		}, {
			"city": "Troy",
			"state": "Michigan",
			"population": "82,821"
		}, {
			"city": "O'Fallon",
			"state": "Missouri",
			"population": "82,809"
		}, {
			"city": "Johns Creek",
			"state": "Georgia",
			"population": "82,788"
		}, {
			"city": "Bellingham",
			"state": "Washington",
			"population": "82,631"
		}, {
			"city": "Westland",
			"state": "Michigan",
			"population": "82,578"
		}, {
			"city": "Bloomington",
			"state": "Indiana",
			"population": "82,575"
		}, {
			"city": "Sioux City",
			"state": "Iowa",
			"population": "82,459"
		}, {
			"city": "Warwick",
			"state": "Rhode Island",
			"population": "81,971"
		}, {
			"city": "Hemet",
			"state": "California",
			"population": "81,750"
		}, {
			"city": "Longview",
			"state": "Texas",
			"population": "81,443"
		}, {
			"city": "Farmington Hills",
			"state": "Michigan",
			"population": "81,295"
		}, {
			"city": "Bend",
			"state": "Oregon",
			"population": "81,236"
		}, {
			"city": "Lakewood",
			"state": "California",
			"population": "81,121"
		}, {
			"city": "Merced",
			"state": "California",
			"population": "81,102"
		}, {
			"city": "Mission",
			"state": "Texas",
			"population": "81,050"
		}, {
			"city": "Chino",
			"state": "California",
			"population": "80,988"
		}, {
			"city": "Redwood City",
			"state": "California",
			"population": "80,872"
		}, {
			"city": "Edinburg",
			"state": "Texas",
			"population": "80,836"
		}, {
			"city": "Cranston",
			"state": "Rhode Island",
			"population": "80,566"
		}, {
			"city": "Parma",
			"state": "Ohio",
			"population": "80,429"
		}, {
			"city": "New Rochelle",
			"state": "New York",
			"population": "79,446"
		}, {
			"city": "Lake Forest",
			"state": "California",
			"population": "79,312"
		}, {
			"city": "Napa",
			"state": "California",
			"population": "79,068"
		}, {
			"city": "Hammond",
			"state": "Indiana",
			"population": "78,967"
		}, {
			"city": "Fayetteville",
			"state": "Arkansas",
			"population": "78,960"
		}, {
			"city": "Bloomington",
			"state": "Illinois",
			"population": "78,902"
		}, {
			"city": "Avondale",
			"state": "Arizona",
			"population": "78,822"
		}, {
			"city": "Somerville",
			"state": "Massachusetts",
			"population": "78,804"
		}, {
			"city": "Palm Coast",
			"state": "Florida",
			"population": "78,740"
		}, {
			"city": "Bryan",
			"state": "Texas",
			"population": "78,709"
		}, {
			"city": "Gary",
			"state": "Indiana",
			"population": "78,450"
		}, {
			"city": "Largo",
			"state": "Florida",
			"population": "78,409"
		}, {
			"city": "Brooklyn Park",
			"state": "Minnesota",
			"population": "78,373"
		}, {
			"city": "Tustin",
			"state": "California",
			"population": "78,327"
		}, {
			"city": "Racine",
			"state": "Wisconsin",
			"population": "78,199"
		}, {
			"city": "Deerfield Beach",
			"state": "Florida",
			"population": "78,041"
		}, {
			"city": "Lynchburg",
			"state": "Virginia",
			"population": "78,014"
		}, {
			"city": "Mountain View",
			"state": "California",
			"population": "77,846"
		}, {
			"city": "Medford",
			"state": "Oregon",
			"population": "77,677"
		}, {
			"city": "Lawrence",
			"state": "Massachusetts",
			"population": "77,657"
		}, {
			"city": "Bellflower",
			"state": "California",
			"population": "77,593"
		}, {
			"city": "Melbourne",
			"state": "Florida",
			"population": "77,508"
		}, {
			"city": "St. Joseph",
			"state": "Missouri",
			"population": "77,147"
		}, {
			"city": "Camden",
			"state": "New Jersey",
			"population": "76,903"
		}, {
			"city": "St. George",
			"state": "Utah",
			"population": "76,817"
		}, {
			"city": "Kennewick",
			"state": "Washington",
			"population": "76,762"
		}, {
			"city": "Baldwin Park",
			"state": "California",
			"population": "76,635"
		}, {
			"city": "Chino Hills",
			"state": "California",
			"population": "76,572"
		}, {
			"city": "Alameda",
			"state": "California",
			"population": "76,419"
		}, {
			"city": "Albany",
			"state": "Georgia",
			"population": "76,185"
		}, {
			"city": "Arlington Heights",
			"state": "Illinois",
			"population": "75,994"
		}, {
			"city": "Scranton",
			"state": "Pennsylvania",
			"population": "75,806"
		}, {
			"city": "Evanston",
			"state": "Illinois",
			"population": "75,570"
		}, {
			"city": "Kalamazoo",
			"state": "Michigan",
			"population": "75,548"
		}, {
			"city": "Baytown",
			"state": "Texas",
			"population": "75,418"
		}, {
			"city": "Upland",
			"state": "California",
			"population": "75,413"
		}, {
			"city": "Springdale",
			"state": "Arkansas",
			"population": "75,229"
		}, {
			"city": "Bethlehem",
			"state": "Pennsylvania",
			"population": "75,018"
		}, {
			"city": "Schaumburg",
			"state": "Illinois",
			"population": "74,907"
		}, {
			"city": "Mount Pleasant",
			"state": "South Carolina",
			"population": "74,885"
		}, {
			"city": "Auburn",
			"state": "Washington",
			"population": "74,860"
		}, {
			"city": "Decatur",
			"state": "Illinois",
			"population": "74,710"
		}, {
			"city": "San Ramon",
			"state": "California",
			"population": "74,513"
		}, {
			"city": "Pleasanton",
			"state": "California",
			"population": "74,110"
		}, {
			"city": "Wyoming",
			"state": "Michigan",
			"population": "74,100"
		}, {
			"city": "Lake Charles",
			"state": "Louisiana",
			"population": "74,024"
		}, {
			"city": "Plymouth",
			"state": "Minnesota",
			"population": "73,987"
		}, {
			"city": "Bolingbrook",
			"state": "Illinois",
			"population": "73,936"
		}, {
			"city": "Pharr",
			"state": "Texas",
			"population": "73,790"
		}, {
			"city": "Appleton",
			"state": "Wisconsin",
			"population": "73,596"
		}, {
			"city": "Gastonia",
			"state": "North Carolina",
			"population": "73,209"
		}, {
			"city": "Folsom",
			"state": "California",
			"population": "73,098"
		}, {
			"city": "Southfield",
			"state": "Michigan",
			"population": "73,006"
		}, {
			"city": "Rochester Hills",
			"state": "Michigan",
			"population": "72,952"
		}, {
			"city": "New Britain",
			"state": "Connecticut",
			"population": "72,939"
		}, {
			"city": "Goodyear",
			"state": "Arizona",
			"population": "72,864"
		}, {
			"city": "Canton",
			"state": "Ohio",
			"population": "72,535"
		}, {
			"city": "Warner Robins",
			"state": "Georgia",
			"population": "72,531"
		}, {
			"city": "Union City",
			"state": "California",
			"population": "72,528"
		}, {
			"city": "Perris",
			"state": "California",
			"population": "72,326"
		}, {
			"city": "Manteca",
			"state": "California",
			"population": "71,948"
		}, {
			"city": "Iowa City",
			"state": "Iowa",
			"population": "71,591"
		}, {
			"city": "Jonesboro",
			"state": "Arkansas",
			"population": "71,551"
		}, {
			"city": "Wilmington",
			"state": "Delaware",
			"population": "71,525"
		}, {
			"city": "Lynwood",
			"state": "California",
			"population": "71,371"
		}, {
			"city": "Loveland",
			"state": "Colorado",
			"population": "71,334"
		}, {
			"city": "Pawtucket",
			"state": "Rhode Island",
			"population": "71,172"
		}, {
			"city": "Boynton Beach",
			"state": "Florida",
			"population": "71,097"
		}, {
			"city": "Waukesha",
			"state": "Wisconsin",
			"population": "71,016"
		}, {
			"city": "Gulfport",
			"state": "Mississippi",
			"population": "71,012"
		}, {
			"city": "Apple Valley",
			"state": "California",
			"population": "70,924"
		}, {
			"city": "Passaic",
			"state": "New Jersey",
			"population": "70,868"
		}, {
			"city": "Rapid City",
			"state": "South Dakota",
			"population": "70,812"
		}, {
			"city": "Layton",
			"state": "Utah",
			"population": "70,790"
		}, {
			"city": "Lafayette",
			"state": "Indiana",
			"population": "70,373"
		}, {
			"city": "Turlock",
			"state": "California",
			"population": "70,365"
		}, {
			"city": "Muncie",
			"state": "Indiana",
			"population": "70,316"
		}, {
			"city": "Temple",
			"state": "Texas",
			"population": "70,190"
		}, {
			"city": "Missouri City",
			"state": "Texas",
			"population": "70,185"
		}, {
			"city": "Redlands",
			"state": "California",
			"population": "69,999"
		}, {
			"city": "Santa Fe",
			"state": "New Mexico",
			"population": "69,976"
		}, {
			"city": "Lauderhill",
			"state": "Florida",
			"population": "69,813"
		}, {
			"city": "Milpitas",
			"state": "California",
			"population": "69,783"
		}, {
			"city": "Palatine",
			"state": "Illinois",
			"population": "69,350"
		}, {
			"city": "Missoula",
			"state": "Montana",
			"population": "69,122"
		}, {
			"city": "Rock Hill",
			"state": "South Carolina",
			"population": "69,103"
		}, {
			"city": "Jacksonville",
			"state": "North Carolina",
			"population": "69,079"
		}, {
			"city": "Franklin",
			"state": "Tennessee",
			"population": "68,886"
		}, {
			"city": "Flagstaff",
			"state": "Arizona",
			"population": "68,667"
		}, {
			"city": "Flower Mound",
			"state": "Texas",
			"population": "68,609"
		}, {
			"city": "Weston",
			"state": "Florida",
			"population": "68,388"
		}, {
			"city": "Waterloo",
			"state": "Iowa",
			"population": "68,366"
		}, {
			"city": "Union City",
			"state": "New Jersey",
			"population": "68,247"
		}, {
			"city": "Mount Vernon",
			"state": "New York",
			"population": "68,224"
		}, {
			"city": "Fort Myers",
			"state": "Florida",
			"population": "68,190"
		}, {
			"city": "Dothan",
			"state": "Alabama",
			"population": "68,001"
		}, {
			"city": "Rancho Cordova",
			"state": "California",
			"population": "67,911"
		}, {
			"city": "Redondo Beach",
			"state": "California",
			"population": "67,815"
		}, {
			"city": "Jackson",
			"state": "Tennessee",
			"population": "67,685"
		}, {
			"city": "Pasco",
			"state": "Washington",
			"population": "67,599"
		}, {
			"city": "St. Charles",
			"state": "Missouri",
			"population": "67,569"
		}, {
			"city": "Eau Claire",
			"state": "Wisconsin",
			"population": "67,545"
		}, {
			"city": "North Richland Hills",
			"state": "Texas",
			"population": "67,317"
		}, {
			"city": "Bismarck",
			"state": "North Dakota",
			"population": "67,034"
		}, {
			"city": "Yorba Linda",
			"state": "California",
			"population": "67,032"
		}, {
			"city": "Kenner",
			"state": "Louisiana",
			"population": "66,975"
		}, {
			"city": "Walnut Creek",
			"state": "California",
			"population": "66,900"
		}, {
			"city": "Frederick",
			"state": "Maryland",
			"population": "66,893"
		}, {
			"city": "Oshkosh",
			"state": "Wisconsin",
			"population": "66,778"
		}, {
			"city": "Pittsburg",
			"state": "California",
			"population": "66,695"
		}, {
			"city": "Palo Alto",
			"state": "California",
			"population": "66,642"
		}, {
			"city": "Bossier City",
			"state": "Louisiana",
			"population": "66,333"
		}, {
			"city": "Portland",
			"state": "Maine",
			"population": "66,318"
		}, {
			"city": "St. Cloud",
			"state": "Minnesota",
			"population": "66,297"
		}, {
			"city": "Davis",
			"state": "California",
			"population": "66,205"
		}, {
			"city": "South San Francisco",
			"state": "California",
			"population": "66,174"
		}, {
			"city": "Camarillo",
			"state": "California",
			"population": "66,086"
		}, {
			"city": "North Little Rock",
			"state": "Arkansas",
			"population": "66,075"
		}, {
			"city": "Schenectady",
			"state": "New York",
			"population": "65,902"
		}, {
			"city": "Gaithersburg",
			"state": "Maryland",
			"population": "65,690"
		}, {
			"city": "Harlingen",
			"state": "Texas",
			"population": "65,665"
		}, {
			"city": "Woodbury",
			"state": "Minnesota",
			"population": "65,656"
		}, {
			"city": "Eagan",
			"state": "Minnesota",
			"population": "65,453"
		}, {
			"city": "Yuba City",
			"state": "California",
			"population": "65,416"
		}, {
			"city": "Maple Grove",
			"state": "Minnesota",
			"population": "65,415"
		}, {
			"city": "Youngstown",
			"state": "Ohio",
			"population": "65,184"
		}, {
			"city": "Skokie",
			"state": "Illinois",
			"population": "65,176"
		}, {
			"city": "Kissimmee",
			"state": "Florida",
			"population": "65,173"
		}, {
			"city": "Johnson City",
			"state": "Tennessee",
			"population": "65,123"
		}, {
			"city": "Victoria",
			"state": "Texas",
			"population": "65,098"
		}, {
			"city": "San Clemente",
			"state": "California",
			"population": "65,040"
		}, {
			"city": "Bayonne",
			"state": "New Jersey",
			"population": "65,028"
		}, {
			"city": "Laguna Niguel",
			"state": "California",
			"population": "64,652"
		}, {
			"city": "East Orange",
			"state": "New Jersey",
			"population": "64,544"
		}, {
			"city": "Shawnee",
			"state": "Kansas",
			"population": "64,323"
		}, {
			"city": "Homestead",
			"state": "Florida",
			"population": "64,079"
		}, {
			"city": "Rockville",
			"state": "Maryland",
			"population": "64,072"
		}, {
			"city": "Delray Beach",
			"state": "Florida",
			"population": "64,072"
		}, {
			"city": "Janesville",
			"state": "Wisconsin",
			"population": "63,820"
		}, {
			"city": "Conway",
			"state": "Arkansas",
			"population": "63,816"
		}, {
			"city": "Pico Rivera",
			"state": "California",
			"population": "63,771"
		}, {
			"city": "Lorain",
			"state": "Ohio",
			"population": "63,710"
		}, {
			"city": "Montebello",
			"state": "California",
			"population": "63,495"
		}, {
			"city": "Lodi",
			"state": "California",
			"population": "63,338"
		}, {
			"city": "New Braunfels",
			"state": "Texas",
			"population": "63,279"
		}, {
			"city": "Marysville",
			"state": "Washington",
			"population": "63,269"
		}, {
			"city": "Tamarac",
			"state": "Florida",
			"population": "63,155"
		}, {
			"city": "Madera",
			"state": "California",
			"population": "63,105"
		}, {
			"city": "Conroe",
			"state": "Texas",
			"population": "63,032"
		}, {
			"city": "Santa Cruz",
			"state": "California",
			"population": "62,864"
		}, {
			"city": "Eden Prairie",
			"state": "Minnesota",
			"population": "62,603"
		}, {
			"city": "Cheyenne",
			"state": "Wyoming",
			"population": "62,448"
		}, {
			"city": "Daytona Beach",
			"state": "Florida",
			"population": "62,316"
		}, {
			"city": "Alpharetta",
			"state": "Georgia",
			"population": "62,298"
		}, {
			"city": "Hamilton",
			"state": "Ohio",
			"population": "62,258"
		}, {
			"city": "Waltham",
			"state": "Massachusetts",
			"population": "62,227"
		}, {
			"city": "Coon Rapids",
			"state": "Minnesota",
			"population": "62,103"
		}, {
			"city": "Haverhill",
			"state": "Massachusetts",
			"population": "62,088"
		}, {
			"city": "Council Bluffs",
			"state": "Iowa",
			"population": "61,969"
		}, {
			"city": "Taylor",
			"state": "Michigan",
			"population": "61,817"
		}, {
			"city": "Utica",
			"state": "New York",
			"population": "61,808"
		}, {
			"city": "Ames",
			"state": "Iowa",
			"population": "61,792"
		}, {
			"city": "La Habra",
			"state": "California",
			"population": "61,653"
		}, {
			"city": "Encinitas",
			"state": "California",
			"population": "61,588"
		}, {
			"city": "Bowling Green",
			"state": "Kentucky",
			"population": "61,488"
		}, {
			"city": "Burnsville",
			"state": "Minnesota",
			"population": "61,434"
		}, {
			"city": "Greenville",
			"state": "South Carolina",
			"population": "61,397"
		}, {
			"city": "West Des Moines",
			"state": "Iowa",
			"population": "61,255"
		}, {
			"city": "Cedar Park",
			"state": "Texas",
			"population": "61,238"
		}, {
			"city": "Tulare",
			"state": "California",
			"population": "61,170"
		}, {
			"city": "Monterey Park",
			"state": "California",
			"population": "61,085"
		}, {
			"city": "Vineland",
			"state": "New Jersey",
			"population": "61,050"
		}, {
			"city": "Terre Haute",
			"state": "Indiana",
			"population": "61,025"
		}, {
			"city": "North Miami",
			"state": "Florida",
			"population": "61,007"
		}, {
			"city": "Mansfield",
			"state": "Texas",
			"population": "60,872"
		}, {
			"city": "West Allis",
			"state": "Wisconsin",
			"population": "60,697"
		}, {
			"city": "Bristol",
			"state": "Connecticut",
			"population": "60,568"
		}, {
			"city": "Taylorsville",
			"state": "Utah",
			"population": "60,519"
		}, {
			"city": "Malden",
			"state": "Massachusetts",
			"population": "60,509"
		}, {
			"city": "Meriden",
			"state": "Connecticut",
			"population": "60,456"
		}, {
			"city": "Blaine",
			"state": "Minnesota",
			"population": "60,407"
		}, {
			"city": "Wellington",
			"state": "Florida",
			"population": "60,202"
		}, {
			"city": "Cupertino",
			"state": "California",
			"population": "60,189"
		}, {
			"city": "Springfield",
			"state": "Oregon",
			"population": "60,177"
		}, {
			"city": "Rogers",
			"state": "Arkansas",
			"population": "60,112"
		}, {
			"city": "St. Clair Shores",
			"state": "Michigan",
			"population": "60,070"
		}, {
			"city": "Gardena",
			"state": "California",
			"population": "59,957"
		}, {
			"city": "Pontiac",
			"state": "Michigan",
			"population": "59,887"
		}, {
			"city": "National City",
			"state": "California",
			"population": "59,834"
		}, {
			"city": "Grand Junction",
			"state": "Colorado",
			"population": "59,778"
		}, {
			"city": "Rocklin",
			"state": "California",
			"population": "59,738"
		}, {
			"city": "Chapel Hill",
			"state": "North Carolina",
			"population": "59,635"
		}, {
			"city": "Casper",
			"state": "Wyoming",
			"population": "59,628"
		}, {
			"city": "Broomfield",
			"state": "Colorado",
			"population": "59,471"
		}, {
			"city": "Petaluma",
			"state": "California",
			"population": "59,440"
		}, {
			"city": "South Jordan",
			"state": "Utah",
			"population": "59,366"
		}, {
			"city": "Springfield",
			"state": "Ohio",
			"population": "59,357"
		}, {
			"city": "Great Falls",
			"state": "Montana",
			"population": "59,351"
		}, {
			"city": "Lancaster",
			"state": "Pennsylvania",
			"population": "59,325"
		}, {
			"city": "North Port",
			"state": "Florida",
			"population": "59,212"
		}, {
			"city": "Lakewood",
			"state": "Washington",
			"population": "59,097"
		}, {
			"city": "Marietta",
			"state": "Georgia",
			"population": "59,089"
		}, {
			"city": "San Rafael",
			"state": "California",
			"population": "58,994"
		}, {
			"city": "Royal Oak",
			"state": "Michigan",
			"population": "58,946"
		}, {
			"city": "Des Plaines",
			"state": "Illinois",
			"population": "58,918"
		}, {
			"city": "Huntington Park",
			"state": "California",
			"population": "58,879"
		}, {
			"city": "La Mesa",
			"state": "California",
			"population": "58,642"
		}, {
			"city": "Orland Park",
			"state": "Illinois",
			"population": "58,590"
		}, {
			"city": "Auburn",
			"state": "Alabama",
			"population": "58,582"
		}, {
			"city": "Lakeville",
			"state": "Minnesota",
			"population": "58,562"
		}, {
			"city": "Owensboro",
			"state": "Kentucky",
			"population": "58,416"
		}, {
			"city": "Moore",
			"state": "Oklahoma",
			"population": "58,414"
		}, {
			"city": "Jupiter",
			"state": "Florida",
			"population": "58,298"
		}, {
			"city": "Idaho Falls",
			"state": "Idaho",
			"population": "58,292"
		}, {
			"city": "Dubuque",
			"state": "Iowa",
			"population": "58,253"
		}, {
			"city": "Bartlett",
			"state": "Tennessee",
			"population": "58,226"
		}, {
			"city": "Rowlett",
			"state": "Texas",
			"population": "58,043"
		}, {
			"city": "Novi",
			"state": "Michigan",
			"population": "57,960"
		}, {
			"city": "White Plains",
			"state": "New York",
			"population": "57,866"
		}, {
			"city": "Arcadia",
			"state": "California",
			"population": "57,639"
		}, {
			"city": "Redmond",
			"state": "Washington",
			"population": "57,530"
		}, {
			"city": "Lake Elsinore",
			"state": "California",
			"population": "57,525"
		}, {
			"city": "Ocala",
			"state": "Florida",
			"population": "57,468"
		}, {
			"city": "Tinley Park",
			"state": "Illinois",
			"population": "57,282"
		}, {
			"city": "Port Orange",
			"state": "Florida",
			"population": "57,203"
		}, {
			"city": "Medford",
			"state": "Massachusetts",
			"population": "57,170"
		}, {
			"city": "Oak Lawn",
			"state": "Illinois",
			"population": "57,073"
		}, {
			"city": "Rocky Mount",
			"state": "North Carolina",
			"population": "56,954"
		}, {
			"city": "Kokomo",
			"state": "Indiana",
			"population": "56,895"
		}, {
			"city": "Coconut Creek",
			"state": "Florida",
			"population": "56,792"
		}, {
			"city": "Bowie",
			"state": "Maryland",
			"population": "56,759"
		}, {
			"city": "Berwyn",
			"state": "Illinois",
			"population": "56,758"
		}, {
			"city": "Midwest City",
			"state": "Oklahoma",
			"population": "56,756"
		}, {
			"city": "Fountain Valley",
			"state": "California",
			"population": "56,707"
		}, {
			"city": "Buckeye",
			"state": "Arizona",
			"population": "56,683"
		}, {
			"city": "Dearborn Heights",
			"state": "Michigan",
			"population": "56,620"
		}, {
			"city": "Woodland",
			"state": "California",
			"population": "56,590"
		}, {
			"city": "Noblesville",
			"state": "Indiana",
			"population": "56,540"
		}, {
			"city": "Valdosta",
			"state": "Georgia",
			"population": "56,481"
		}, {
			"city": "Diamond Bar",
			"state": "California",
			"population": "56,449"
		}, {
			"city": "Manhattan",
			"state": "Kansas",
			"population": "56,143"
		}, {
			"city": "Santee",
			"state": "California",
			"population": "56,105"
		}, {
			"city": "Taunton",
			"state": "Massachusetts",
			"population": "56,069"
		}, {
			"city": "Sanford",
			"state": "Florida",
			"population": "56,002"
		}, {
			"city": "Kettering",
			"state": "Ohio",
			"population": "55,870"
		}, {
			"city": "New Brunswick",
			"state": "New Jersey",
			"population": "55,831"
		}, {
			"city": "Decatur",
			"state": "Alabama",
			"population": "55,816"
		}, {
			"city": "Chicopee",
			"state": "Massachusetts",
			"population": "55,717"
		}, {
			"city": "Anderson",
			"state": "Indiana",
			"population": "55,670"
		}, {
			"city": "Margate",
			"state": "Florida",
			"population": "55,456"
		}, {
			"city": "Weymouth Town",
			"state": "Massachusetts",
			"population": "55,419"
		}, {
			"city": "Hempstead",
			"state": "New York",
			"population": "55,361"
		}, {
			"city": "Corvallis",
			"state": "Oregon",
			"population": "55,298"
		}, {
			"city": "Eastvale",
			"state": "California",
			"population": "55,191"
		}, {
			"city": "Porterville",
			"state": "California",
			"population": "55,174"
		}, {
			"city": "West Haven",
			"state": "Connecticut",
			"population": "55,046"
		}, {
			"city": "Brentwood",
			"state": "California",
			"population": "55,000"
		}, {
			"city": "Paramount",
			"state": "California",
			"population": "54,980"
		}, {
			"city": "Grand Forks",
			"state": "North Dakota",
			"population": "54,932"
		}, {
			"city": "Georgetown",
			"state": "Texas",
			"population": "54,898"
		}, {
			"city": "St. Peters",
			"state": "Missouri",
			"population": "54,842"
		}, {
			"city": "Shoreline",
			"state": "Washington",
			"population": "54,790"
		}, {
			"city": "Mount Prospect",
			"state": "Illinois",
			"population": "54,771"
		}, {
			"city": "Hanford",
			"state": "California",
			"population": "54,686"
		}, {
			"city": "Normal",
			"state": "Illinois",
			"population": "54,664"
		}, {
			"city": "Rosemead",
			"state": "California",
			"population": "54,561"
		}, {
			"city": "Lehi",
			"state": "Utah",
			"population": "54,382"
		}, {
			"city": "Pocatello",
			"state": "Idaho",
			"population": "54,350"
		}, {
			"city": "Highland",
			"state": "California",
			"population": "54,291"
		}, {
			"city": "Novato",
			"state": "California",
			"population": "54,194"
		}, {
			"city": "Port Arthur",
			"state": "Texas",
			"population": "54,135"
		}, {
			"city": "Carson City",
			"state": "Nevada",
			"population": "54,080"
		}, {
			"city": "San Marcos",
			"state": "Texas",
			"population": "54,076"
		}, {
			"city": "Hendersonville",
			"state": "Tennessee",
			"population": "54,068"
		}, {
			"city": "Elyria",
			"state": "Ohio",
			"population": "53,956"
		}, {
			"city": "Revere",
			"state": "Massachusetts",
			"population": "53,756"
		}, {
			"city": "Pflugerville",
			"state": "Texas",
			"population": "53,752"
		}, {
			"city": "Greenwood",
			"state": "Indiana",
			"population": "53,665"
		}, {
			"city": "Bellevue",
			"state": "Nebraska",
			"population": "53,663"
		}, {
			"city": "Wheaton",
			"state": "Illinois",
			"population": "53,648"
		}, {
			"city": "Smyrna",
			"state": "Georgia",
			"population": "53,438"
		}, {
			"city": "Sarasota",
			"state": "Florida",
			"population": "53,326"
		}, {
			"city": "Blue Springs",
			"state": "Missouri",
			"population": "53,294"
		}, {
			"city": "Colton",
			"state": "California",
			"population": "53,243"
		}, {
			"city": "Euless",
			"state": "Texas",
			"population": "53,224"
		}, {
			"city": "Castle Rock",
			"state": "Colorado",
			"population": "53,063"
		}, {
			"city": "Cathedral City",
			"state": "California",
			"population": "52,977"
		}, {
			"city": "Kingsport",
			"state": "Tennessee",
			"population": "52,962"
		}, {
			"city": "Lake Havasu City",
			"state": "Arizona",
			"population": "52,844"
		}, {
			"city": "Pensacola",
			"state": "Florida",
			"population": "52,703"
		}, {
			"city": "Hoboken",
			"state": "New Jersey",
			"population": "52,575"
		}, {
			"city": "Yucaipa",
			"state": "California",
			"population": "52,536"
		}, {
			"city": "Watsonville",
			"state": "California",
			"population": "52,477"
		}, {
			"city": "Richland",
			"state": "Washington",
			"population": "52,413"
		}, {
			"city": "Delano",
			"state": "California",
			"population": "52,403"
		}, {
			"city": "Hoffman Estates",
			"state": "Illinois",
			"population": "52,398"
		}, {
			"city": "Florissant",
			"state": "Missouri",
			"population": "52,363"
		}, {
			"city": "Placentia",
			"state": "California",
			"population": "52,206"
		}, {
			"city": "West New York",
			"state": "New Jersey",
			"population": "52,122"
		}, {
			"city": "Dublin",
			"state": "California",
			"population": "52,105"
		}, {
			"city": "Oak Park",
			"state": "Illinois",
			"population": "52,066"
		}, {
			"city": "Peabody",
			"state": "Massachusetts",
			"population": "52,044"
		}, {
			"city": "Perth Amboy",
			"state": "New Jersey",
			"population": "51,982"
		}, {
			"city": "Battle Creek",
			"state": "Michigan",
			"population": "51,848"
		}, {
			"city": "Bradenton",
			"state": "Florida",
			"population": "51,763"
		}, {
			"city": "Gilroy",
			"state": "California",
			"population": "51,701"
		}, {
			"city": "Milford",
			"state": "Connecticut",
			"population": "51,644"
		}, {
			"city": "Albany",
			"state": "Oregon",
			"population": "51,583"
		}, {
			"city": "Ankeny",
			"state": "Iowa",
			"population": "51,567"
		}, {
			"city": "La Crosse",
			"state": "Wisconsin",
			"population": "51,522"
		}, {
			"city": "Burlington",
			"state": "North Carolina",
			"population": "51,510"
		}, {
			"city": "DeSoto",
			"state": "Texas",
			"population": "51,483"
		}, {
			"city": "Harrisonburg",
			"state": "Virginia",
			"population": "51,395"
		}, {
			"city": "Minnetonka",
			"state": "Minnesota",
			"population": "51,368"
		}, {
			"city": "Elkhart",
			"state": "Indiana",
			"population": "51,265"
		}, {
			"city": "Lakewood",
			"state": "Ohio",
			"population": "51,143"
		}, {
			"city": "Glendora",
			"state": "California",
			"population": "51,074"
		}, {
			"city": "Southaven",
			"state": "Mississippi",
			"population": "50,997"
		}, {
			"city": "Charleston",
			"state": "West Virginia",
			"population": "50,821"
		}, {
			"city": "Joplin",
			"state": "Missouri",
			"population": "50,789"
		}, {
			"city": "Enid",
			"state": "Oklahoma",
			"population": "50,725"
		}, {
			"city": "Palm Beach Gardens",
			"state": "Florida",
			"population": "50,699"
		}, {
			"city": "Brookhaven",
			"state": "Georgia",
			"population": "50,603"
		}, {
			"city": "Plainfield",
			"state": "New Jersey",
			"population": "50,588"
		}, {
			"city": "Grand Island",
			"state": "Nebraska",
			"population": "50,550"
		}, {
			"city": "Palm Desert",
			"state": "California",
			"population": "50,508"
		}, {
			"city": "Huntersville",
			"state": "North Carolina",
			"population": "50,458"
		}, {
			"city": "Tigard",
			"state": "Oregon",
			"population": "50,444"
		}, {
			"city": "Lenexa",
			"state": "Kansas",
			"population": "50,344"
		}, {
			"city": "Saginaw",
			"state": "Michigan",
			"population": "50,303"
		}, {
			"city": "Kentwood",
			"state": "Michigan",
			"population": "50,233"
		}, {
			"city": "Doral",
			"state": "Florida",
			"population": "50,213"
		}, {
			"city": "Apple Valley",
			"state": "Minnesota",
			"population": "50,201"
		}, {
			"city": "Grapevine",
			"state": "Texas",
			"population": "50,195"
		}, {
			"city": "Aliso Viejo",
			"state": "California",
			"population": "50,175"
		}, {
			"city": "Sammamish",
			"state": "Washington",
			"population": "50,169"
		}, {
			"city": "Casa Grande",
			"state": "Arizona",
			"population": "50,111"
		}, {
			"city": "Pinellas Park",
			"state": "Florida",
			"population": "49,998"
		}, {
			"city": "Troy",
			"state": "New York",
			"population": "49,974"
		}, {
			"city": "West Sacramento",
			"state": "California",
			"population": "49,891"
		}, {
			"city": "Burien",
			"state": "Washington",
			"population": "49,858"
		}, {
			"city": "Commerce City",
			"state": "Colorado",
			"population": "49,799"
		}, {
			"city": "Monroe",
			"state": "Louisiana",
			"population": "49,761"
		}, {
			"city": "Cerritos",
			"state": "California",
			"population": "49,707"
		}, {
			"city": "Downers Grove",
			"state": "Illinois",
			"population": "49,670"
		}, {
			"city": "Coral Gables",
			"state": "Florida",
			"population": "49,631"
		}, {
			"city": "Wilson",
			"state": "North Carolina",
			"population": "49,628"
		}, {
			"city": "Niagara Falls",
			"state": "New York",
			"population": "49,468"
		}, {
			"city": "Poway",
			"state": "California",
			"population": "49,417"
		}, {
			"city": "Edina",
			"state": "Minnesota",
			"population": "49,376"
		}, {
			"city": "Cuyahoga Falls",
			"state": "Ohio",
			"population": "49,267"
		}, {
			"city": "Rancho Santa Margarita",
			"state": "California",
			"population": "49,228"
		}, {
			"city": "Harrisburg",
			"state": "Pennsylvania",
			"population": "49,188"
		}, {
			"city": "Huntington",
			"state": "West Virginia",
			"population": "49,177"
		}, {
			"city": "La Mirada",
			"state": "California",
			"population": "49,133"
		}, {
			"city": "Cypress",
			"state": "California",
			"population": "49,087"
		}, {
			"city": "Caldwell",
			"state": "Idaho",
			"population": "48,957"
		}, {
			"city": "Logan",
			"state": "Utah",
			"population": "48,913"
		}, {
			"city": "Galveston",
			"state": "Texas",
			"population": "48,733"
		}, {
			"city": "Sheboygan",
			"state": "Wisconsin",
			"population": "48,725"
		}, {
			"city": "Middletown",
			"state": "Ohio",
			"population": "48,630"
		}, {
			"city": "Murray",
			"state": "Utah",
			"population": "48,612"
		}, {
			"city": "Roswell",
			"state": "New Mexico",
			"population": "48,611"
		}, {
			"city": "Parker",
			"state": "Colorado",
			"population": "48,608"
		}, {
			"city": "Bedford",
			"state": "Texas",
			"population": "48,592"
		}, {
			"city": "East Lansing",
			"state": "Michigan",
			"population": "48,554"
		}, {
			"city": "Methuen",
			"state": "Massachusetts",
			"population": "48,514"
		}, {
			"city": "Covina",
			"state": "California",
			"population": "48,508"
		}, {
			"city": "Alexandria",
			"state": "Louisiana",
			"population": "48,426"
		}, {
			"city": "Olympia",
			"state": "Washington",
			"population": "48,338"
		}, {
			"city": "Euclid",
			"state": "Ohio",
			"population": "48,139"
		}, {
			"city": "Mishawaka",
			"state": "Indiana",
			"population": "47,989"
		}, {
			"city": "Salina",
			"state": "Kansas",
			"population": "47,846"
		}, {
			"city": "Azusa",
			"state": "California",
			"population": "47,842"
		}, {
			"city": "Newark",
			"state": "Ohio",
			"population": "47,777"
		}, {
			"city": "Chesterfield",
			"state": "Missouri",
			"population": "47,749"
		}, {
			"city": "Leesburg",
			"state": "Virginia",
			"population": "47,673"
		}, {
			"city": "Dunwoody",
			"state": "Georgia",
			"population": "47,591"
		}, {
			"city": "Hattiesburg",
			"state": "Mississippi",
			"population": "47,556"
		}, {
			"city": "Roseville",
			"state": "Michigan",
			"population": "47,555"
		}, {
			"city": "Bonita Springs",
			"state": "Florida",
			"population": "47,547"
		}, {
			"city": "Portage",
			"state": "Michigan",
			"population": "47,523"
		}, {
			"city": "St. Louis Park",
			"state": "Minnesota",
			"population": "47,411"
		}, {
			"city": "Collierville",
			"state": "Tennessee",
			"population": "47,333"
		}, {
			"city": "Middletown",
			"state": "Connecticut",
			"population": "47,333"
		}, {
			"city": "Stillwater",
			"state": "Oklahoma",
			"population": "47,186"
		}, {
			"city": "East Providence",
			"state": "Rhode Island",
			"population": "47,149"
		}, {
			"city": "Lawrence",
			"state": "Indiana",
			"population": "47,135"
		}, {
			"city": "Wauwatosa",
			"state": "Wisconsin",
			"population": "47,134"
		}, {
			"city": "Mentor",
			"state": "Ohio",
			"population": "46,979"
		}, {
			"city": "Ceres",
			"state": "California",
			"population": "46,714"
		}, {
			"city": "Cedar Hill",
			"state": "Texas",
			"population": "46,663"
		}, {
			"city": "Mansfield",
			"state": "Ohio",
			"population": "46,454"
		}, {
			"city": "Binghamton",
			"state": "New York",
			"population": "46,444"
		}, {
			"city": "Coeur d'Alene",
			"state": "Idaho",
			"population": "46,402"
		}, {
			"city": "San Luis Obispo",
			"state": "California",
			"population": "46,377"
		}, {
			"city": "Minot",
			"state": "North Dakota",
			"population": "46,321"
		}, {
			"city": "Palm Springs",
			"state": "California",
			"population": "46,281"
		}, {
			"city": "Pine Bluff",
			"state": "Arkansas",
			"population": "46,094"
		}, {
			"city": "Texas City",
			"state": "Texas",
			"population": "46,081"
		}, {
			"city": "Summerville",
			"state": "South Carolina",
			"population": "46,074"
		}, {
			"city": "Twin Falls",
			"state": "Idaho",
			"population": "45,981"
		}, {
			"city": "Jeffersonville",
			"state": "Indiana",
			"population": "45,929"
		}, {
			"city": "San Jacinto",
			"state": "California",
			"population": "45,851"
		}, {
			"city": "Madison",
			"state": "Alabama",
			"population": "45,799"
		}, {
			"city": "Altoona",
			"state": "Pennsylvania",
			"population": "45,796"
		}, {
			"city": "Columbus",
			"state": "Indiana",
			"population": "45,775"
		}, {
			"city": "Beavercreek",
			"state": "Ohio",
			"population": "45,712"
		}, {
			"city": "Apopka",
			"state": "Florida",
			"population": "45,587"
		}, {
			"city": "Elmhurst",
			"state": "Illinois",
			"population": "45,556"
		}, {
			"city": "Maricopa",
			"state": "Arizona",
			"population": "45,508"
		}, {
			"city": "Farmington",
			"state": "New Mexico",
			"population": "45,426"
		}, {
			"city": "Glenview",
			"state": "Illinois",
			"population": "45,417"
		}, {
			"city": "Cleveland Heights",
			"state": "Ohio",
			"population": "45,394"
		}, {
			"city": "Draper",
			"state": "Utah",
			"population": "45,285"
		}, {
			"city": "Lincoln",
			"state": "California",
			"population": "45,237"
		}, {
			"city": "Sierra Vista",
			"state": "Arizona",
			"population": "45,129"
		}, {
			"city": "Lacey",
			"state": "Washington",
			"population": "44,919"
		}, {
			"city": "Biloxi",
			"state": "Mississippi",
			"population": "44,820"
		}, {
			"city": "Strongsville",
			"state": "Ohio",
			"population": "44,730"
		}, {
			"city": "Barnstable Town",
			"state": "Massachusetts",
			"population": "44,641"
		}, {
			"city": "Wylie",
			"state": "Texas",
			"population": "44,575"
		}, {
			"city": "Sayreville",
			"state": "New Jersey",
			"population": "44,412"
		}, {
			"city": "Kannapolis",
			"state": "North Carolina",
			"population": "44,359"
		}, {
			"city": "Charlottesville",
			"state": "Virginia",
			"population": "44,349"
		}, {
			"city": "Littleton",
			"state": "Colorado",
			"population": "44,275"
		}, {
			"city": "Titusville",
			"state": "Florida",
			"population": "44,206"
		}, {
			"city": "Hackensack",
			"state": "New Jersey",
			"population": "44,113"
		}, {
			"city": "Newark",
			"state": "California",
			"population": "44,096"
		}, {
			"city": "Pittsfield",
			"state": "Massachusetts",
			"population": "44,057"
		}, {
			"city": "York",
			"state": "Pennsylvania",
			"population": "43,935"
		}, {
			"city": "Lombard",
			"state": "Illinois",
			"population": "43,907"
		}, {
			"city": "Attleboro",
			"state": "Massachusetts",
			"population": "43,886"
		}, {
			"city": "DeKalb",
			"state": "Illinois",
			"population": "43,849"
		}, {
			"city": "Blacksburg",
			"state": "Virginia",
			"population": "43,609"
		}, {
			"city": "Dublin",
			"state": "Ohio",
			"population": "43,607"
		}, {
			"city": "Haltom City",
			"state": "Texas",
			"population": "43,580"
		}, {
			"city": "Lompoc",
			"state": "California",
			"population": "43,509"
		}, {
			"city": "El Centro",
			"state": "California",
			"population": "43,363"
		}, {
			"city": "Danville",
			"state": "California",
			"population": "43,341"
		}, {
			"city": "Jefferson City",
			"state": "Missouri",
			"population": "43,330"
		}, {
			"city": "Cutler Bay",
			"state": "Florida",
			"population": "43,328"
		}, {
			"city": "Oakland Park",
			"state": "Florida",
			"population": "43,286"
		}, {
			"city": "North Miami Beach",
			"state": "Florida",
			"population": "43,250"
		}, {
			"city": "Freeport",
			"state": "New York",
			"population": "43,167"
		}, {
			"city": "Moline",
			"state": "Illinois",
			"population": "43,116"
		}, {
			"city": "Coachella",
			"state": "California",
			"population": "43,092"
		}, {
			"city": "Fort Pierce",
			"state": "Florida",
			"population": "43,074"
		}, {
			"city": "Smyrna",
			"state": "Tennessee",
			"population": "43,060"
		}, {
			"city": "Bountiful",
			"state": "Utah",
			"population": "43,023"
		}, {
			"city": "Fond du Lac",
			"state": "Wisconsin",
			"population": "42,970"
		}, {
			"city": "Everett",
			"state": "Massachusetts",
			"population": "42,935"
		}, {
			"city": "Danville",
			"state": "Virginia",
			"population": "42,907"
		}, {
			"city": "Keller",
			"state": "Texas",
			"population": "42,907"
		}, {
			"city": "Belleville",
			"state": "Illinois",
			"population": "42,895"
		}, {
			"city": "Bell Gardens",
			"state": "California",
			"population": "42,889"
		}, {
			"city": "Cleveland",
			"state": "Tennessee",
			"population": "42,774"
		}, {
			"city": "North Lauderdale",
			"state": "Florida",
			"population": "42,757"
		}, {
			"city": "Fairfield",
			"state": "Ohio",
			"population": "42,635"
		}, {
			"city": "Salem",
			"state": "Massachusetts",
			"population": "42,544"
		}, {
			"city": "Rancho Palos Verdes",
			"state": "California",
			"population": "42,448"
		}, {
			"city": "San Bruno",
			"state": "California",
			"population": "42,443"
		}, {
			"city": "Concord",
			"state": "New Hampshire",
			"population": "42,419"
		}, {
			"city": "Burlington",
			"state": "Vermont",
			"population": "42,284"
		}, {
			"city": "Apex",
			"state": "North Carolina",
			"population": "42,214"
		}, {
			"city": "Midland",
			"state": "Michigan",
			"population": "42,181"
		}, {
			"city": "Altamonte Springs",
			"state": "Florida",
			"population": "42,150"
		}, {
			"city": "Hutchinson",
			"state": "Kansas",
			"population": "41,889"
		}, {
			"city": "Buffalo Grove",
			"state": "Illinois",
			"population": "41,778"
		}, {
			"city": "Urbandale",
			"state": "Iowa",
			"population": "41,776"
		}, {
			"city": "State College",
			"state": "Pennsylvania",
			"population": "41,757"
		}, {
			"city": "Urbana",
			"state": "Illinois",
			"population": "41,752"
		}, {
			"city": "Plainfield",
			"state": "Illinois",
			"population": "41,734"
		}, {
			"city": "Manassas",
			"state": "Virginia",
			"population": "41,705"
		}, {
			"city": "Bartlett",
			"state": "Illinois",
			"population": "41,679"
		}, {
			"city": "Kearny",
			"state": "New Jersey",
			"population": "41,664"
		}, {
			"city": "Oro Valley",
			"state": "Arizona",
			"population": "41,627"
		}, {
			"city": "Findlay",
			"state": "Ohio",
			"population": "41,512"
		}, {
			"city": "Rohnert Park",
			"state": "California",
			"population": "41,398"
		}, {
			"city": "Westfield",
			"state": "Massachusetts",
			"population": "41,301"
		}, {
			"city": "Linden",
			"state": "New Jersey",
			"population": "41,301"
		}, {
			"city": "Sumter",
			"state": "South Carolina",
			"population": "41,190"
		}, {
			"city": "Wilkes-Barre",
			"state": "Pennsylvania",
			"population": "41,108"
		}, {
			"city": "Woonsocket",
			"state": "Rhode Island",
			"population": "41,026"
		}, {
			"city": "Leominster",
			"state": "Massachusetts",
			"population": "41,002"
		}, {
			"city": "Shelton",
			"state": "Connecticut",
			"population": "40,999"
		}, {
			"city": "Brea",
			"state": "California",
			"population": "40,963"
		}, {
			"city": "Covington",
			"state": "Kentucky",
			"population": "40,956"
		}, {
			"city": "Rockwall",
			"state": "Texas",
			"population": "40,922"
		}, {
			"city": "Meridian",
			"state": "Mississippi",
			"population": "40,921"
		}, {
			"city": "Riverton",
			"state": "Utah",
			"population": "40,921"
		}, {
			"city": "St. Cloud",
			"state": "Florida",
			"population": "40,918"
		}, {
			"city": "Quincy",
			"state": "Illinois",
			"population": "40,915"
		}, {
			"city": "Morgan Hill",
			"state": "California",
			"population": "40,836"
		}, {
			"city": "Warren",
			"state": "Ohio",
			"population": "40,768"
		}, {
			"city": "Edmonds",
			"state": "Washington",
			"population": "40,727"
		}, {
			"city": "Burleson",
			"state": "Texas",
			"population": "40,714"
		}, {
			"city": "Beverly",
			"state": "Massachusetts",
			"population": "40,664"
		}, {
			"city": "Mankato",
			"state": "Minnesota",
			"population": "40,641"
		}, {
			"city": "Hagerstown",
			"state": "Maryland",
			"population": "40,612"
		}, {
			"city": "Prescott",
			"state": "Arizona",
			"population": "40,590"
		}, {
			"city": "Campbell",
			"state": "California",
			"population": "40,584"
		}, {
			"city": "Cedar Falls",
			"state": "Iowa",
			"population": "40,566"
		}, {
			"city": "Beaumont",
			"state": "California",
			"population": "40,481"
		}, {
			"city": "La Puente",
			"state": "California",
			"population": "40,435"
		}, {
			"city": "Crystal Lake",
			"state": "Illinois",
			"population": "40,388"
		}, {
			"city": "Fitchburg",
			"state": "Massachusetts",
			"population": "40,383"
		}, {
			"city": "Carol Stream",
			"state": "Illinois",
			"population": "40,379"
		}, {
			"city": "Hickory",
			"state": "North Carolina",
			"population": "40,361"
		}, {
			"city": "Streamwood",
			"state": "Illinois",
			"population": "40,351"
		}, {
			"city": "Norwich",
			"state": "Connecticut",
			"population": "40,347"
		}, {
			"city": "Coppell",
			"state": "Texas",
			"population": "40,342"
		}, {
			"city": "San Gabriel",
			"state": "California",
			"population": "40,275"
		}, {
			"city": "Holyoke",
			"state": "Massachusetts",
			"population": "40,249"
		}, {
			"city": "Bentonville",
			"state": "Arkansas",
			"population": "40,167"
		}, {
			"city": "Florence",
			"state": "Alabama",
			"population": "40,059"
		}, {
			"city": "Peachtree Corners",
			"state": "Georgia",
			"population": "40,059"
		}, {
			"city": "Brentwood",
			"state": "Tennessee",
			"population": "40,021"
		}, {
			"city": "Bozeman",
			"state": "Montana",
			"population": "39,860"
		}, {
			"city": "New Berlin",
			"state": "Wisconsin",
			"population": "39,834"
		}, {
			"city": "Goose Creek",
			"state": "South Carolina",
			"population": "39,823"
		}, {
			"city": "Huntsville",
			"state": "Texas",
			"population": "39,795"
		}, {
			"city": "Prescott Valley",
			"state": "Arizona",
			"population": "39,791"
		}, {
			"city": "Maplewood",
			"state": "Minnesota",
			"population": "39,765"
		}, {
			"city": "Romeoville",
			"state": "Illinois",
			"population": "39,650"
		}, {
			"city": "Duncanville",
			"state": "Texas",
			"population": "39,605"
		}, {
			"city": "Atlantic City",
			"state": "New Jersey",
			"population": "39,551"
		}, {
			"city": "Clovis",
			"state": "New Mexico",
			"population": "39,508"
		}, {
			"city": "The Colony",
			"state": "Texas",
			"population": "39,458"
		}, {
			"city": "Culver City",
			"state": "California",
			"population": "39,428"
		}, {
			"city": "Marlborough",
			"state": "Massachusetts",
			"population": "39,414"
		}, {
			"city": "Hilton Head Island",
			"state": "South Carolina",
			"population": "39,412"
		}, {
			"city": "Moorhead",
			"state": "Minnesota",
			"population": "39,398"
		}, {
			"city": "Calexico",
			"state": "California",
			"population": "39,389"
		}, {
			"city": "Bullhead City",
			"state": "Arizona",
			"population": "39,383"
		}, {
			"city": "Germantown",
			"state": "Tennessee",
			"population": "39,375"
		}, {
			"city": "La Quinta",
			"state": "California",
			"population": "39,331"
		}, {
			"city": "Lancaster",
			"state": "Ohio",
			"population": "39,325"
		}, {
			"city": "Wausau",
			"state": "Wisconsin",
			"population": "39,309"
		}, {
			"city": "Sherman",
			"state": "Texas",
			"population": "39,296"
		}, {
			"city": "Ocoee",
			"state": "Florida",
			"population": "39,172"
		}, {
			"city": "Shakopee",
			"state": "Minnesota",
			"population": "39,167"
		}, {
			"city": "Woburn",
			"state": "Massachusetts",
			"population": "39,083"
		}, {
			"city": "Bremerton",
			"state": "Washington",
			"population": "39,056"
		}, {
			"city": "Rock Island",
			"state": "Illinois",
			"population": "38,877"
		}, {
			"city": "Muskogee",
			"state": "Oklahoma",
			"population": "38,863"
		}, {
			"city": "Cape Girardeau",
			"state": "Missouri",
			"population": "38,816"
		}, {
			"city": "Annapolis",
			"state": "Maryland",
			"population": "38,722"
		}, {
			"city": "Greenacres",
			"state": "Florida",
			"population": "38,696"
		}, {
			"city": "Ormond Beach",
			"state": "Florida",
			"population": "38,661"
		}, {
			"city": "Hallandale Beach",
			"state": "Florida",
			"population": "38,632"
		}, {
			"city": "Stanton",
			"state": "California",
			"population": "38,623"
		}, {
			"city": "Puyallup",
			"state": "Washington",
			"population": "38,609"
		}, {
			"city": "Pacifica",
			"state": "California",
			"population": "38,606"
		}, {
			"city": "Hanover Park",
			"state": "Illinois",
			"population": "38,510"
		}, {
			"city": "Hurst",
			"state": "Texas",
			"population": "38,448"
		}, {
			"city": "Lima",
			"state": "Ohio",
			"population": "38,355"
		}, {
			"city": "Marana",
			"state": "Arizona",
			"population": "38,290"
		}, {
			"city": "Carpentersville",
			"state": "Illinois",
			"population": "38,241"
		}, {
			"city": "Oakley",
			"state": "California",
			"population": "38,194"
		}, {
			"city": "Huber Heights",
			"state": "Ohio",
			"population": "38,142"
		}, {
			"city": "Lancaster",
			"state": "Texas",
			"population": "38,071"
		}, {
			"city": "Montclair",
			"state": "California",
			"population": "38,027"
		}, {
			"city": "Wheeling",
			"state": "Illinois",
			"population": "38,015"
		}, {
			"city": "Brookfield",
			"state": "Wisconsin",
			"population": "37,999"
		}, {
			"city": "Park Ridge",
			"state": "Illinois",
			"population": "37,839"
		}, {
			"city": "Florence",
			"state": "South Carolina",
			"population": "37,792"
		}, {
			"city": "Roy",
			"state": "Utah",
			"population": "37,733"
		}, {
			"city": "Winter Garden",
			"state": "Florida",
			"population": "37,711"
		}, {
			"city": "Chelsea",
			"state": "Massachusetts",
			"population": "37,670"
		}, {
			"city": "Valley Stream",
			"state": "New York",
			"population": "37,659"
		}, {
			"city": "Spartanburg",
			"state": "South Carolina",
			"population": "37,647"
		}, {
			"city": "Lake Oswego",
			"state": "Oregon",
			"population": "37,610"
		}, {
			"city": "Friendswood",
			"state": "Texas",
			"population": "37,587"
		}, {
			"city": "Westerville",
			"state": "Ohio",
			"population": "37,530"
		}, {
			"city": "Northglenn",
			"state": "Colorado",
			"population": "37,499"
		}, {
			"city": "Phenix City",
			"state": "Alabama",
			"population": "37,498"
		}, {
			"city": "Grove City",
			"state": "Ohio",
			"population": "37,490"
		}, {
			"city": "Texarkana",
			"state": "Texas",
			"population": "37,442"
		}, {
			"city": "Addison",
			"state": "Illinois",
			"population": "37,385"
		}, {
			"city": "Dover",
			"state": "Delaware",
			"population": "37,366"
		}, {
			"city": "Lincoln Park",
			"state": "Michigan",
			"population": "37,313"
		}, {
			"city": "Calumet City",
			"state": "Illinois",
			"population": "37,240"
		}, {
			"city": "Muskegon",
			"state": "Michigan",
			"population": "37,213"
		}, {
			"city": "Aventura",
			"state": "Florida",
			"population": "37,199"
		}, {
			"city": "Martinez",
			"state": "California",
			"population": "37,165"
		}, {
			"city": "Greenfield",
			"state": "Wisconsin",
			"population": "37,159"
		}, {
			"city": "Apache Junction",
			"state": "Arizona",
			"population": "37,130"
		}, {
			"city": "Monrovia",
			"state": "California",
			"population": "37,101"
		}, {
			"city": "Weslaco",
			"state": "Texas",
			"population": "37,093"
		}, {
			"city": "Keizer",
			"state": "Oregon",
			"population": "37,064"
		}, {
			"city": "Spanish Fork",
			"state": "Utah",
			"population": "36,956"
		}, {
			"city": "Beloit",
			"state": "Wisconsin",
			"population": "36,888"
		}, {
			"city": "Panama City",
			"state": "Florida",
			"population": "36,877"
		}]
	};

/***/ },
/* 9 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
		"description": "A list of occupations (jobs that people might have).",
		"occupations": ["accountant", "actor", "actuary", "adhesive bonding machine tender", "adjudicator", "administrative assistant", "administrative services manager", "adult education teacher", "advertising manager", "advertising sales agent", "aerobics instructor", "aerospace engineer", "aerospace engineering technician", "agent", "agricultural engineer", "agricultural equipment operator", "agricultural grader", "agricultural inspector", "agricultural manager", "agricultural sciences teacher", "agricultural sorter", "agricultural technician", "agricultural worker", "air conditioning installer", "air conditioning mechanic", "air traffic controller", "aircraft cargo handling supervisor", "aircraft mechanic", "aircraft service technician", "airline copilot", "airline pilot", "ambulance dispatcher", "ambulance driver", "amusement machine servicer", "anesthesiologist", "animal breeder", "animal control worker", "animal scientist", "animal trainer", "animator", "answering service operator", "anthropologist", "apparel patternmaker", "apparel worker", "arbitrator", "archeologist", "architect", "architectural drafter", "architectural manager", "archivist", "art director", "art teacher", "artist", "assembler", "astronomer", "athlete", "athletic trainer", "ATM machine repairer", "atmospheric scientist", "attendant", "audio and video equipment technician", "audio-visual and multimedia collections specialist", "audiologist", "auditor", "author", "auto damage insurance appraiser", "automotive and watercraft service attendant", "automotive glass installer", "automotive mechanic", "avionics technician", "baggage porter", "bailiff", "baker", "barback", "barber", "bartender", "basic education teacher", "behavioral disorder counselor", "bellhop", "bench carpenter", "bicycle repairer", "bill and account collector", "billing and posting clerk", "biochemist", "biological technician", "biomedical engineer", "biophysicist", "blaster", "blending machine operator", "blockmason", "boiler operator", "boilermaker", "bookkeeper", "boring machine tool tender", "brazer", "brickmason", "bridge and lock tender", "broadcast news analyst", "broadcast technician", "brokerage clerk", "budget analyst", "building inspector", "bus mechanic", "butcher", "buyer", "cabinetmaker", "cafeteria attendant", "cafeteria cook", "camera operator", "camera repairer", "cardiovascular technician", "cargo agent", "carpenter", "carpet installer", "cartographer", "cashier", "caster", "ceiling tile installer", "cellular equipment installer", "cement masonchanneling machine operator", "chauffeur", "checker", "chef", "chemical engineer", "chemical plant operator", "chemist", "chemistry teacher", "chief executive", "child social worker", "childcare worker", "chiropractor", "choreographer", "civil drafter", "civil engineer", "civil engineering technician", "claims adjuster", "claims examiner", "claims investigator", "cleaner", "clinical laboratory technician", "clinical laboratory technologist", "clinical psychologist", "coating worker", "coatroom attendant", "coil finisher", "coil taper", "coil winder", "coin machine servicer", "commercial diver", "commercial pilot", "commodities sales agent", "communications equipment operator", "communications teacher", "community association manager", "community service manager", "compensation and benefits manager", "compliance officer", "composer", "computer hardware engineer", "computer network architect", "computer operator", "computer programmer", "computer science teacher", "computer support specialist", "computer systems administrator", "computer systems analyst", "concierge", "conciliator", "concrete finisher", "conservation science teacher", "conservation scientist", "conservation worker", "conservator", "construction inspector", "construction manager", "construction painter", "construction worker", "continuous mining machine operator", "convention planner", "conveyor operator", "cook", "cooling equipment operator", "copy marker", "correctional officer", "correctional treatment specialist", "correspondence clerk", "correspondent", "cosmetologist", "cost estimator", "costume attendant", "counseling psychologist", "counselor", "courier", "court reporter", "craft artist", "crane operator", "credit analyst", "credit checker", "credit counselor", "criminal investigator", "criminal justice teacher", "crossing guard", "curator", "custom sewer", "customer service representative", "cutter", "cutting machine operator", "dancer", "data entry keyer", "database administrator", "decorating worker", "delivery services driver", "demonstrator", "dental assistant", "dental hygienist", "dental laboratory technician", "dentist", "derrick operator", "designer", "desktop publisher", "detective", "diagnostic medical sonographer", "die maker", "diesel engine specialist", "dietetic technician", "dietitian", "dinkey operator", "director", "dishwasher", "dispatcher", "door-to-door sales worker", "drafter", "dragline operator", "drama teacher", "dredge operator", "dressing room attendant", "dressmaker", "drier operator", "drilling machine tool operator", "dry-cleaning workerdrywall installer", "dyeing machine operator", "earth driller", "economics teacher", "economist", "editor", "education administrator", "electric motor repairer", "electrical electronics drafter", "electrical engineer", "electrical equipment assembler", "electrical installer", "electrical power-line installer", "electrician", "electro-mechanical technician", "elementary school teacher", "elevator installer", "elevator repairer", "embalmer", "emergency management director", "emergency medical technician", "engine assembler", "engineer", "engineering manager", "engineering teacher", "english language teacher", "engraver", "entertainment attendant", "environmental engineer", "environmental science teacher", "environmental scientist", "epidemiologist", "escort", "etcher", "event planner", "excavating operator", "executive administrative assistant", "executive secretary", "exhibit designer", "expediting clerk", "explosives worker", "extraction worker", "fabric mender", "fabric patternmaker", "fabricator", "faller", "family practitioner", "family social worker", "family therapist", "farm advisor", "farm equipment mechanic", "farm labor contractor", "farmer", "farmworker", "fashion designer", "fast food cook", "fence erector", "fiberglass fabricator", "fiberglass laminator", "file clerk", "filling machine operator", "film and video editor", "financial analyst", "financial examiner", "financial manager", "financial services sales agent", "fine artist", "fire alarm system installer", "fire dispatcher", "fire inspector", "fire investigator", "firefighter", "fish and game warden", "fish cutter", "fish trimmer", "fisher", "fitness studies teacher", "fitness trainer", "flight attendant", "floor finisher", "floor layer", "floor sander", "floral designer", "food batchmaker", "food cooking machine operator", "food preparation worker", "food science technician", "food scientist", "food server", "food service manager", "food technologist", "foreign language teacher", "foreign literature teacher", "forensic science technician", "forest fire inspector", "forest fire prevention specialist", "forest worker", "forester", "forestry teacher", "forging machine setter", "foundry coremaker", "freight agent", "freight mover", "fundraising manager", "funeral attendant", "funeral director", "funeral service manager", "furnace operator", "furnishings worker", "furniture finisher", "gaming booth cashier", "gaming cage worker", "gaming change person", "gaming dealer", "gaming investigator", "gaming manager", "gaming surveillance officer", "garment mender", "garment presser", "gas compressor", "gas plant operator", "gas pumping station operator", "general manager", "general practitioner", "geographer", "geography teacher", "geological engineer", "geological technician", "geoscientist", "glazier", "government program eligibility interviewer", "graduate teaching assistant", "graphic designer", "groundskeeper", "groundskeeping worker", "gynecologist", "hairdresser", "hairstylist", "hand grinding worker", "hand laborer", "hand packager", "hand packer", "hand polishing worker", "hand sewer", "hazardous materials removal worker", "head cook", "health and safety engineer", "health educator", "health information technician", "health services manager", "health specialties teacher", "healthcare social worker", "hearing officer", "heat treating equipment setter", "heating installer", "heating mechanic", "heavy truck driver", "highway maintenance worker", "historian", "history teacher", "hoist and winch operator", "home appliance repairer", "home economics teacher", "home entertainment installer", "home health aide", "home management advisor", "host", "hostess", "hostler", "hotel desk clerk", "housekeeping cleaner", "human resources assistant", "human resources manager", "human service assistant", "hunter", "hydrologist", "illustrator", "industrial designer", "industrial engineer", "industrial engineering technician", "industrial machinery mechanic", "industrial production manager", "industrial truck operator", "industrial-organizational psychologist", "information clerk", "information research scientist", "information security analyst", "information systems manager", "inspector", "instructional coordinator", "instructor", "insulation worker", "insurance claims clerk", "insurance sales agent", "insurance underwriter", "intercity bus driver", "interior designer", "internist", "interpreter", "interviewer", "investigator", "jailer", "janitor", "jeweler", "judge", "judicial law clerk", "kettle operator", "kiln operator", "kindergarten teacher", "laboratory animal caretaker", "landscape architect", "landscaping worker", "lathe setter", "laundry worker", "law enforcement teacher", "law teacher", "lawyer", "layout worker", "leather worker", "legal assistant", "legal secretary", "legislator", "librarian", "library assistant", "library science teacher", "library technician", "licensed practical nurse", "licensed vocational nurse", "life scientist", "lifeguard", "light truck driver", "line installer", "literacy teacher", "literature teacher", "loading machine operator", "loan clerk", "loan interviewer", "loan officer", "lobby attendant", "locker room attendant", "locksmith", "locomotive engineer", "locomotive firer", "lodging manager", "log grader", "logging equipment operator", "logistician", "machine feeder", "machinist", "magistrate judge", "magistrate", "maid", "mail clerk", "mail machine operator", "mail superintendent", "maintenance painter", "maintenance worker", "makeup artist", "management analyst", "manicurist", "manufactured building installer", "mapping technician", "marble setter", "marine engineer", "marine oiler", "market research analyst", "marketing manager", "marketing specialist", "marriage therapist", "massage therapist", "material mover", "materials engineer", "materials scientist", "mathematical science teacher", "mathematical technician", "mathematician", "maxillofacial surgeon", "measurer", "meat cutter", "meat packer", "meat trimmer", "mechanical door repairer", "mechanical drafter", "mechanical engineer", "mechanical engineering technician", "mediator", "medical appliance technician", "medical assistant", "medical equipment preparer", "medical equipment repairer", "medical laboratory technician", "medical laboratory technologist", "medical records technician", "medical scientist", "medical secretary", "medical services manager", "medical transcriptionist", "meeting planner", "mental health counselor", "mental health social worker", "merchandise displayer", "messenger", "metal caster", "metal patternmaker", "metal pickling operator", "metal pourer", "metal worker", "metal-refining furnace operator", "metal-refining furnace tender", "meter reader", "microbiologist", "middle school teacher", "milling machine setter", "millwright", "mine cutting machine operator", "mine shuttle car operator", "mining engineer", "mining safety engineer", "mining safety inspector", "mining service unit operator", "mixing machine setter", "mobile heavy equipment mechanic", "mobile home installer", "model maker", "model", "molder", "mortician", "motel desk clerk", "motion picture projectionist", "motorboat mechanic", "motorboat operator", "motorboat service technician", "motorcycle mechanic", "multimedia artist", "museum technician", "music director", "music teacher", "musical instrument repairer", "musician", "natural sciences manager", "naval architect", "network systems administrator", "new accounts clerk", "news vendor", "nonfarm animal caretaker", "nuclear engineer", "nuclear medicine technologist", "nuclear power reactor operator", "nuclear technician", "nursing aide", "nursing instructor", "nursing teacher", "nutritionist", "obstetrician", "occupational health and safety specialist", "occupational health and safety technician", "occupational therapist", "occupational therapy aide", "occupational therapy assistant", "offbearer", "office clerk", "office machine operator", "operating engineer", "operations manager", "operations research analyst", "ophthalmic laboratory technician", "optician", "optometrist", "oral surgeon", "order clerk", "order filler", "orderly", "ordnance handling expert", "orthodontist", "orthotist", "outdoor power equipment mechanic", "oven operator", "packaging machine operator", "painter ", "painting worker", "paper goods machine setter", "paperhanger", "paralegal", "paramedic", "parking enforcement worker", "parking lot attendant", "parts salesperson", "paving equipment operator", "payroll clerk", "pediatrician", "pedicurist", "personal care aide", "personal chef", "personal financial advisor", "pest control worker", "pesticide applicator", "pesticide handler", "pesticide sprayer", "petroleum engineer", "petroleum gauger", "petroleum pump system operator", "petroleum refinery operator", "petroleum technician", "pharmacist", "pharmacy aide", "pharmacy technician", "philosophy teacher", "photogrammetrist", "photographer", "photographic process worker", "photographic processing machine operator", "physical therapist aide", "physical therapist assistant", "physical therapist", "physician assistant", "physician", "physicistphysics teacher", "pile-driver operator", "pipefitter", "pipelayer", "planing machine operator", "planning clerk", "plant operator", "plant scientist", "plasterer", "plastic patternmaker", "plastic worker", "plumber", "podiatrist", "police dispatcher", "police officer", "policy processing clerk", "political science teacher", "political scientist", "postal service clerk", "postal service mail carrier", "postal service mail processing machine operator", "postal service mail processor", "postal service mail sorter", "postmaster", "postsecondary teacher", "poultry cutter", "poultry trimmer", "power dispatcher", "power distributor", "power plant operator", "power tool repairer", "precious stone worker", "precision instrument repairer", "prepress technician", "preschool teacher", "priest", "print binding worker", "printing press operator", "private detective", "probation officer", "procurement clerk", "producer", "product promoter", "production clerk", "production occupation", "proofreader", "property manager", "prosthetist", "prosthodontist", "psychiatric aide", "psychiatric technician", "psychiatrist", "psychologist", "psychology teacher", "public relations manager", "public relations specialist", "pump operator", "purchasing agent", "purchasing manager", "radiation therapist", "radio announcer", "radio equipment installer", "radio operator", "radiologic technician", "radiologic technologist", "rail car repairer", "rail transportation worker", "rail yard engineer", "rail-track laying equipment operator", "railroad brake operator", "railroad conductor", "railroad police", "rancher", "real estate appraiser", "real estate broker", "real estate manager", "real estate sales agent", "receiving clerk", "receptionist", "record clerk", "recreation teacher", "recreation worker", "recreational therapist", "recreational vehicle service technician", "recyclable material collector", "referee", "refractory materials repairer", "refrigeration installer", "refrigeration mechanic", "refuse collector", "regional planner", "registered nurse", "rehabilitation counselor", "reinforcing iron worker", "reinforcing rebar worker", "religion teacher", "religious activities director", "religious worker", "rental clerk", "repair worker", "reporter", "residential advisor", "resort desk clerk", "respiratory therapist", "respiratory therapy technician", "retail buyer", "retail salesperson", "revenue agent", "rigger", "rock splitter", "rolling machine tender", "roof bolter", "roofer", "rotary drill operator", "roustabout", "safe repairer", "sailor", "sales engineer", "sales manager", "sales representative", "sampler", "sawing machine operator", "scaler", "school bus driver", "school psychologist", "school social worker", "scout leader", "sculptor", "secondary education teacher", "secondary school teacher", "secretary", "securities sales agent", "security guard", "security system installer", "segmental paver", "self-enrichment education teacher", "semiconductor processor", "septic tank servicer", "set designer", "sewer pipe cleaner", "sewing machine operator", "shampooer", "shaper", "sheet metal worker", "sheriff's patrol officer", "ship captain", "ship engineer", "ship loader", "shipmate", "shipping clerk", "shoe machine operator", "shoe worker", "short order cook", "signal operator", "signal repairer", "singer", "ski patrol", "skincare specialist", "slaughterer", "slicing machine tender", "slot supervisor", "social science research assistant", "social sciences teacher", "social scientist", "social service assistant", "social service manager", "social work teacher", "social worker", "sociologist", "sociology teacher", "software developer", "software engineer", "soil scientist", "solderer", "sorter", "sound engineering technician", "space scientist", "special education teacher", "speech-language pathologist", "sports book runner", "sports entertainer", "sports performer", "stationary engineer", "statistical assistant", "statistician", "steamfitter", "stock clerk", "stock mover", "stonemason", "street vendor", "streetcar operator", "structural iron worker", "structural metal fabricator", "structural metal fitter", "structural steel worker", "stucco mason", "substance abuse counselor", "substance abuse social worker", "subway operator", "surfacing equipment operator", "surgeon", "surgical technologist", "survey researcher", "surveying technician", "surveyor", "switch operator", "switchboard operator", "tailor", "tamping equipment operator", "tank car loader", "taper", "tax collector", "tax examiner", "tax preparer", "taxi driver", "teacher assistant", "teacher", "team assembler", "technical writer", "telecommunications equipment installer", "telemarketer", "telephone operator", "television announcer", "teller", "terrazzo finisher", "terrazzo worker", "tester", "textile bleaching operator", "textile cutting machine setter", "textile knitting machine setter", "textile presser", "textile worker", "therapist", "ticket agent", "ticket taker", "tile setter", "timekeeping clerk", "timing device assembler", "tire builder", "tire changertire repairer", "title abstractor", "title examiner", "title searcher", "tobacco roasting machine operator", "tool filer", "tool grinder", "tool maker", "tool sharpener", "tour guide", "tower equipment installer", "tower operator", "track switch repairer", "tractor operator", "tractor-trailer truck driver", "traffic clerk", "traffic technician", "training and development manager", "training and development specialist", "transit police", "translator", "transportation equipment painter", "transportation inspector", "transportation security screener", "transportation worker", "trapper", "travel agent", "travel clerk", "travel guide", "tree pruner", "tree trimmer", "trimmer", "truck loader", "truck mechanic", "tuner", "turning machine tool operator", "typist", "umpire", "undertaker", "upholsterer", "urban planner", "usher", "valve installer", "vending machine servicer", "veterinarian", "veterinary assistant", "veterinary technician", "vocational counselor", "vocational education teacher", "waiter", "waitress", "watch repairer", "water treatment plant operator", "weaving machine setter", "web developer", "weigher", "welder", "wellhead pumper", "wholesale buyer", "wildlife biologist", "window trimmer", "wood patternmaker", "woodworker", "word processor", "writer", "yardmaster", "zoologist"]
	};

/***/ },
/* 10 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
		"description": "metals",
		"metals": ["actinium", "aluminium", "americium", "barium", "berkelium", "beryllium", "bismuth", "bohrium", "cadmium", "calcium", "californium", "cerium", "cesium", "chromium", "cobalt", "copper", "curium", "darmstadtium", "dubnium", "dysprosium", "einsteinium", "erbium", "europium", "fermium", "francium", "gadolinium", "gallium", "gold", "hafnium", "hassium", "holmium", "indium", "iridium", "iron", "lanthanum", "lawrencium", "lead", "lithium", "lutetium", "magnesium", "manganese", "meitnerium", "mendelevium", "mercury", "molybdenum", "neodymium", "neptunium", "nickel", "niobium", "nobelium", "osmium", "palladium", "platinum", "plutonium", "polonium", "potassium", "praseodymium", "promethium", "protactinium", "radium", "rhenium", "rhodium", "roentgenium", "rubidium", "ruthenium", "rutherfordium", "samarium", "scandium", "seaborgium", "silver", "sodium", "strontium", "tantalum", "technetium", "terbium", "thallium", "thorium", "thulium", "tin", "titanium", "tungsten", "ununbium", "ununhexium", "ununpentium", "ununquadium", "ununtrium", "uranium", "vanadium", "ytterbium", "yttrium", "zinc", "zirconium"]
	};

/***/ },
/* 11 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
		"description": "A list of monsters and other mythic creatures",
		"sources": "some from https://en.wikipedia.org/wiki/Mythic_humanoids, others from memory.",
		"names": ["angel", "brownie", "bugbear", "centaur", "chimera", "chupacabra", "cockatrice", "cyclops", "demon", "djinn", "dragon", "draugr", "dryad", "dwarf", "elemental", "elf", "fairy", "faun", "frost giant", "gargoyle", "genie", "ghast", "ghost", "ghoul", "giant", "gnome", "goblin", "golem", "gorgon", "gremlin", "griffon", "hag", "harpy", "hippogriff", "hobgoblin", "homonculus", "hydra", "imp", "incubus", "kappa", "kobold", "kraken", "lamassu", "leprechaun", "lich", "manticore", "mermaid", "merman", "minotaur", "mummy", "naga", "nix", "nymph", "ogre", "oni", "orc", "pegasus", "phoenix", "pixie", "poltergeist", "roc", "sasquatch", "satyr", "selkie", "siren", "spectre", "sphinx", "sprite", "succubus", "sylph", "thunderbird", "troll", "unicorn", "vampire", "valkyrie", "warg", "wendigo", "werewolf", "wight", "witch", "wraith", "wyvern", "yeti", "zombie"]
	};

/***/ },
/* 12 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
		"description": "List of household objects",
		"objects": ["CD", "Christmas ornament", "acorn", "apple", "bag", "bag of cotton balls", "bag of popcorn", "bag of rubber bands", "ball of yarn", "balloon", "banana", "bananas", "bandana", "bangle bracelet", "bar of soap", "baseball", "baseball bat", "baseball hat", "basketball", "beaded bracelet", "beaded necklace", "bed", "beef", "bell", "belt", "blouse", "blowdryer", "bonesaw", "book", "book of jokes", "book of matches", "bookmark", "boom box", "bottle", "bottle cap", "bottle of glue", "bottle of honey", "bottle of ink", "bottle of lotion", "bottle of nail polish", "bottle of oil", "bottle of paint", "bottle of perfume", "bottle of pills", "bottle of soda", "bottle of sunscreen", "bottle of syrup", "bottle of water", "bouquet of flowers", "bow", "bow tie", "bowl", "box", "box of Q-tips", "box of baking soda", "box of chalk", "box of chocolates", "box of crayons", "box of markers", "box of tissues", "bracelet", "bread", "broccoli", "brush", "buckle", "butter knife", "button", "camera", "can of beans", "can of chili", "can of peas", "can of whipped cream", "candle", "candlestick", "candy bar", "candy cane", "candy wrapper", "canteen", "canvas", "car", "card", "carrot", "carrots", "cars", "carton of ice cream", "cat", "catalogue", "cell phone", "cellphone", "cement stone", "chain", "chair", "chalk", "chapter book", "check book", "chenille stick", "chicken", "children's book", "chocolate", "class ring", "clay pot", "clock", "clothes", "clothes pin", "coffee mug", "coffee pot", "comb", "comic book", "computer", "conditioner", "container of pudding", "cookie jar", "cookie tin", "cork", "couch", "cow", "cowboy hat", "craft book", "credit card", "crow", "crowbar", "cucumber", "cup", "dagger", "deodorant ", "desk", "dictionary", "dog", "dolphin", "domino set", "door", "dove", "drawer", "drill press", "egg", "egg beater", "egg timer", "empty bottle", "empty jar", "empty tin can", "eraser", "extension cord", "eye liner", "face wash", "fake flowers", "feather", "feather duster", "few batteries", "fish", "fishing hook", "flag", "flashlight", "floor", "flowers", "flyswatter", "food", "football", "fork", "fridge", "frying pan", "game CD", "game cartridge", "garden spade", "giraffe", "glass", "glasses", "glow stick", "grid paper", "grocery list", "hair brush", "hair clip", "hair pin", "hair ribbon", "hair tie", "hammer", "hamster", "hand bag", "hand fan", "hand mirror", "handbasket", "handful of change", "handheld game system", "hanger", "harmonica", "helmet", "house", "ice cream stick", "ice cube", "ice pick", "incense holder", "ipod", "ipod charger", "jar of jam", "jar of peanut butter", "jar of pickles", "jigsaw puzzle", "key", "key chain", "keyboard", "keychain", "keys", "kitchen knife", "knife", "lace", "ladle", "lamp", "lamp shade", "laser pointer", "leg warmers", "lemon", "letter opener", "light", "light bulb", "lighter", "lime", "lion", "lip gloss", "locket", "lotion", "magazine", "magnet", "magnifying glass", "map", "marble", "martini glass", "matchbook", "microphone", "milk", "miniature portrait", "mirror", "mobile phone", "model car", "money", "monitor", "mop", "mouse pad", "mp3 player", "multitool", "music CD", "nail", "nail clippers", "nail filer", "necktie", "needle", "notebook", "notepad", "novel", "ocarina", "orange", "outlet", "pack of cards", "package of crisp and crunchy edibles", "package of glitter", "packet of seeds", "pail", "paint brush", "paintbrush", "pair of binoculars", "pair of dice", "pair of earrings", "pair of glasses", "pair of handcuffs", "pair of knitting needles", "pair of rubber gloves", "pair of safety goggles", "pair of scissors", "pair of socks", "pair of sunglasses", "pair of tongs", "pair of water goggles", "panda", "pants", "paper", "paperclip", "pasta strainer", "pearl necklace", "pen", "pencil", "pencil holder", "pepper shaker", "perfume", "phone", "photo album", "picture frame", "piece of gum", "pillow", "pinecone", "plastic fork", "plate", "plush bear", "plush cat", "plush dinosaur", "plush dog", "plush frog", "plush octopus", "plush pony", "plush rabbit", "plush unicorn", "pocketknife", "pocketwatch", "pool stick", "pop can", "postage stamp", "puddle", "purse", "purse/bag", "quartz crystal", "quilt", "rabbit", "radio", "rat", "remote", "rhino", "ring", "rock", "roll of duct tape", "roll of gauze", "roll of masking tape", "roll of stickers", "roll of toilet paper", "rolling pin", "rope", "rubber band", "rubber duck", "rubber stamp", "rug", "rusty nail", "safety pin", "sailboat", "salt shaker", "sand paper", "sandal", "sandglass", "scallop shell", "scarf", "scotch tape", "screw", "screwdriver", "seat belt", "shampoo", "shark", "sharpie", "shawl", "sheep", "sheet of paper", "shirt", "shirt button", "shoe lace", "shoes", "shopping bag", "shovel", "sidewalk", "sketch pad", "slipper", "small pouch", "snail shell", "snowglobe", "soap", "soccer ball", "socks", "sofa", "spatula", "speakers ", "spectacles", "spice bottle", "sponge", "spool of ribbon", "spool of string", "spool of thread", "spool of wire", "spoon", "spring", "squirrel", "squirt gun", "statuette", "steak knife", "stick", "stick of incense", "sticker book", "sticky note", "stockings", "stop sign", "straw", "street lights", "sun glasses", "sword", "table", "tea cup", "tea pot", "teddies", "television", "tennis ball", "tennis racket", "thermometer", "thimble", "thread", "tiger", "tire swing", "tissue box", "toe ring", "toilet", "toilet paper tube", "tomato", "tooth pick", "toothbrush", "toothpaste", "toothpick", "towel", "toy boat", "toy car", "toy plane", "toy robot", "toy soldier", "toy top", "trash bag", "tree", "trucks", "tube of lip balm", "tube of lipstick", "turtle", "tv", "tweezers", "twister", "umbrella", "vase", "video games", "wallet", "washcloth", "washing machine", "watch", "water", "water bottle", "wedding ring", "whale", "whip", "whistle", "white out", "window", "wine glass", "wireless control", "wishbone", "wooden spoon", "word search", "wrench", "wristwatch", "zebra", "zipper"]
	};

/***/ },
/* 13 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
		"flowers": ["anemone", "amaryllis", "amaranth", "aster", "azalea", "babys breath", "begonia", "bellflower", "bergamot", "bird of paradise", "bluebell", "bottlebrush", "buttercup", "camellias", "carnation", "chrysantemum", "columbine", "clover", "crocus", "daisy", "dahlia", "daffodil", "delphinium", "edelweiss", "primrose", "forget me not", "foxglove", "freesia", "gerbera daisy", "gladiolus", "hibiscus", "heather", "hyacinth", "holly", "iris", "jasmine", "ladys slipper", "lavender", "lilac", "lily", "lotus flower", "marigold", "marjoram", "mimosa", "narcissus", "orange blossom", "orchid", "peach blossom", "peony", "petunia", "rhododendron", "rosemary", "roses", "sage", "snapdragon", "sunflower", "tansy", "thistle", "thyme", "tulip", "violet", "water lily", "zinnia"]
	};

/***/ },
/* 14 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
		"description": "A list of home appliances",
		"appliances": ["air conditioner", "air fryer", "air ioniser", "aroma lamp", "attic fan", "bachelor griller", "back boiler", "barbecue", "beehive oven", "beverage opener", "boiler", "bread machine", "butane torch", "can opener", "ceiling fan", "central vacuum cleaner", "clothes dryer", "clothes iron", "coffee percolator", "coffeemaker", "combo washer dryer", "compactor", "convection heater", "convection microwave", "convection oven", "corn roaster", "crepe maker", "deep fryer", "dehumidifier", "dishwasher", "earth oven", "electric cooker", "electric water boiler", "embroidery machine", "energy regulator", "espresso machine", "fan heater", "field kitchen", "fire pot", "fireplace toaster", "flame supervision device", "flattop grill", "food steamer", "garbage disposal unit", "hair dryer", "hair iron", "halogen oven", "home server", "hot plate", "humidifier", "HVAC", "icebox", "instant hot water dispenser", "internet refrigerator", "kettle", "kimchi refrigerator", "kitchener range", "micathermic heater", "microwave oven", "mousetrap", "oil heater", "oven", "panini sandwich grill", "patio heater", "pneumatic vacuum", "popcorn maker", "pressure cooker", "pressure fryer", "radiator", "reflector oven", "refrigerator", "rice cooker", "rice polisher", "robotic vacuum cleaner", "rotisserie", "sandwich toaster", "self-cleaning oven", "set-n-forget cooker", "sewing machine", "slow cooker", "solar cooker", "sous-vide cooker", "soy milk maker", "stove", "sump pump", "susceptor", "swamp cooler", "tandoor", "thermal immersion circulator", "thermal mass refrigerator", "tie press", "toaster", "toaster oven", "trivet", "trouser press", "turkey fryer", "vacuum cleaner", "vacuum fryer", "vaporizer", "waffle iron", "washing machine", "water cooker", "water cooler", "water heater", "wet grinder", "window fan", "wood-fired oven"]
	};

/***/ },
/* 15 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
		"description": "A list of English adjectives.",
		"adjs": ["Aristotelian", "Arthurian", "Bohemian", "Brethren", "Mosaic", "Oceanic", "Proctor", "Terran", "Tudor", "abroad", "absorbing", "abstract", "academic", "accelerated", "accented", "accountant", "acquainted", "acute", "addicting", "addictive", "adjustable", "admired", "adult", "adverse", "advised", "aerosol", "afraid", "aggravated", "aggressive", "agreeable", "alienate", "aligned", "all-round", "alleged", "almond", "alright", "altruistic", "ambient", "ambivalent", "amiable", "amino", "amorphous", "amused", "anatomical", "ancestral", "angelic", "angrier", "answerable", "antiquarian", "antiretroviral", "appellate", "applicable", "apportioned", "approachable", "appropriated", "archer", "aroused", "arrested", "assertive", "assigned", "athletic", "atrocious", "attained", "authoritarian", "autobiographical", "avaricious", "avocado", "awake", "awsome", "backstage", "backwoods", "balding", "bandaged", "banded", "banned", "barreled", "battle", "beaten", "begotten", "beguiled", "bellied", "belted", "beneficent", "besieged", "betting", "big-money", "biggest", "biochemical", "bipolar", "blackened", "blame", "blessed", "blindfolded", "bloat", "blocked", "blooded", "blue-collar", "blushing", "boastful", "bolder", "bolstered", "bonnie", "bored", "boundary", "bounded", "bounding", "branched", "brawling", "brazen", "breeding", "bridged", "brimming", "brimstone", "broadest", "broiled", "broker", "bronze", "bruising", "buffy", "bullied", "bungling", "burial", "buttery", "candied", "canonical", "cantankerous", "cardinal", "carefree", "caretaker", "casual", "cathartic", "causal", "chapel", "characterized", "charcoal", "cheeky", "cherished", "chipotle", "chirping", "chivalrous", "circumstantial", "civic", "civil", "civilised", "clanking", "clapping", "claptrap", "classless", "cleansed", "cleric", "cloistered", "codified", "colloquial", "colour", "combat", "combined", "comely", "commissioned", "commonplace", "commuter", "commuting", "comparable", "complementary", "compromising", "conceding", "concentrated", "conceptual", "conditioned", "confederate", "confident", "confidential", "confining", "confuse", "congressional", "consequential", "conservative", "constituent", "contaminated", "contemporaneous", "contraceptive", "convertible", "convex", "cooked", "coronary", "corporatist", "correlated", "corroborated", "cosmic", "cover", "crash", "crypto", "culminate", "cushioned", "dandy", "dashing", "dazzled", "decreased", "decrepit", "dedicated", "defaced", "defective", "defenseless", "deluded", "deodorant", "departed", "depress", "designing", "despairing", "destitute", "detective", "determined", "devastating", "deviant", "devilish", "devoted", "diagonal", "dictated", "didactic", "differentiated", "diffused", "dirtier", "disabling", "disconnected", "discovered", "disdainful", "diseased", "disfigured", "disheartened", "disheveled", "disillusioned", "disparate", "dissident", "doable", "doctrinal", "doing", "dotted", "double-blind", "downbeat", "dozen", "draining", "draught", "dread", "dried", "dropped", "dulled", "duplicate", "eaten", "echoing", "economical", "elaborated", "elastic", "elective", "electoral", "elven", "embryo", "emerald", "emergency", "emissary", "emotional", "employed", "enamel", "encased", "encrusted", "endangered", "engraved", "engrossing", "enlarged", "enlisted", "enlivened", "ensconced", "entangled", "enthralling", "entire", "envious", "eradicated", "eroded", "esoteric", "essential", "evaporated", "ever-present", "evergreen", "everlasting", "exacting", "exasperated", "excess", "exciting", "executable", "existent", "exonerated", "exorbitant", "exponential", "export", "extraordinary", "exultant", "exulting", "facsimile", "fading", "fainter", "faith-based", "fallacious", "faltering", "famous", "fancier", "fast-growing", "fated", "favourable", "fearless", "feathered", "fellow", "fermented", "ferocious", "fiddling", "filling", "firmer", "fitted", "flammable", "flawed", "fledgling", "fleshy", "flexible", "flickering", "floral", "flowering", "flowing", "foggy", "folic", "foolhardy", "foolish", "footy", "forehand", "forked", "formative", "formulaic", "foul-mouthed", "fractional", "fragrant", "fraudulent", "freakish", "freckled", "freelance", "freight", "fresh", "fretted", "frugal", "fulfilling", "fuming", "funded", "funny", "garbled", "gathered", "geologic", "geometric", "gibberish", "gilded", "ginger", "glare", "glaring", "gleaming", "glorified", "glorious", "goalless", "gold-plated", "goody", "grammatical", "grande", "grateful", "gratuitous", "graven", "greener", "grinding", "grizzly", "groaning", "grudging", "guaranteed", "gusty", "gypsy", "half-breed", "hand-held", "handheld", "hands-off", "hard-pressed", "harlot", "healing", "healthier", "healthiest", "heart", "heart-shaped", "heathen", "hedonistic", "heralded", "herbal", "high-density", "high-performance", "high-res", "high-yield", "hissy", "hitless", "holiness", "homesick", "honorable", "hooded", "hopeless", "horrendous", "horrible", "hot-button", "huddled", "human", "humbling", "humid", "humiliating", "hypnotized", "idealistic", "idiosyncratic", "ignited", "illustrated", "illustrative", "imitated", "immense", "immersive", "immigrant", "immoral", "impassive", "impressionable", "improbable", "impulsive", "in-between", "in-flight", "inattentive", "inbound", "inbounds", "incalculable", "incomprehensible", "indefatigable", "indigo", "indiscriminate", "indomitable", "inert", "inflate", "inform", "inheriting", "injured", "injurious", "inking", "inoffensive", "insane", "insensible", "insidious", "insincere", "insistent", "insolent", "insufferable", "intemperate", "interdependent", "interesting", "interfering", "intern", "interpreted", "intersecting", "intolerable", "intolerant", "intuitive", "irresolute", "irritate", "jealous", "jerking", "joining", "joint", "journalistic", "joyful", "keyed", "knowing", "lacklustre", "laden", "lagging", "lamented", "laughable", "layered", "leather", "leathern", "leery", "left-footed", "legible", "leisure", "lessening", "liberating", "life-size", "lifted", "lightest", "limitless", "listening", "literary", "liver", "livid", "lobster", "locked", "long-held", "long-lasting", "long-running", "long-suffering", "loudest", "loveliest", "low-budget", "low-carb", "lowering", "lucid", "luckless", "lusty", "luxurious", "magazine", "maniac", "manmade", "maroon", "mastered", "mated", "material", "materialistic", "meaningful", "measuring", "mediaeval", "medical", "meditated", "medley", "melodic", "memorable", "memorial", "metabolic", "metallic", "metallurgical", "metering", "midair", "midterm", "midway", "mighty", "migrating", "mind-blowing", "mind-boggling", "minor", "mirrored", "misguided", "misshapen", "mitigated", "mixed", "modernized", "molecular", "monarch", "monastic", "morbid", "motley", "motorized", "mounted", "multi-million", "multidisciplinary", "muscled", "muscular", "muted", "mysterious", "mythic", "nail-biting", "natural", "nauseous", "negative", "networked", "neurological", "neutered", "newest", "night", "nitrous", "no-fly", "noncommercial", "nonsense", "north", "nuanced", "occurring", "offensive", "oldest", "oncoming", "one-eyed", "one-year", "onstage", "onward", "opaque", "open-ended", "operating", "opportunist", "opposing", "opt-in", "ordinate", "outdone", "outlaw", "outsized", "overboard", "overheated", "oversize", "overworked", "oyster", "paced", "panting", "paralyzed", "paramount", "parental", "parted", "partisan", "passive", "pastel", "patriot", "peacekeeping", "pedestrian", "peevish", "penal", "penned", "pensive", "perceptual", "perky", "permissible", "pernicious", "perpetuate", "perplexed", "pervasive", "petrochemical", "philosophical", "picturesque", "pillaged", "piped", "piquant", "pitching", "plausible", "pliable", "plumb", "politician", "polygamous", "poorest", "portmanteau", "posed", "positive", "possible", "postpartum", "prank", "pre-emptive", "precocious", "predicted", "premium", "preparatory", "prerequisite", "prescient", "preserved", "presidential", "pressed", "pressurized", "presumed", "prewar", "priced", "pricier", "primal", "primer", "primetime", "printed", "private", "problem", "procedural", "process", "prodigious", "professional", "programmed", "progressive", "prolific", "promising", "promulgated", "pronged", "proportionate", "protracted", "pulled", "pulsed", "purgatory", "quick", "rapid-fire", "raunchy", "razed", "reactive", "readable", "realizing", "recognised", "recovering", "recurrent", "recycled", "redeemable", "reflecting", "regal", "registering", "reliable", "reminiscent", "remorseless", "removable", "renewable", "repeating", "repellent", "reserve", "resigned", "respectful", "rested", "restrict", "resultant", "retaliatory", "retiring", "revelatory", "reverend", "reversing", "revolving", "ridiculous", "right-hand", "ringed", "risque", "robust", "roomful", "rotating", "roused", "rubber", "run-down", "running", "runtime", "rustling", "safest", "salient", "sanctioned", "saute", "saved", "scandalized", "scarlet", "scattering", "sceptical", "scheming", "scoundrel", "scratched", "scratchy", "scrolled", "seated", "second-best", "segregated", "self-taught", "semiautomatic", "senior", "sensed", "sentient", "sexier", "shadowy", "shaken", "shaker", "shameless", "shaped", "shiny", "shipped", "shivering", "shoestring", "short", "short-lived", "signed", "simplest", "simplistic", "sizable", "skeleton", "skinny", "skirting", "skyrocketed", "slamming", "slanting", "slapstick", "sleek", "sleepless", "sleepy", "slender", "slimmer", "smacking", "smokeless", "smothered", "smouldering", "snuff", "socialized", "solid-state", "sometime", "sought", "spanking", "sparing", "spattered", "specialized", "specific", "speedy", "spherical", "spiky", "spineless", "sprung", "squint", "stainless", "standing", "starlight", "startled", "stately", "statewide", "stereoscopic", "sticky", "stimulant", "stinky", "stoked", "stolen", "storied", "strained", "strapping", "strengthened", "stubborn", "stylized", "suave", "subjective", "subjugated", "subordinate", "succeeding", "suffering", "summary", "sunset", "sunshine", "supernatural", "supervisory", "supply-side", "surrogate", "suspended", "suspenseful", "swarthy", "sweating", "sweeping", "swinging", "swooning", "sympathize", "synchronized", "synonymous", "synthetic", "tailed", "tallest", "tangible", "tanked", "tarry", "technical", "tectonic", "telepathic", "tenderest", "territorial", "testimonial", "theistic", "thicker", "threatening", "tight-lipped", "timed", "timely", "timid", "torrent", "totalled", "tougher", "traditional", "transformed", "trapped", "traveled", "traverse", "treated", "trial", "trunk", "trusting", "trying", "twisted", "two-lane", "tyrannical", "unaided", "unassisted", "unassuming", "unattractive", "uncapped", "uncomfortable", "uncontrolled", "uncooked", "uncooperative", "underground", "undersea", "undisturbed", "unearthly", "uneasy", "unequal", "unfazed", "unfinished", "unforeseen", "unforgivable", "unidentified", "unimaginative", "uninspired", "unintended", "uninvited", "universal", "unmasked", "unorthodox", "unparalleled", "unpleasant", "unprincipled", "unread", "unreasonable", "unregulated", "unreliable", "unremitting", "unsafe", "unsanitary", "unsealed", "unsuccessful", "unsupervised", "untimely", "unwary", "unwrapped", "uppity", "upstart", "useless", "utter", "valiant", "valid", "valued", "vanilla", "vaulting", "vaunted", "veering", "vegetative", "vented", "verbal", "verifying", "veritable", "versed", "vinyl", "virgin", "visceral", "visual", "voluptuous", "walk-on", "wanton", "warlike", "washed", "waterproof", "waved", "weakest", "well-bred", "well-chosen", "well-informed", "wetting", "wheeled", "whirlwind", "widen", "widening", "willful", "willing", "winnable", "winningest", "wireless", "wistful", "woeful", "wooded", "woodland", "wordless", "workable", "worldly", "worldwide", "worst-case", "worsted", "worthless"]
	};

/***/ },
/* 16 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
		"description": "A list of English nouns.",
		"nouns": ["Armour", "Barrymore", "Cabot", "Catholicism", "Chihuahua", "Christianity", "Easter", "Frenchman", "Lowry", "Mayer", "Orientalism", "Pharaoh", "Pueblo", "Pullman", "Rodeo", "Saturday", "Sister", "Snead", "Syrah", "Tuesday", "Woodward", "abbey", "absence", "absorption", "abstinence", "absurdity", "abundance", "acceptance", "accessibility", "accommodation", "accomplice", "accountability", "accounting", "accreditation", "accuracy", "acquiescence", "acreage", "actress", "actuality", "adage", "adaptation", "adherence", "adjustment", "adoption", "adultery", "advancement", "advert", "advertisement", "advertising", "advice", "aesthetics", "affinity", "aggression", "agriculture", "aircraft", "airtime", "allegation", "allegiance", "allegory", "allergy", "allies", "alligator", "allocation", "allotment", "altercation", "ambulance", "ammonia", "anatomy", "anemia", "ankle", "announcement", "annoyance", "annuity", "anomaly", "anthropology", "anxiety", "apartheid", "apologise", "apostle", "apparatus", "appeasement", "appellation", "appendix", "applause", "appointment", "appraisal", "archery", "archipelago", "architecture", "ardor", "arrears", "arrow", "artisan", "artistry", "ascent", "assembly", "assignment", "association", "asthma", "atheism", "attacker", "attraction", "attractiveness", "auspices", "authority", "avarice", "aversion", "aviation", "babbling", "backlash", "baker", "ballet", "balls", "banjo", "baron", "barrier", "barrister", "bases", "basin", "basis", "battery", "battling", "bedtime", "beginner", "begun", "bending", "bicycle", "billing", "bingo", "biography", "biology", "birthplace", "blackberry", "blather", "blossom", "boardroom", "boasting", "bodyguard", "boldness", "bomber", "bondage", "bonding", "bones", "bonus", "bookmark", "boomer", "booty", "bounds", "bowling", "brainstorming", "breadth", "breaker", "brewer", "brightness", "broccoli", "broth", "brotherhood", "browsing", "brunch", "brunt", "building", "bullion", "bureaucracy", "burglary", "buyout", "by-election", "cabal", "cabbage", "calamity", "campaign", "canonization", "captaincy", "carcass", "carrier", "cartridge", "cassette", "catfish", "caught", "celebrity", "cemetery", "certainty", "certification", "charade", "chasm", "check-in", "cheerleader", "cheesecake", "chemotherapy", "chili", "china", "chivalry", "cholera", "cilantro", "circus", "civilisation", "civility", "clearance", "clearing", "clerk", "climber", "closeness", "clothing", "clutches", "coaster", "coconut", "coding", "collaborator", "colleague", "college", "collision", "colors", "combustion", "comedian", "comer", "commander", "commemoration", "commenter", "commissioner", "commune", "competition", "completeness", "complexity", "computing", "comrade", "concur", "condominium", "conduit", "confidant", "configuration", "confiscation", "conflagration", "conflict", "consist", "consistency", "consolidation", "conspiracy", "constable", "consul", "consultancy", "contentment", "contents", "contractor", "conversation", "cornerstone", "corpus", "correlation", "councilman", "counselor", "countdown", "countryman", "coverage", "covering", "coyote", "cracker", "creator", "criminality", "crocodile", "cropping", "cross-examination", "crossover", "crossroads", "culprit", "cumin", "curator", "curfew", "cursor", "custard", "cutter", "cyclist", "cyclone", "cylinder", "cynicism", "daddy", "damsel", "darkness", "dawning", "daybreak", "dealing", "dedication", "deduction", "defection", "deference", "deficiency", "definition", "deflation", "degeneration", "delegation", "delicacy", "delirium", "deliverance", "demeanor", "demon", "demonstration", "denomination", "dentist", "departure", "depletion", "depression", "designation", "despotism", "detention", "developer", "devolution", "dexterity", "diagnosis", "dialect", "differentiation", "digger", "digress", "dioxide", "diploma", "disability", "disarmament", "discord", "discovery", "dishonesty", "dismissal", "disobedience", "dispatcher", "disservice", "distribution", "distributor", "diver", "diversity", "docking", "dollar", "dominance", "domination", "dominion", "donkey", "doorstep", "doorway", "dossier", "downside", "drafting", "drank", "drilling", "driver", "drumming", "drunkenness", "duchess", "ducking", "dugout", "dumps", "dwelling", "dynamics", "eagerness", "earnestness", "earnings", "eater", "editor", "effectiveness", "electricity", "elements", "eloquence", "emancipation", "embodiment", "embroidery", "emperor", "employment", "encampment", "enclosure", "encouragement", "endangerment", "enlightenment", "enthusiasm", "environment", "environs", "envoy", "epilepsy", "equation", "equator", "error", "espionage", "estimation", "evacuation", "exaggeration", "examination", "exclamation", "expediency", "exploitation", "extinction", "eyewitness", "falls", "fascism", "fastball", "feces", "feedback", "ferocity", "fertilization", "fetish", "finale", "firing", "fixing", "flashing", "flask", "flora", "fluke", "folklore", "follower", "foothold", "footing", "forefinger", "forefront", "forgiveness", "formality", "formation", "formula", "foyer", "fragmentation", "framework", "fraud", "freestyle", "frequency", "friendliness", "fries", "frigate", "fulfillment", "function", "functionality", "fundraiser", "fusion", "futility", "gallantry", "gallery", "genesis", "genitals", "girlfriend", "glamour", "glitter", "glucose", "google", "grandeur", "grappling", "greens", "gridlock", "grocer", "groundwork", "grouping", "gunman", "gusto", "habitation", "hacker", "hallway", "hamburger", "hammock", "handling", "hands", "handshake", "happiness", "hardship", "headcount", "header", "headquarters", "heads", "headset", "hearth", "hearts", "heath", "hegemony", "height", "hello", "helper", "helping", "helplessness", "hierarchy", "hoarding", "hockey", "homeland", "homer", "honesty", "horror", "horseman", "hostility", "housing", "humility", "hurricane", "iceberg", "ignition", "illness", "illustration", "illustrator", "immunity", "immunization", "imperialism", "imprisonment", "inaccuracy", "inaction", "inactivity", "inauguration", "indecency", "indicator", "inevitability", "infamy", "infiltration", "influx", "iniquity", "innocence", "innovation", "insanity", "inspiration", "instruction", "instructor", "insurer", "interact", "intercession", "intercourse", "intermission", "interpretation", "intersection", "interval", "intolerance", "intruder", "invasion", "investment", "involvement", "irrigation", "iteration", "jenny", "jogging", "jones", "joseph", "juggernaut", "juncture", "jurisprudence", "juror", "kangaroo", "kingdom", "knocking", "laborer", "larceny", "laurels", "layout", "leadership", "leasing", "legislation", "leopard", "liberation", "licence", "lifeblood", "lifeline", "ligament", "lighting", "likeness", "line-up", "lineage", "liner", "lineup", "liquidation", "listener", "literature", "litigation", "litre", "loathing", "locality", "lodging", "logic", "longevity", "lookout", "lordship", "lustre", "ma'am", "machinery", "madness", "magnificence", "mahogany", "mailing", "mainframe", "maintenance", "majority", "manga", "mango", "manifesto", "mantra", "manufacturer", "maple", "martin", "martyrdom", "mathematician", "matrix", "matron", "mayhem", "mayor", "means", "meantime", "measurement", "mechanics", "mediator", "medics", "melodrama", "memory", "mentality", "metaphysics", "method", "metre", "miner", "mirth", "misconception", "misery", "mishap", "misunderstanding", "mobility", "molasses", "momentum", "monarchy", "monument", "morale", "mortality", "motto", "mouthful", "mouthpiece", "mover", "movie", "mowing", "murderer", "musician", "mutation", "mythology", "narration", "narrator", "nationality", "negligence", "neighborhood", "neighbour", "nervousness", "networking", "nexus", "nightmare", "nobility", "nobody", "noodle", "normalcy", "notification", "nourishment", "novella", "nucleus", "nuisance", "nursery", "nutrition", "nylon", "oasis", "obscenity", "obscurity", "observer", "offense", "onslaught", "operation", "opportunity", "opposition", "oracle", "orchestra", "organisation", "organizer", "orientation", "originality", "ounce", "outage", "outcome", "outdoors", "outfield", "outing", "outpost", "outset", "overseer", "owner", "oxygen", "pairing", "panther", "paradox", "parliament", "parsley", "parson", "passenger", "pasta", "patchwork", "pathos", "patriotism", "pendulum", "penguin", "permission", "persona", "perusal", "pessimism", "peter", "philosopher", "phosphorus", "phrasing", "physique", "piles", "plateau", "playing", "plaza", "plethora", "plurality", "pneumonia", "pointer", "poker", "policeman", "polling", "poster", "posterity", "posting", "postponement", "potassium", "pottery", "poultry", "pounding", "pragmatism", "precedence", "precinct", "preoccupation", "pretense", "priesthood", "prisoner", "privacy", "probation", "proceeding", "proceedings", "processing", "processor", "progression", "projection", "prominence", "propensity", "prophecy", "prorogation", "prospectus", "protein", "prototype", "providence", "provider", "provocation", "proximity", "puberty", "publicist", "publicity", "publisher", "pundit", "putting", "quantity", "quart", "quilting", "quorum", "racism", "radiance", "ralph", "rancher", "ranger", "rapidity", "rapport", "ratification", "rationality", "reaction", "reader", "reassurance", "rebirth", "receptor", "recipe", "recognition", "recourse", "recreation", "rector", "recurrence", "redemption", "redistribution", "redundancy", "refinery", "reformer", "refrigerator", "regularity", "regulator", "reinforcement", "reins", "reinstatement", "relativism", "relaxation", "rendition", "repayment", "repentance", "repertoire", "repository", "republic", "reputation", "resentment", "residency", "resignation", "restaurant", "resurgence", "retailer", "retention", "retirement", "reviewer", "riches", "righteousness", "roadblock", "robber", "rocks", "rubbing", "runoff", "saloon", "salvation", "sarcasm", "saucer", "savior", "scarcity", "scenario", "scenery", "schism", "scholarship", "schoolboy", "schooner", "scissors", "scolding", "scooter", "scouring", "scrimmage", "scrum", "seating", "sediment", "seduction", "seeder", "seizure", "self-confidence", "self-control", "self-respect", "semicolon", "semiconductor", "semifinal", "senator", "sending", "serenity", "seriousness", "servitude", "sesame", "setup", "sewing", "sharpness", "shaving", "shoplifting", "shopping", "siding", "simplicity", "simulation", "sinking", "skate", "sloth", "slugger", "snack", "snail", "snapshot", "snark", "soccer", "solemnity", "solicitation", "solitude", "somewhere", "sophistication", "sorcery", "souvenir", "spaghetti", "specification", "specimen", "specs", "spectacle", "spectre", "speculation", "sperm", "spoiler", "squad", "squid", "staging", "stagnation", "staircase", "stairway", "stamina", "standpoint", "standstill", "stanza", "statement", "stillness", "stimulus", "stocks", "stole", "stoppage", "storey", "storyteller", "stylus", "subcommittee", "subscription", "subsidy", "suburb", "success", "sufferer", "supposition", "suspension", "sweater", "sweepstakes", "swimmer", "syndrome", "synopsis", "syntax", "system", "tablespoon", "taker", "tavern", "technology", "telephony", "template", "tempo", "tendency", "tendon", "terrier", "terror", "terry", "theater", "theology", "therapy", "thicket", "thoroughfare", "threshold", "thriller", "thunderstorm", "ticker", "tiger", "tights", "to-day", "tossing", "touchdown", "tourist", "tourney", "toxicity", "tracing", "tractor", "translation", "transmission", "transmitter", "trauma", "traveler", "treadmill", "trilogy", "trout", "tuning", "twenties", "tycoon", "tyrant", "ultimatum", "underdog", "underwear", "unhappiness", "unification", "university", "uprising", "vaccination", "validity", "vampire", "vanguard", "variation", "vegetation", "verification", "viability", "vicinity", "victory", "viewpoint", "villa", "vindication", "violation", "vista", "vocalist", "vogue", "volcano", "voltage", "vomiting", "vulnerability", "waistcoat", "waitress", "wardrobe", "warmth", "watchdog", "wealth", "weariness", "whereabouts", "whisky", "whiteness", "widget", "width", "windfall", "wiring", "witchcraft", "withholding", "womanhood", "words", "workman", "youngster"]
	};

/***/ },
/* 17 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
		"description": "A list of English verbs.",
		"verbs": [{
			"present": "accept",
			"past": "accepted"
		}, {
			"present": "add",
			"past": "added"
		}, {
			"present": "admire",
			"past": "admired"
		}, {
			"present": "admit",
			"past": "admitted"
		}, {
			"present": "advise",
			"past": "advised"
		}, {
			"present": "afford",
			"past": "afforded"
		}, {
			"present": "agree",
			"past": "agreed"
		}, {
			"present": "alert",
			"past": "alerted"
		}, {
			"present": "allow",
			"past": "allowed"
		}, {
			"present": "amuse",
			"past": "amused"
		}, {
			"present": "analyse",
			"past": "analysed"
		}, {
			"present": "announce",
			"past": "announced"
		}, {
			"present": "annoy",
			"past": "annoyed"
		}, {
			"present": "answer",
			"past": "answered"
		}, {
			"present": "apologise",
			"past": "apologised"
		}, {
			"present": "appear",
			"past": "appeared"
		}, {
			"present": "applaud",
			"past": "applauded"
		}, {
			"present": "appreciate",
			"past": "appreciated"
		}, {
			"present": "approve",
			"past": "approved"
		}, {
			"present": "argue",
			"past": "argued"
		}, {
			"present": "arrange",
			"past": "arranged"
		}, {
			"present": "arrest",
			"past": "arrested"
		}, {
			"present": "arrive",
			"past": "arrived"
		}, {
			"present": "ask",
			"past": "asked"
		}, {
			"present": "attach",
			"past": "attached"
		}, {
			"present": "attack",
			"past": "attacked"
		}, {
			"present": "attempt",
			"past": "attempted"
		}, {
			"present": "attend",
			"past": "attended"
		}, {
			"present": "attract",
			"past": "attracted"
		}, {
			"present": "avoid",
			"past": "avoided"
		}, {
			"present": "back",
			"past": "backed"
		}, {
			"present": "bake",
			"past": "baked"
		}, {
			"present": "balance",
			"past": "balanced"
		}, {
			"present": "ban",
			"past": "banned"
		}, {
			"present": "bang",
			"past": "banged"
		}, {
			"present": "bare",
			"past": "bared"
		}, {
			"present": "bat",
			"past": "batted"
		}, {
			"present": "bathe",
			"past": "bathed"
		}, {
			"present": "battle",
			"past": "battled"
		}, {
			"present": "beam",
			"past": "beamed"
		}, {
			"present": "beg",
			"past": "begged"
		}, {
			"present": "behave",
			"past": "behaved"
		}, {
			"present": "belong",
			"past": "belonged"
		}, {
			"present": "bleach",
			"past": "bleached"
		}, {
			"present": "bless",
			"past": "blessed"
		}, {
			"present": "blind",
			"past": "blinded"
		}, {
			"present": "blink",
			"past": "blinked"
		}, {
			"present": "blot",
			"past": "blotted"
		}, {
			"present": "blush",
			"past": "blushed"
		}, {
			"present": "boast",
			"past": "boasted"
		}, {
			"present": "boil",
			"past": "boiled"
		}, {
			"present": "bolt",
			"past": "bolted"
		}, {
			"present": "bomb",
			"past": "bombed"
		}, {
			"present": "book",
			"past": "booked"
		}, {
			"present": "bore",
			"past": "bored"
		}, {
			"present": "borrow",
			"past": "borrowed"
		}, {
			"present": "bounce",
			"past": "bounced"
		}, {
			"present": "bow",
			"past": "bowed"
		}, {
			"present": "box",
			"past": "boxed"
		}, {
			"present": "brake",
			"past": "braked"
		}, {
			"present": "branch",
			"past": "branched"
		}, {
			"present": "breathe",
			"past": "breathed"
		}, {
			"present": "bruise",
			"past": "bruised"
		}, {
			"present": "brush",
			"past": "brushed"
		}, {
			"present": "bubble",
			"past": "bubbled"
		}, {
			"present": "bump",
			"past": "bumped"
		}, {
			"present": "burn",
			"past": "burned"
		}, {
			"present": "bury",
			"past": "buried"
		}, {
			"present": "buzz",
			"past": "buzzed"
		}, {
			"present": "calculate",
			"past": "calculated"
		}, {
			"present": "call",
			"past": "called"
		}, {
			"present": "camp",
			"past": "camped"
		}, {
			"present": "care",
			"past": "cared"
		}, {
			"present": "carry",
			"past": "carried"
		}, {
			"present": "carve",
			"past": "carved"
		}, {
			"present": "cause",
			"past": "caused"
		}, {
			"present": "challenge",
			"past": "challenged"
		}, {
			"present": "change",
			"past": "changed"
		}, {
			"present": "charge",
			"past": "charged"
		}, {
			"present": "chase",
			"past": "chased"
		}, {
			"present": "cheat",
			"past": "cheated"
		}, {
			"present": "check",
			"past": "checked"
		}, {
			"present": "cheer",
			"past": "cheered"
		}, {
			"present": "chew",
			"past": "chewed"
		}, {
			"present": "choke",
			"past": "choked"
		}, {
			"present": "chop",
			"past": "chopped"
		}, {
			"present": "claim",
			"past": "claimed"
		}, {
			"present": "clap",
			"past": "clapped"
		}, {
			"present": "clean",
			"past": "cleaned"
		}, {
			"present": "clear",
			"past": "cleared"
		}, {
			"present": "clip",
			"past": "clipped"
		}, {
			"present": "close",
			"past": "closed"
		}, {
			"present": "coach",
			"past": "coached"
		}, {
			"present": "coil",
			"past": "coiled"
		}, {
			"present": "collect",
			"past": "collected"
		}, {
			"present": "colour",
			"past": "coloured"
		}, {
			"present": "comb",
			"past": "combed"
		}, {
			"present": "command",
			"past": "commanded"
		}, {
			"present": "communicate",
			"past": "communicated"
		}, {
			"present": "compare",
			"past": "compared"
		}, {
			"present": "compete",
			"past": "competed"
		}, {
			"present": "complain",
			"past": "complained"
		}, {
			"present": "complete",
			"past": "completed"
		}, {
			"present": "concentrate",
			"past": "concentrated"
		}, {
			"present": "concern",
			"past": "concerned"
		}, {
			"present": "confess",
			"past": "confessed"
		}, {
			"present": "confuse",
			"past": "confused"
		}, {
			"present": "connect",
			"past": "connected"
		}, {
			"present": "consider",
			"past": "considered"
		}, {
			"present": "consist",
			"past": "consisted"
		}, {
			"present": "contain",
			"past": "contained"
		}, {
			"present": "continue",
			"past": "continued"
		}, {
			"present": "copy",
			"past": "copied"
		}, {
			"present": "correct",
			"past": "corrected"
		}, {
			"present": "cough",
			"past": "coughed"
		}, {
			"present": "count",
			"past": "counted"
		}, {
			"present": "cover",
			"past": "covered"
		}, {
			"present": "crack",
			"past": "cracked"
		}, {
			"present": "crash",
			"past": "crashed"
		}, {
			"present": "crawl",
			"past": "crawled"
		}, {
			"present": "cross",
			"past": "crossed"
		}, {
			"present": "crush",
			"past": "crushed"
		}, {
			"present": "cry",
			"past": "cried"
		}, {
			"present": "cure",
			"past": "cured"
		}, {
			"present": "curl",
			"past": "curled"
		}, {
			"present": "curve",
			"past": "curved"
		}, {
			"present": "cycle",
			"past": "cycled"
		}, {
			"present": "dam",
			"past": "dammed"
		}, {
			"present": "damage",
			"past": "damaged"
		}, {
			"present": "dance",
			"past": "danced"
		}, {
			"present": "dare",
			"past": "dared"
		}, {
			"present": "decay",
			"past": "decayed"
		}, {
			"present": "deceive",
			"past": "deceived"
		}, {
			"present": "decide",
			"past": "decided"
		}, {
			"present": "decorate",
			"past": "decorated"
		}, {
			"present": "delay",
			"past": "delayed"
		}, {
			"present": "delight",
			"past": "delighted"
		}, {
			"present": "deliver",
			"past": "delivered"
		}, {
			"present": "depend",
			"past": "depended"
		}, {
			"present": "describe",
			"past": "described"
		}, {
			"present": "desert",
			"past": "deserted"
		}, {
			"present": "deserve",
			"past": "deserved"
		}, {
			"present": "destroy",
			"past": "destroyed"
		}, {
			"present": "detect",
			"past": "detected"
		}, {
			"present": "develop",
			"past": "developed"
		}, {
			"present": "disagree",
			"past": "disagreed"
		}, {
			"present": "disappear",
			"past": "disappeared"
		}, {
			"present": "disapprove",
			"past": "disapproved"
		}, {
			"present": "disarm",
			"past": "disarmed"
		}, {
			"present": "discover",
			"past": "discovered"
		}, {
			"present": "dislike",
			"past": "disliked"
		}, {
			"present": "divide",
			"past": "divided"
		}, {
			"present": "double",
			"past": "doubled"
		}, {
			"present": "doubt",
			"past": "doubted"
		}, {
			"present": "drag",
			"past": "dragged"
		}, {
			"present": "drain",
			"past": "drained"
		}, {
			"present": "dream",
			"past": "dreamed"
		}, {
			"present": "dress",
			"past": "dressed"
		}, {
			"present": "drip",
			"past": "dripped"
		}, {
			"present": "drop",
			"past": "dropped"
		}, {
			"present": "drown",
			"past": "drowned"
		}, {
			"present": "drum",
			"past": "drummed"
		}, {
			"present": "dry",
			"past": "dried"
		}, {
			"present": "dust",
			"past": "dusted"
		}, {
			"present": "earn",
			"past": "earned"
		}, {
			"present": "educate",
			"past": "educated"
		}, {
			"present": "embarrass",
			"past": "embarrassed"
		}, {
			"present": "employ",
			"past": "employed"
		}, {
			"present": "empty",
			"past": "emptied"
		}, {
			"present": "encourage",
			"past": "encouraged"
		}, {
			"present": "end",
			"past": "ended"
		}, {
			"present": "enjoy",
			"past": "enjoyed"
		}, {
			"present": "enter",
			"past": "entered"
		}, {
			"present": "entertain",
			"past": "entertained"
		}, {
			"present": "escape",
			"past": "escaped"
		}, {
			"present": "examine",
			"past": "examined"
		}, {
			"present": "excite",
			"past": "excited"
		}, {
			"present": "excuse",
			"past": "excused"
		}, {
			"present": "exercise",
			"past": "exercised"
		}, {
			"present": "exist",
			"past": "existed"
		}, {
			"present": "expand",
			"past": "expand"
		}, {
			"present": "expect",
			"past": "expected"
		}, {
			"present": "explain",
			"past": "explained"
		}, {
			"present": "explode",
			"past": "exploded"
		}, {
			"present": "extend",
			"past": "extended"
		}, {
			"present": "face",
			"past": "faced"
		}, {
			"present": "fade",
			"past": "faded"
		}, {
			"present": "fail",
			"past": "failed"
		}, {
			"present": "fancy",
			"past": "fancied"
		}, {
			"present": "fasten",
			"past": "fastened"
		}, {
			"present": "fax",
			"past": "faxed"
		}, {
			"present": "fear",
			"past": "feared"
		}, {
			"present": "fence",
			"past": "fenced"
		}, {
			"present": "fetch",
			"past": "fetched"
		}, {
			"present": "file",
			"past": "filed"
		}, {
			"present": "fill",
			"past": "filled"
		}, {
			"present": "film",
			"past": "filmed"
		}, {
			"present": "fire",
			"past": "fired"
		}, {
			"present": "fit",
			"past": "fitted"
		}, {
			"present": "fix",
			"past": "fixed"
		}, {
			"present": "flap",
			"past": "flapped"
		}, {
			"present": "flash",
			"past": "flashed"
		}, {
			"present": "float",
			"past": "floated"
		}, {
			"present": "flood",
			"past": "flooded"
		}, {
			"present": "flow",
			"past": "flowed"
		}, {
			"present": "flower",
			"past": "flowered"
		}, {
			"present": "fold",
			"past": "folded"
		}, {
			"present": "follow",
			"past": "followed"
		}, {
			"present": "fool",
			"past": "fooled"
		}, {
			"present": "force",
			"past": "forced"
		}, {
			"present": "form",
			"past": "formed"
		}, {
			"present": "found",
			"past": "founded"
		}, {
			"present": "frame",
			"past": "framed"
		}, {
			"present": "frighten",
			"past": "frightened"
		}, {
			"present": "fry",
			"past": "fried"
		}, {
			"present": "gather",
			"past": "gathered"
		}, {
			"present": "gaze",
			"past": "gazed"
		}, {
			"present": "glow",
			"past": "glowed"
		}, {
			"present": "glue",
			"past": "glued"
		}, {
			"present": "grab",
			"past": "grabbed"
		}, {
			"present": "grate",
			"past": "grated"
		}, {
			"present": "grease",
			"past": "greased"
		}, {
			"present": "greet",
			"past": "greeted"
		}, {
			"present": "grin",
			"past": "grinned"
		}, {
			"present": "grip",
			"past": "gripped"
		}, {
			"present": "groan",
			"past": "groaned"
		}, {
			"present": "guarantee",
			"past": "guaranteed"
		}, {
			"present": "guard",
			"past": "guarded"
		}, {
			"present": "guess",
			"past": "guessed"
		}, {
			"present": "guide",
			"past": "guided"
		}, {
			"present": "hammer",
			"past": "hammered"
		}, {
			"present": "hand",
			"past": "handed"
		}, {
			"present": "handle",
			"past": "handled"
		}, {
			"present": "hang",
			"past": "hung"
		}, {
			"present": "happen",
			"past": "happened"
		}, {
			"present": "harass",
			"past": "harassed"
		}, {
			"present": "harm",
			"past": "harmed"
		}, {
			"present": "hate",
			"past": "hated"
		}, {
			"present": "haunt",
			"past": "haunted"
		}, {
			"present": "head",
			"past": "headed"
		}, {
			"present": "heal",
			"past": "healed"
		}, {
			"present": "heap",
			"past": "heaped"
		}, {
			"present": "heat",
			"past": "heated"
		}, {
			"present": "help",
			"past": "helped"
		}, {
			"present": "hook",
			"past": "hooked"
		}, {
			"present": "hop",
			"past": "hopped"
		}, {
			"present": "hope",
			"past": "hoped"
		}, {
			"present": "hover",
			"past": "hovered"
		}, {
			"present": "hug",
			"past": "hugged"
		}, {
			"present": "hum",
			"past": "hummed"
		}, {
			"present": "hunt",
			"past": "hunted"
		}, {
			"present": "hurry",
			"past": "hurried"
		}, {
			"present": "identify",
			"past": "identified"
		}, {
			"present": "ignore",
			"past": "ignored"
		}, {
			"present": "imagine",
			"past": "imagined"
		}, {
			"present": "impress",
			"past": "impressed"
		}, {
			"present": "improve",
			"past": "improved"
		}, {
			"present": "include",
			"past": "included"
		}, {
			"present": "increase",
			"past": "increased"
		}, {
			"present": "influence",
			"past": "influenced"
		}, {
			"present": "inform",
			"past": "informed"
		}, {
			"present": "inject",
			"past": "injected"
		}, {
			"present": "injure",
			"past": "injured"
		}, {
			"present": "instruct",
			"past": "instructed"
		}, {
			"present": "intend",
			"past": "intended"
		}, {
			"present": "interest",
			"past": "interested"
		}, {
			"present": "interfere",
			"past": "interfered"
		}, {
			"present": "interrupt",
			"past": "interrupted"
		}, {
			"present": "introduce",
			"past": "introduced"
		}, {
			"present": "invent",
			"past": "invented"
		}, {
			"present": "invite",
			"past": "invited"
		}, {
			"present": "irritate",
			"past": "irritated"
		}, {
			"present": "itch",
			"past": "itched"
		}, {
			"present": "jail",
			"past": "jailed"
		}, {
			"present": "jam",
			"past": "jammed"
		}, {
			"present": "jog",
			"past": "jogged"
		}, {
			"present": "join",
			"past": "joined"
		}, {
			"present": "joke",
			"past": "joked"
		}, {
			"present": "judge",
			"past": "judged"
		}, {
			"present": "juggle",
			"past": "juggled"
		}, {
			"present": "jump",
			"past": "jumped"
		}, {
			"present": "kick",
			"past": "kicked"
		}, {
			"present": "kill",
			"past": "killed"
		}, {
			"present": "kiss",
			"past": "kissed"
		}, {
			"present": "kneel",
			"past": "knelt"
		}, {
			"present": "knit",
			"past": "knitted"
		}, {
			"present": "knock",
			"past": "knocked"
		}, {
			"present": "knot",
			"past": "knotted"
		}, {
			"present": "label",
			"past": "labelled"
		}, {
			"present": "land",
			"past": "landed"
		}, {
			"present": "last",
			"past": "lasted"
		}, {
			"present": "laugh",
			"past": "laughed"
		}, {
			"present": "launch",
			"past": "launched"
		}, {
			"present": "learn",
			"past": "learned"
		}, {
			"present": "level",
			"past": "levelled"
		}, {
			"present": "license",
			"past": "licensed"
		}, {
			"present": "lick",
			"past": "licked"
		}, {
			"present": "lie",
			"past": "lied"
		}, {
			"present": "lighten",
			"past": "lightened"
		}, {
			"present": "like",
			"past": "liked"
		}, {
			"present": "list",
			"past": "listed"
		}, {
			"present": "listen",
			"past": "listened"
		}, {
			"present": "live",
			"past": "lived"
		}, {
			"present": "load",
			"past": "loaded"
		}, {
			"present": "lock",
			"past": "locked"
		}, {
			"present": "long",
			"past": "longed"
		}, {
			"present": "look",
			"past": "look"
		}, {
			"present": "love",
			"past": "loved"
		}, {
			"present": "man",
			"past": "manned"
		}, {
			"present": "manage",
			"past": "managed"
		}, {
			"present": "march",
			"past": "marched"
		}, {
			"present": "mark",
			"past": "marked"
		}, {
			"present": "marry",
			"past": "married"
		}, {
			"present": "match",
			"past": "matched"
		}, {
			"present": "mate",
			"past": "mated"
		}, {
			"present": "matter",
			"past": "mattered"
		}, {
			"present": "measure",
			"past": "measured"
		}, {
			"present": "meddle",
			"past": "meddled"
		}, {
			"present": "melt",
			"past": "melted"
		}, {
			"present": "memorise",
			"past": "memorised"
		}, {
			"present": "mend",
			"past": "mended"
		}, {
			"present": "mess up",
			"past": "messed up"
		}, {
			"present": "milk",
			"past": "milked"
		}, {
			"present": "mine",
			"past": "mined"
		}, {
			"present": "miss",
			"past": "missed"
		}, {
			"present": "mix",
			"past": "mixed"
		}, {
			"present": "moan",
			"past": "moaned"
		}, {
			"present": "moor",
			"past": "moored"
		}, {
			"present": "mourn",
			"past": "mourned"
		}, {
			"present": "move",
			"past": "moved"
		}, {
			"present": "muddle",
			"past": "muddled"
		}, {
			"present": "mug",
			"past": "mugged"
		}, {
			"present": "multiply",
			"past": "multiplied"
		}, {
			"present": "murder",
			"past": "murdered"
		}, {
			"present": "nail",
			"past": "nailed"
		}, {
			"present": "name",
			"past": "named"
		}, {
			"present": "need",
			"past": "needed"
		}, {
			"present": "nest",
			"past": "nested"
		}, {
			"present": "nod",
			"past": "nodded"
		}, {
			"present": "note",
			"past": "noted"
		}, {
			"present": "notice",
			"past": "noticed"
		}, {
			"present": "number",
			"past": "numbered"
		}, {
			"present": "obey",
			"past": "obeyed"
		}, {
			"present": "object",
			"past": "objected"
		}, {
			"present": "observe",
			"past": "observed"
		}, {
			"present": "obtain",
			"past": "obtained"
		}, {
			"present": "occur",
			"past": "occurred"
		}, {
			"present": "offend",
			"past": "offended"
		}, {
			"present": "offer",
			"past": "offered"
		}, {
			"present": "open",
			"past": "opened"
		}, {
			"present": "order",
			"past": "ordered"
		}, {
			"present": "overflow",
			"past": "overflowed"
		}, {
			"present": "owe",
			"past": "owed"
		}, {
			"present": "own",
			"past": "owned"
		}, {
			"present": "pack",
			"past": "packed"
		}, {
			"present": "paddle",
			"past": "paddled"
		}, {
			"present": "paint",
			"past": "painted"
		}, {
			"present": "park",
			"past": "parked"
		}, {
			"present": "part",
			"past": "parted"
		}, {
			"present": "pass",
			"past": "passed"
		}, {
			"present": "paste",
			"past": "pasted"
		}, {
			"present": "pat",
			"past": "patted"
		}, {
			"present": "pause",
			"past": "paused"
		}, {
			"present": "peck",
			"past": "pecked"
		}, {
			"present": "pedal",
			"past": "pedalled"
		}, {
			"present": "peel",
			"past": "peeled"
		}, {
			"present": "peep",
			"past": "peeped"
		}, {
			"present": "perform",
			"past": "performed"
		}, {
			"present": "permit",
			"past": "permitted"
		}, {
			"present": "phone",
			"past": "phoned"
		}, {
			"present": "pick",
			"past": "picked"
		}, {
			"present": "pinch",
			"past": "pinched"
		}, {
			"present": "pine",
			"past": "pined"
		}, {
			"present": "place",
			"past": "placed"
		}, {
			"present": "plan",
			"past": "planned"
		}, {
			"present": "plant",
			"past": "planted"
		}, {
			"present": "play",
			"past": "played"
		}, {
			"present": "please",
			"past": "pleased"
		}, {
			"present": "plug",
			"past": "plugged"
		}, {
			"present": "point",
			"past": "pointed"
		}, {
			"present": "poke",
			"past": "poked"
		}, {
			"present": "polish",
			"past": "polished"
		}, {
			"present": "pop",
			"past": "popped"
		}, {
			"present": "possess",
			"past": "possessed"
		}, {
			"present": "post",
			"past": "posted"
		}, {
			"present": "pour",
			"past": "poured"
		}, {
			"present": "practise",
			"past": "practised"
		}, {
			"present": "pray",
			"past": "prayed"
		}, {
			"present": "preach",
			"past": "preached"
		}, {
			"present": "precede",
			"past": "preceded"
		}, {
			"present": "prefer",
			"past": "preferred"
		}, {
			"present": "prepare",
			"past": "prepared"
		}, {
			"present": "present",
			"past": "presented"
		}, {
			"present": "preserve",
			"past": "preserved"
		}, {
			"present": "press",
			"past": "pressed"
		}, {
			"present": "pretend",
			"past": "pretended"
		}, {
			"present": "prevent",
			"past": "prevented"
		}, {
			"present": "prick",
			"past": "pricked"
		}, {
			"present": "print",
			"past": "printed"
		}, {
			"present": "produce",
			"past": "produced"
		}, {
			"present": "program",
			"past": "programmed"
		}, {
			"present": "promise",
			"past": "promised"
		}, {
			"present": "protect",
			"past": "protected"
		}, {
			"present": "provide",
			"past": "provided"
		}, {
			"present": "pull",
			"past": "pulled"
		}, {
			"present": "pump",
			"past": "pumped"
		}, {
			"present": "punch",
			"past": "punched"
		}, {
			"present": "puncture",
			"past": "punctured"
		}, {
			"present": "punish",
			"past": "punished"
		}, {
			"present": "push",
			"past": "pushed"
		}, {
			"present": "question",
			"past": "questioned"
		}, {
			"present": "queue",
			"past": "questioned"
		}, {
			"present": "race",
			"past": "raced"
		}, {
			"present": "radiate",
			"past": "radiated"
		}, {
			"present": "rain",
			"past": "rained"
		}, {
			"present": "raise",
			"past": "raised"
		}, {
			"present": "reach",
			"past": "reached"
		}, {
			"present": "realise",
			"past": "realised"
		}, {
			"present": "receive",
			"past": "received"
		}, {
			"present": "recognise",
			"past": "recognised"
		}, {
			"present": "record",
			"past": "recorded"
		}, {
			"present": "reduce",
			"past": "reduced"
		}, {
			"present": "reflect",
			"past": "reflected"
		}, {
			"present": "refuse",
			"past": "refused"
		}, {
			"present": "regret",
			"past": "regretted"
		}, {
			"present": "reign",
			"past": "reigned"
		}, {
			"present": "reject",
			"past": "rejected"
		}, {
			"present": "rejoice",
			"past": "rejoiced"
		}, {
			"present": "relax",
			"past": "relaxed"
		}, {
			"present": "release",
			"past": "released"
		}, {
			"present": "rely",
			"past": "relied"
		}, {
			"present": "remain",
			"past": "remained"
		}, {
			"present": "remember",
			"past": "remembered"
		}, {
			"present": "remind",
			"past": "reminded"
		}, {
			"present": "remove",
			"past": "removed"
		}, {
			"present": "repair",
			"past": "repaired"
		}, {
			"present": "repeat",
			"past": "repeated"
		}, {
			"present": "replace",
			"past": "replaced"
		}, {
			"present": "reply",
			"past": "replied"
		}, {
			"present": "report",
			"past": "reported"
		}, {
			"present": "reproduce",
			"past": "reproduced"
		}, {
			"present": "request",
			"past": "requested"
		}, {
			"present": "rescue",
			"past": "rescued"
		}, {
			"present": "retire",
			"past": "retired"
		}, {
			"present": "return",
			"past": "returned"
		}, {
			"present": "rhyme",
			"past": "rhyme"
		}, {
			"present": "rinse",
			"past": "rinsed"
		}, {
			"present": "risk",
			"past": "risked"
		}, {
			"present": "rob",
			"past": "robbed"
		}, {
			"present": "rock",
			"past": "rocked"
		}, {
			"present": "roll",
			"past": "rolled"
		}, {
			"present": "rot",
			"past": "rotted"
		}, {
			"present": "rub",
			"past": "rubbed"
		}, {
			"present": "ruin",
			"past": "ruined"
		}, {
			"present": "rule",
			"past": "ruled"
		}, {
			"present": "rush",
			"past": "rushed"
		}, {
			"present": "sack",
			"past": "sacked"
		}, {
			"present": "sail",
			"past": "sailed"
		}, {
			"present": "satisfy",
			"past": "satisfied"
		}, {
			"present": "save",
			"past": "saved"
		}, {
			"present": "saw",
			"past": "sawed"
		}, {
			"present": "scare",
			"past": "scared"
		}, {
			"present": "scatter",
			"past": "scattered"
		}, {
			"present": "scold",
			"past": "scolded"
		}, {
			"present": "scorch",
			"past": "scorched"
		}, {
			"present": "scrape",
			"past": "scraped"
		}, {
			"present": "scratch",
			"past": "scratched"
		}, {
			"present": "scream",
			"past": "screamed"
		}, {
			"present": "screw",
			"past": "screwed"
		}, {
			"present": "scribble",
			"past": "scribbled"
		}, {
			"present": "scrub",
			"past": "scrubbed"
		}, {
			"present": "seal",
			"past": "sealed"
		}, {
			"present": "search",
			"past": "searched"
		}, {
			"present": "separate",
			"past": "separate"
		}, {
			"present": "serve",
			"past": "served"
		}, {
			"present": "settle",
			"past": "settled"
		}, {
			"present": "shade",
			"past": "shaded"
		}, {
			"present": "share",
			"past": "shared"
		}, {
			"present": "shave",
			"past": "shaved"
		}, {
			"present": "shelter",
			"past": "sheltered"
		}, {
			"present": "shiver",
			"past": "shivered"
		}, {
			"present": "shock",
			"past": "shocked"
		}, {
			"present": "shop",
			"past": "shopped"
		}, {
			"present": "shrug",
			"past": "shrugged"
		}, {
			"present": "sigh",
			"past": "sighed"
		}, {
			"present": "sign",
			"past": "signed"
		}, {
			"present": "signal",
			"past": "signalled"
		}, {
			"present": "sin",
			"past": "sinned"
		}, {
			"present": "sip",
			"past": "sipped"
		}, {
			"present": "ski",
			"past": "skied"
		}, {
			"present": "skip",
			"past": "skipped"
		}, {
			"present": "slap",
			"past": "slapped"
		}, {
			"present": "slip",
			"past": "slipped"
		}, {
			"present": "slow",
			"past": "slowed"
		}, {
			"present": "smash",
			"past": "smashed"
		}, {
			"present": "smell",
			"past": "smelled"
		}, {
			"present": "smile",
			"past": "smiled"
		}, {
			"present": "smoke",
			"past": "smoked"
		}, {
			"present": "snatch",
			"past": "snatched"
		}, {
			"present": "sneeze",
			"past": "sneezed"
		}, {
			"present": "sniff",
			"past": "sniffed"
		}, {
			"present": "snore",
			"past": "snored"
		}, {
			"present": "snow",
			"past": "snowed"
		}, {
			"present": "soak",
			"past": "soaked"
		}, {
			"present": "soothe",
			"past": "soothed"
		}, {
			"present": "sound",
			"past": "sounded"
		}, {
			"present": "spare",
			"past": "spared"
		}, {
			"present": "spark",
			"past": "sparked"
		}, {
			"present": "sparkle",
			"past": "sparkled"
		}, {
			"present": "spell",
			"past": "spelled"
		}, {
			"present": "spill",
			"past": "spilled"
		}, {
			"present": "spoil",
			"past": "spoiled"
		}, {
			"present": "spot",
			"past": "spotted"
		}, {
			"present": "spray",
			"past": "sprayed"
		}, {
			"present": "sprout",
			"past": "sprouted"
		}, {
			"present": "squash",
			"past": "squashed"
		}, {
			"present": "squeak",
			"past": "squeaked"
		}, {
			"present": "squeal",
			"past": "squealed"
		}, {
			"present": "squeeze",
			"past": "squeezed"
		}, {
			"present": "stain",
			"past": "stained"
		}, {
			"present": "stamp",
			"past": "stamped"
		}, {
			"present": "stare",
			"past": "stared"
		}, {
			"present": "start",
			"past": "started"
		}, {
			"present": "stay",
			"past": "stayed"
		}, {
			"present": "steer",
			"past": "steered"
		}, {
			"present": "step",
			"past": "stepped"
		}, {
			"present": "stir",
			"past": "stirred"
		}, {
			"present": "stitch",
			"past": "stitched"
		}, {
			"present": "stop",
			"past": "stopped"
		}, {
			"present": "store",
			"past": "stored"
		}, {
			"present": "strap",
			"past": "strapped"
		}, {
			"present": "strengthen",
			"past": "strengthened"
		}, {
			"present": "stretch",
			"past": "stretched"
		}, {
			"present": "strip",
			"past": "stripped"
		}, {
			"present": "stroke",
			"past": "stroked"
		}, {
			"present": "stuff",
			"past": "stuffed"
		}, {
			"present": "subtract",
			"past": "subtracted"
		}, {
			"present": "succeed",
			"past": "succeeded"
		}, {
			"present": "suck",
			"past": "sucked"
		}, {
			"present": "suffer",
			"past": "suffered"
		}, {
			"present": "suggest",
			"past": "suggested"
		}, {
			"present": "suit",
			"past": "suited"
		}, {
			"present": "supply",
			"past": "supplied"
		}, {
			"present": "support",
			"past": "supported"
		}, {
			"present": "suppose",
			"past": "supposed"
		}, {
			"present": "surprise",
			"past": "surprised"
		}, {
			"present": "surround",
			"past": "surrounded"
		}, {
			"present": "suspect",
			"past": "suspected"
		}, {
			"present": "suspend",
			"past": "suspended"
		}, {
			"present": "switch",
			"past": "switched"
		}, {
			"present": "talk",
			"past": "talked"
		}, {
			"present": "tame",
			"past": "tamed"
		}, {
			"present": "tap",
			"past": "tapped"
		}, {
			"present": "taste",
			"past": "tasted"
		}, {
			"present": "tease",
			"past": "teased"
		}, {
			"present": "telephone",
			"past": "telephoned"
		}, {
			"present": "tempt",
			"past": "tempted"
		}, {
			"present": "terrify",
			"past": "terrified"
		}, {
			"present": "test",
			"past": "tested"
		}, {
			"present": "thank",
			"past": "thanked"
		}, {
			"present": "thaw",
			"past": "thawed"
		}, {
			"present": "tick",
			"past": "ticked"
		}, {
			"present": "tickle",
			"past": "tickled"
		}, {
			"present": "tie",
			"past": "tied"
		}, {
			"present": "time",
			"past": "timed"
		}, {
			"present": "tip",
			"past": "tipped"
		}, {
			"present": "tire",
			"past": "tired"
		}, {
			"present": "touch",
			"past": "touched"
		}, {
			"present": "tour",
			"past": "toured"
		}, {
			"present": "tow",
			"past": "towed"
		}, {
			"present": "trace",
			"past": "traced"
		}, {
			"present": "trade",
			"past": "traded"
		}, {
			"present": "train",
			"past": "trained"
		}, {
			"present": "transport",
			"past": "transported"
		}, {
			"present": "trap",
			"past": "trapped"
		}, {
			"present": "travel",
			"past": "travelled"
		}, {
			"present": "treat",
			"past": "treated"
		}, {
			"present": "tremble",
			"past": "trembled"
		}, {
			"present": "trick",
			"past": "tricked"
		}, {
			"present": "trip",
			"past": "tripped"
		}, {
			"present": "trot",
			"past": "trotted"
		}, {
			"present": "trouble",
			"past": "troubled"
		}, {
			"present": "trust",
			"past": "trusted"
		}, {
			"present": "try",
			"past": "tried"
		}, {
			"present": "tug",
			"past": "tugged"
		}, {
			"present": "tumble",
			"past": "tumbled"
		}, {
			"present": "turn",
			"past": "turned"
		}, {
			"present": "twist",
			"past": "twisted"
		}, {
			"present": "type",
			"past": "typed"
		}, {
			"present": "undress",
			"past": "undressed"
		}, {
			"present": "unfasten",
			"past": "unfastened"
		}, {
			"present": "unite",
			"past": "united"
		}, {
			"present": "unlock",
			"past": "unlocked"
		}, {
			"present": "unpack",
			"past": "unpacked"
		}, {
			"present": "untidy",
			"past": "untidied"
		}, {
			"present": "use",
			"past": "used"
		}, {
			"present": "vanish",
			"past": "vanished"
		}, {
			"present": "visit",
			"past": "visited"
		}, {
			"present": "wail",
			"past": "wailed"
		}, {
			"present": "wait",
			"past": "waited"
		}, {
			"present": "walk",
			"past": "walked"
		}, {
			"present": "wander",
			"past": "wandered"
		}, {
			"present": "want",
			"past": "wanted"
		}, {
			"present": "warm",
			"past": "warmed"
		}, {
			"present": "warn",
			"past": "warned"
		}, {
			"present": "wash",
			"past": "washed"
		}, {
			"present": "waste",
			"past": "wasted"
		}, {
			"present": "watch",
			"past": "watched"
		}, {
			"present": "water",
			"past": "watered"
		}, {
			"present": "wave",
			"past": "waved"
		}, {
			"present": "weigh",
			"past": "weighed"
		}, {
			"present": "welcome",
			"past": "welcomed"
		}, {
			"present": "whine",
			"past": "whined"
		}, {
			"present": "whip",
			"past": "whipped"
		}, {
			"present": "whirl",
			"past": "whirled"
		}, {
			"present": "whisper",
			"past": "whispered"
		}, {
			"present": "whistle",
			"past": "whistled"
		}, {
			"present": "wink",
			"past": "winked"
		}, {
			"present": "wipe",
			"past": "wiped"
		}, {
			"present": "wish",
			"past": "wished"
		}, {
			"present": "wobble",
			"past": "wobbled"
		}, {
			"present": "wonder",
			"past": "wondered"
		}, {
			"present": "work",
			"past": "worked"
		}, {
			"present": "worry",
			"past": "worried"
		}, {
			"present": "wrap",
			"past": "wrapped"
		}, {
			"present": "wreck",
			"past": "wrecked"
		}, {
			"present": "wrestle",
			"past": "wrestled"
		}, {
			"present": "wriggle",
			"past": "wriggled"
		}, {
			"present": "x-ray",
			"past": "x-rayed"
		}, {
			"present": "yawn",
			"past": "yawned"
		}, {
			"present": "yell",
			"past": "yelled"
		}, {
			"present": "zip",
			"past": "zipped"
		}, {
			"present": "zoom",
			"past": "zoomed"
		}]
	};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	  * domready (c) Dustin Diaz 2014 - License MIT
	  */
	!function (name, definition) {
	
	  if (true) module.exports = definition()
	  else if (typeof define == 'function' && typeof define.amd == 'object') define(definition)
	  else this[name] = definition()
	
	}('domready', function () {
	
	  var fns = [], listener
	    , doc = document
	    , hack = doc.documentElement.doScroll
	    , domContentLoaded = 'DOMContentLoaded'
	    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState)
	
	
	  if (!loaded)
	  doc.addEventListener(domContentLoaded, listener = function () {
	    doc.removeEventListener(domContentLoaded, listener)
	    loaded = 1
	    while (listener = fns.shift()) listener()
	  })
	
	  return function (fn) {
	    loaded ? setTimeout(fn, 0) : fns.push(fn)
	  }
	
	});


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!Please JS v0.4.2, Jordan Checkman 2014, Checkman.io, MIT License, Have fun.*/
	!function(e,r,a){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (a), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=a():r[e]=a()}("Please",this,function(){"use strict";function e(){function e(e,r,a){var o=Math.random;return a instanceof l&&(o=a.random),Math.floor(o()*(r-e+1))+e}function r(e,r,a){var o=Math.random;return a instanceof l&&(o=a.random),o()*(r-e)+e}function a(e,r,a){return Math.max(r,Math.min(e,a))}function o(e,r){var a;switch(e){case"hex":for(a=0;a<r.length;a++)r[a]=F.HSV_to_HEX(r[a]);break;case"rgb":for(a=0;a<r.length;a++)r[a]=F.HSV_to_RGB(r[a]);break;case"rgb-string":for(a=0;a<r.length;a++){var o=F.HSV_to_RGB(r[a]);r[a]="rgb("+o.r+","+o.g+","+o.b+")"}break;case"hsv":break;default:console.error("Format not recognized.")}return r}function n(e){var r=F.HSV_to_RGB(e),a=(299*r.r+587*r.g+114*r.b)/1e3;return a>=128?"dark":"light"}function t(e){var r={};for(var a in e)e.hasOwnProperty(a)&&(r[a]=e[a]);return r}function l(e){function r(){o=(o+1)%256,n=(n+a[o])%256;var e=a[o];return a[o]=a[n],a[n]=e,a[(a[o]+a[n])%256]}for(var a=[],o=0,n=0,t=0;256>t;t++)a[t]=t;for(var l=0,F=0;256>l;l++){F=(F+a[l]+e.charCodeAt(l%e.length))%256;var s=a[l];a[l]=a[F],a[F]=s}this.random=function(){for(var e=0,a=0,o=1;8>e;e++)a+=r()*o,o*=256;return a/0x10000000000000000}}var F={},s={aliceblue:"F0F8FF",antiquewhite:"FAEBD7",aqua:"00FFFF",aquamarine:"7FFFD4",azure:"F0FFFF",beige:"F5F5DC",bisque:"FFE4C4",black:"000000",blanchedalmond:"FFEBCD",blue:"0000FF",blueviolet:"8A2BE2",brown:"A52A2A",burlywood:"DEB887",cadetblue:"5F9EA0",chartreuse:"7FFF00",chocolate:"D2691E",coral:"FF7F50",cornflowerblue:"6495ED",cornsilk:"FFF8DC",crimson:"DC143C",cyan:"00FFFF",darkblue:"00008B",darkcyan:"008B8B",darkgoldenrod:"B8860B",darkgray:"A9A9A9",darkgrey:"A9A9A9",darkgreen:"006400",darkkhaki:"BDB76B",darkmagenta:"8B008B",darkolivegreen:"556B2F",darkorange:"FF8C00",darkorchid:"9932CC",darkred:"8B0000",darksalmon:"E9967A",darkseagreen:"8FBC8F",darkslateblue:"483D8B",darkslategray:"2F4F4F",darkslategrey:"2F4F4F",darkturquoise:"00CED1",darkviolet:"9400D3",deeppink:"FF1493",deepskyblue:"00BFFF",dimgray:"696969",dimgrey:"696969",dodgerblue:"1E90FF",firebrick:"B22222",floralwhite:"FFFAF0",forestgreen:"228B22",fuchsia:"FF00FF",gainsboro:"DCDCDC",ghostwhite:"F8F8FF",gold:"FFD700",goldenrod:"DAA520",gray:"808080",grey:"808080",green:"008000",greenyellow:"ADFF2F",honeydew:"F0FFF0",hotpink:"FF69B4",indianred:"CD5C5C",indigo:"4B0082",ivory:"FFFFF0",khaki:"F0E68C",lavender:"E6E6FA",lavenderblush:"FFF0F5",lawngreen:"7CFC00",lemonchiffon:"FFFACD",lightblue:"ADD8E6",lightcoral:"F08080",lightcyan:"E0FFFF",lightgoldenrodyellow:"FAFAD2",lightgray:"D3D3D3",lightgrey:"D3D3D3",lightgreen:"90EE90",lightpink:"FFB6C1",lightsalmon:"FFA07A",lightseagreen:"20B2AA",lightskyblue:"87CEFA",lightslategray:"778899",lightslategrey:"778899",lightsteelblue:"B0C4DE",lightyellow:"FFFFE0",lime:"00FF00",limegreen:"32CD32",linen:"FAF0E6",magenta:"FF00FF",maroon:"800000",mediumaquamarine:"66CDAA",mediumblue:"0000CD",mediumorchid:"BA55D3",mediumpurple:"9370D8",mediumseagreen:"3CB371",mediumslateblue:"7B68EE",mediumspringgreen:"00FA9A",mediumturquoise:"48D1CC",mediumvioletred:"C71585",midnightblue:"191970",mintcream:"F5FFFA",mistyrose:"FFE4E1",moccasin:"FFE4B5",navajowhite:"FFDEAD",navy:"000080",oldlace:"FDF5E6",olive:"808000",olivedrab:"6B8E23",orange:"FFA500",orangered:"FF4500",orchid:"DA70D6",palegoldenrod:"EEE8AA",palegreen:"98FB98",paleturquoise:"AFEEEE",palevioletred:"D87093",papayawhip:"FFEFD5",peachpuff:"FFDAB9",peru:"CD853F",pink:"FFC0CB",plum:"DDA0DD",powderblue:"B0E0E6",purple:"800080",rebeccapurple:"663399",red:"FF0000",rosybrown:"BC8F8F",royalblue:"4169E1",saddlebrown:"8B4513",salmon:"FA8072",sandybrown:"F4A460",seagreen:"2E8B57",seashell:"FFF5EE",sienna:"A0522D",silver:"C0C0C0",skyblue:"87CEEB",slateblue:"6A5ACD",slategray:"708090",slategrey:"708090",snow:"FFFAFA",springgreen:"00FF7F",steelblue:"4682B4",tan:"D2B48C",teal:"008080",thistle:"D8BFD8",tomato:"FF6347",turquoise:"40E0D0",violet:"EE82EE",wheat:"F5DEB3",white:"FFFFFF",whitesmoke:"F5F5F5",yellow:"FFFF00",yellowgreen:"9ACD32"},i=.618033988749895,u={hue:null,saturation:null,value:null,base_color:"",greyscale:!1,grayscale:!1,golden:!0,full_random:!1,colors_returned:1,format:"hex",seed:null},c={scheme_type:"analogous",format:"hex"},h={golden:!1,format:"hex"};return F.NAME_to_HEX=function(e){return e=e.toLowerCase(),e in s?s[e]:(console.error("Color name not recognized."),void 0)},F.NAME_to_RGB=function(e){return F.HEX_to_RGB(F.NAME_to_HEX(e))},F.NAME_to_HSV=function(e){return F.HEX_to_HSV(F.NAME_to_HEX(e))},F.HEX_to_RGB=function(e){var r=/^#?([a-f\d])([a-f\d])([a-f\d])$/i;e=e.replace(r,function(e,r,a,o){return r+r+a+a+o+o});var a=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);return a?{r:parseInt(a[1],16),g:parseInt(a[2],16),b:parseInt(a[3],16)}:null},F.RGB_to_HEX=function(e){return"#"+((1<<24)+(e.r<<16)+(e.g<<8)+e.b).toString(16).slice(1)},F.HSV_to_RGB=function(e){var r,a,o,n,t,l,F,s,i=e.h,u=e.s,c=e.v;if(0===u)return{r:c,g:c,b:c};switch(i/=60,n=Math.floor(i),t=i-n,l=c*(1-u),F=c*(1-u*t),s=c*(1-u*(1-t)),n){case 0:r=c,a=s,o=l;break;case 1:r=F,a=c,o=l;break;case 2:r=l,a=c,o=s;break;case 3:r=l,a=F,o=c;break;case 4:r=s,a=l,o=c;break;case 5:r=c,a=l,o=F}return{r:Math.floor(255*r),g:Math.floor(255*a),b:Math.floor(255*o)}},F.RGB_to_HSV=function(e){var r=e.r/255,a=e.g/255,o=e.b/255,n=0,t=0,l=0,F=Math.min(r,Math.min(a,o)),s=Math.max(r,Math.max(a,o));if(F===s)return l=F,{h:0,s:0,v:l};var i=r===F?a-o:o===F?r-a:o-r,u=r===F?3:o===F?1:5;return n=60*(u-i/(s-F)),t=(s-F)/s,l=s,{h:n,s:t,v:l}},F.HSV_to_HEX=function(e){return F.RGB_to_HEX(F.HSV_to_RGB(e))},F.HEX_to_HSV=function(e){return F.RGB_to_HSV(F.HEX_to_RGB(e))},F.make_scheme=function(e,r){function n(e){return{h:e.h,s:e.s,v:e.v}}var l,F,s,i,u,h=t(c);if(null!==r)for(var d in r)r.hasOwnProperty(d)&&(h[d]=r[d]);var g=[e];switch(h.scheme_type.toLowerCase()){case"monochromatic":case"mono":for(u=1;2>=u;u++)l=n(e),s=l.s+.1*u,s=a(s,0,1),i=l.v+.1*u,i=a(i,0,1),l.s=s,l.v=i,g.push(l);for(u=1;2>=u;u++)l=n(e),s=l.s-.1*u,s=a(s,0,1),i=l.v-.1*u,i=a(i,0,1),l.s=s,l.v=i,g.push(l);break;case"complementary":case"complement":case"comp":l=n(e),l.h=(l.h+180)%360,g.push(l);break;case"split-complementary":case"split-complement":case"split":l=n(e),l.h=(l.h+165)%360,g.push(l),l=n(e),l.h=Math.abs((l.h-165)%360),g.push(l);break;case"double-complementary":case"double-complement":case"double":l=n(e),l.h=(l.h+180)%360,g.push(l),l.h=(l.h+30)%360,F=n(l),g.push(l),l.h=(l.h+180)%360,g.push(F);break;case"analogous":case"ana":for(u=1;5>=u;u++)l=n(e),l.h=(l.h+20*u)%360,g.push(l);break;case"triadic":case"triad":case"tri":for(u=1;3>u;u++)l=n(e),l.h=(l.h+120*u)%360,g.push(l);break;default:console.error("Color scheme not recognized.")}return o(h.format.toLowerCase(),g),g},F.make_color=function(n){var s=[],c=t(u),h=null;if(null!==n)for(var d in n)n.hasOwnProperty(d)&&(c[d]=n[d]);var g=null;"string"==typeof c.seed&&(g=new l(c.seed)),c.base_color.length>0&&(h=c.base_color.match(/^#?([0-9a-f]{3})([0-9a-f]{3})?$/i)?F.HEX_to_HSV(c.base_color):F.NAME_to_HSV(c.base_color));for(var m=0;m<c.colors_returned;m++){var f,E,b,p=e(0,360,g);null!==h?(f=a(e(h.h-5,h.h+5,g),0,360),E=0===h.s?0:r(.4,.85,g),b=r(.4,.85,g),s.push({h:f,s:E,v:b})):(f=c.greyscale===!0||c.grayscale===!0?0:c.golden===!0?(p+p/i)%360:null===c.hue||c.full_random===!0?p:a(c.hue,0,360),E=c.greyscale===!0||c.grayscale===!0?0:c.full_random===!0?r(0,1,g):null===c.saturation?.4:a(c.saturation,0,1),b=c.full_random===!0?r(0,1,g):c.greyscale===!0||c.grayscale===!0?r(.15,.75,g):null===c.value?.75:a(c.value,0,1),s.push({h:f,s:E,v:b}))}return o(c.format.toLowerCase(),s),s},F.make_contrast=function(e,r){var l=t(h);if(null!==r)for(var s in r)r.hasOwnProperty(s)&&(l[s]=r[s]);var u,c,d=n(e);if(l.golden===!0)c=e.h*(1+i)%360;else{var g=F.make_scheme(e,{scheme_type:"complementary",format:"hsv"})[1];c=a(g.h-30,0,360)}var m;return"dark"===d?m=a(e.v-.25,0,1):"light"===d&&(m=a(e.v+.25,0,1)),u=[{h:c,s:e.s,v:m}],o(l.format.toLowerCase(),u),u[0]},F}return e()});

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/* global define */
	
	(function (root, pluralize) {
	  /* istanbul ignore else */
	  if (true) {
	    // Node.
	    module.exports = pluralize();
	  } else if (typeof define === 'function' && define.amd) {
	    // AMD, registers as an anonymous module.
	    define(function () {
	      return pluralize();
	    });
	  } else {
	    // Browser global.
	    root.pluralize = pluralize();
	  }
	})(this, function () {
	  // Rule storage - pluralize and singularize need to be run sequentially,
	  // while other rules can be optimized using an object for instant lookups.
	  var pluralRules = [];
	  var singularRules = [];
	  var uncountables = {};
	  var irregularPlurals = {};
	  var irregularSingles = {};
	
	  /**
	   * Title case a string.
	   *
	   * @param  {string} str
	   * @return {string}
	   */
	  function toTitleCase (str) {
	    return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase();
	  }
	
	  /**
	   * Sanitize a pluralization rule to a usable regular expression.
	   *
	   * @param  {(RegExp|string)} rule
	   * @return {RegExp}
	   */
	  function sanitizeRule (rule) {
	    if (typeof rule === 'string') {
	      return new RegExp('^' + rule + '$', 'i');
	    }
	
	    return rule;
	  }
	
	  /**
	   * Pass in a word token to produce a function that can replicate the case on
	   * another word.
	   *
	   * @param  {string}   word
	   * @param  {string}   token
	   * @return {Function}
	   */
	  function restoreCase (word, token) {
	    // Upper cased words. E.g. "HELLO".
	    if (word === word.toUpperCase()) {
	      return token.toUpperCase();
	    }
	
	    // Title cased words. E.g. "Title".
	    if (word[0] === word[0].toUpperCase()) {
	      return toTitleCase(token);
	    }
	
	    // Lower cased words. E.g. "test".
	    return token.toLowerCase();
	  }
	
	  /**
	   * Interpolate a regexp string.
	   *
	   * @param  {string} str
	   * @param  {Array}  args
	   * @return {string}
	   */
	  function interpolate (str, args) {
	    return str.replace(/\$(\d{1,2})/g, function (match, index) {
	      return args[index] || '';
	    });
	  }
	
	  /**
	   * Sanitize a word by passing in the word and sanitization rules.
	   *
	   * @param  {String}   token
	   * @param  {String}   word
	   * @param  {Array}    collection
	   * @return {String}
	   */
	  function sanitizeWord (token, word, collection) {
	    // Empty string or doesn't need fixing.
	    if (!token.length || uncountables.hasOwnProperty(token)) {
	      return word;
	    }
	
	    var len = collection.length;
	
	    // Iterate over the sanitization rules and use the first one to match.
	    while (len--) {
	      var rule = collection[len];
	
	      // If the rule passes, return the replacement.
	      if (rule[0].test(word)) {
	        return word.replace(rule[0], function (match, index, word) {
	          var result = interpolate(rule[1], arguments);
	
	          if (match === '') {
	            return restoreCase(word[index - 1], result);
	          }
	
	          return restoreCase(match, result);
	        });
	      }
	    }
	
	    return word;
	  }
	
	  /**
	   * Replace a word with the updated word.
	   *
	   * @param  {Object}   replaceMap
	   * @param  {Object}   keepMap
	   * @param  {Array}    rules
	   * @return {Function}
	   */
	  function replaceWord (replaceMap, keepMap, rules) {
	    return function (word) {
	      // Get the correct token and case restoration functions.
	      var token = word.toLowerCase();
	
	      // Check against the keep object map.
	      if (keepMap.hasOwnProperty(token)) {
	        return restoreCase(word, token);
	      }
	
	      // Check against the replacement map for a direct word replacement.
	      if (replaceMap.hasOwnProperty(token)) {
	        return restoreCase(word, replaceMap[token]);
	      }
	
	      // Run all the rules against the word.
	      return sanitizeWord(token, word, rules);
	    };
	  }
	
	  /**
	   * Pluralize or singularize a word based on the passed in count.
	   *
	   * @param  {String}  word
	   * @param  {Number}  count
	   * @param  {Boolean} inclusive
	   * @return {String}
	   */
	  function pluralize (word, count, inclusive) {
	    var pluralized = count === 1
	      ? pluralize.singular(word) : pluralize.plural(word);
	
	    return (inclusive ? count + ' ' : '') + pluralized;
	  }
	
	  /**
	   * Pluralize a word.
	   *
	   * @type {Function}
	   */
	  pluralize.plural = replaceWord(
	    irregularSingles, irregularPlurals, pluralRules
	  );
	
	  /**
	   * Singularize a word.
	   *
	   * @type {Function}
	   */
	  pluralize.singular = replaceWord(
	    irregularPlurals, irregularSingles, singularRules
	  );
	
	  /**
	   * Add a pluralization rule to the collection.
	   *
	   * @param {(string|RegExp)} rule
	   * @param {string}          replacement
	   */
	  pluralize.addPluralRule = function (rule, replacement) {
	    pluralRules.push([sanitizeRule(rule), replacement]);
	  };
	
	  /**
	   * Add a singularization rule to the collection.
	   *
	   * @param {(string|RegExp)} rule
	   * @param {string}          replacement
	   */
	  pluralize.addSingularRule = function (rule, replacement) {
	    singularRules.push([sanitizeRule(rule), replacement]);
	  };
	
	  /**
	   * Add an uncountable word rule.
	   *
	   * @param {(string|RegExp)} word
	   */
	  pluralize.addUncountableRule = function (word) {
	    if (typeof word === 'string') {
	      uncountables[word.toLowerCase()] = true;
	      return;
	    }
	
	    // Set singular and plural references for the word.
	    pluralize.addPluralRule(word, '$0');
	    pluralize.addSingularRule(word, '$0');
	  };
	
	  /**
	   * Add an irregular word definition.
	   *
	   * @param {String} single
	   * @param {String} plural
	   */
	  pluralize.addIrregularRule = function (single, plural) {
	    plural = plural.toLowerCase();
	    single = single.toLowerCase();
	
	    irregularSingles[single] = plural;
	    irregularPlurals[plural] = single;
	  };
	
	  /**
	   * Irregular rules.
	   */
	  [
	    // Pronouns.
	    ['I', 'we'],
	    ['me', 'us'],
	    ['he', 'they'],
	    ['she', 'they'],
	    ['them', 'them'],
	    ['myself', 'ourselves'],
	    ['yourself', 'yourselves'],
	    ['itself', 'themselves'],
	    ['herself', 'themselves'],
	    ['himself', 'themselves'],
	    ['themself', 'themselves'],
	    ['is', 'are'],
	    ['this', 'these'],
	    ['that', 'those'],
	    // Words ending in with a consonant and `o`.
	    ['echo', 'echoes'],
	    ['dingo', 'dingoes'],
	    ['volcano', 'volcanoes'],
	    ['tornado', 'tornadoes'],
	    ['torpedo', 'torpedoes'],
	    // Ends with `us`.
	    ['genus', 'genera'],
	    ['viscus', 'viscera'],
	    // Ends with `ma`.
	    ['stigma', 'stigmata'],
	    ['stoma', 'stomata'],
	    ['dogma', 'dogmata'],
	    ['lemma', 'lemmata'],
	    ['schema', 'schemata'],
	    ['anathema', 'anathemata'],
	    // Other irregular rules.
	    ['ox', 'oxen'],
	    ['axe', 'axes'],
	    ['die', 'dice'],
	    ['yes', 'yeses'],
	    ['foot', 'feet'],
	    ['eave', 'eaves'],
	    ['goose', 'geese'],
	    ['tooth', 'teeth'],
	    ['quiz', 'quizzes'],
	    ['human', 'humans'],
	    ['proof', 'proofs'],
	    ['carve', 'carves'],
	    ['valve', 'valves'],
	    ['thief', 'thieves'],
	    ['genie', 'genies'],
	    ['groove', 'grooves'],
	    ['pickaxe', 'pickaxes'],
	    ['whiskey', 'whiskies']
	  ].forEach(function (rule) {
	    return pluralize.addIrregularRule(rule[0], rule[1]);
	  });
	
	  /**
	   * Pluralization rules.
	   */
	  [
	    [/s?$/i, 's'],
	    [/([^aeiou]ese)$/i, '$1'],
	    [/(ax|test)is$/i, '$1es'],
	    [/(alias|[^aou]us|tlas|gas|ris)$/i, '$1es'],
	    [/(e[mn]u)s?$/i, '$1s'],
	    [/([^l]ias|[aeiou]las|[emjzr]as|[iu]am)$/i, '$1'],
	    [/(alumn|syllab|octop|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1i'],
	    [/(alumn|alg|vertebr)(?:a|ae)$/i, '$1ae'],
	    [/(seraph|cherub)(?:im)?$/i, '$1im'],
	    [/(her|at|gr)o$/i, '$1oes'],
	    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, '$1a'],
	    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, '$1a'],
	    [/sis$/i, 'ses'],
	    [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, '$1$2ves'],
	    [/([^aeiouy]|qu)y$/i, '$1ies'],
	    [/([^ch][ieo][ln])ey$/i, '$1ies'],
	    [/(x|ch|ss|sh|zz)$/i, '$1es'],
	    [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, '$1ices'],
	    [/(m|l)(?:ice|ouse)$/i, '$1ice'],
	    [/(pe)(?:rson|ople)$/i, '$1ople'],
	    [/(child)(?:ren)?$/i, '$1ren'],
	    [/eaux$/i, '$0'],
	    [/m[ae]n$/i, 'men'],
	    ['thou', 'you']
	  ].forEach(function (rule) {
	    return pluralize.addPluralRule(rule[0], rule[1]);
	  });
	
	  /**
	   * Singularization rules.
	   */
	  [
	    [/s$/i, ''],
	    [/(ss)$/i, '$1'],
	    [/((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)(?:sis|ses)$/i, '$1sis'],
	    [/(^analy)(?:sis|ses)$/i, '$1sis'],
	    [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, '$1fe'],
	    [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, '$1f'],
	    [/([^aeiouy]|qu)ies$/i, '$1y'],
	    [/(^[pl]|zomb|^(?:neck)?t|[aeo][lt]|cut)ies$/i, '$1ie'],
	    [/(\b(?:mon|smil))ies$/i, '$1ey'],
	    [/(m|l)ice$/i, '$1ouse'],
	    [/(seraph|cherub)im$/i, '$1'],
	    [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|tlas|gas|(?:her|at|gr)o|ris)(?:es)?$/i, '$1'],
	    [/(e[mn]u)s?$/i, '$1'],
	    [/(movie|twelve)s$/i, '$1'],
	    [/(cris|test|diagnos)(?:is|es)$/i, '$1is'],
	    [/(alumn|syllab|octop|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1us'],
	    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, '$1um'],
	    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, '$1on'],
	    [/(alumn|alg|vertebr)ae$/i, '$1a'],
	    [/(cod|mur|sil|vert|ind)ices$/i, '$1ex'],
	    [/(matr|append)ices$/i, '$1ix'],
	    [/(pe)(rson|ople)$/i, '$1rson'],
	    [/(child)ren$/i, '$1'],
	    [/(eau)x?$/i, '$1'],
	    [/men$/i, 'man']
	  ].forEach(function (rule) {
	    return pluralize.addSingularRule(rule[0], rule[1]);
	  });
	
	  /**
	   * Uncountable rules.
	   */
	  [
	    // Singular words with no plurals.
	    'advice',
	    'agenda',
	    'bison',
	    'bream',
	    'buffalo',
	    'carp',
	    'chassis',
	    'cod',
	    'cooperation',
	    'corps',
	    'digestion',
	    'debris',
	    'diabetes',
	    'energy',
	    'equipment',
	    'elk',
	    'excretion',
	    'expertise',
	    'flounder',
	    'gallows',
	    'garbage',
	    'graffiti',
	    'headquarters',
	    'health',
	    'herpes',
	    'highjinks',
	    'homework',
	    'information',
	    'jeans',
	    'justice',
	    'kudos',
	    'labour',
	    'machinery',
	    'mackerel',
	    'media',
	    'mews',
	    'moose',
	    'news',
	    'pike',
	    'plankton',
	    'pliers',
	    'pollution',
	    'premises',
	    'rain',
	    'rice',
	    'salmon',
	    'scissors',
	    'series',
	    'sewage',
	    'shambles',
	    'shrimp',
	    'species',
	    'staff',
	    'swine',
	    'trout',
	    'tuna',
	    'whiting',
	    'wildebeest',
	    'wildlife',
	    'you',
	    // Regexes.
	    /pox$/i, // "chickpox", "smallpox"
	    /ois$/i,
	    /deer$/i, // "deer", "reindeer"
	    /fish$/i, // "fish", "blowfish", "angelfish"
	    /sheep$/i,
	    /measles$/i,
	    /[^aeiou]ese$/i // "chinese", "japanese"
	  ].forEach(pluralize.addUncountableRule);
	
	  return pluralize;
	});


/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** bundle.js
 **/